export const uoms = [
  {
    key: 'C81',
    label: 'radian',
    Description: '',
  },
  {
    key: 'C25',
    label: 'milliradian',
    Description: '',
  },
  {
    key: 'B97',
    label: 'microradian',
    Description: '',
  },
  {
    key: 'DD',
    label: 'degree [unit of angle]',
    Description: '',
  },
  {
    key: 'D61',
    label: 'minute [unit of angle]',
    Description: '',
  },
  {
    key: 'D62',
    label: 'second [unit of angle]',
    Description: '',
  },
  {
    key: 'A91',
    label: 'grade',
    Description: '',
  },
  {
    key: 'M43',
    label: 'mil',
    Description:
      'Unit to indicate an angle at military zone, equal to the 6400th part of the full circle of the 360° or 2·p·rad.',
  },
  {
    key: 'M44',
    label: 'revolution',
    Description:
      'Unit to identify an angle of the full circle of 360° or 2·p·rad (Refer ISO/TC12 SI Guide).',
  },
  {
    key: 'D27',
    label: 'steradian',
    Description: '',
  },
  {
    key: 'H57',
    label: 'inch per two pi radiant',
    Description: '',
  },
  {
    key: 'MTR',
    label: 'metre',
    Description: '',
  },
  {
    key: 'E96',
    label: 'degree per second',
    Description: '',
  },
  {
    key: 'H27',
    label: 'degree per metre',
    Description: '',
  },
  {
    key: 'M55',
    label: 'metre per radiant',
    Description:
      'Unit of the translation factor for implementation from rotation to linear movement.',
  },
  {
    key: 'DMT',
    label: 'decimetre',
    Description: '',
  },
  {
    key: 'CMT',
    label: 'centimetre',
    Description: '',
  },
  {
    key: '4H',
    label: 'micrometre (micron)',
    Description: '',
  },
  {
    key: 'MMT',
    label: 'millimetre',
    Description: '',
  },
  {
    key: 'HMT',
    label: 'hectometre',
    Description: '',
  },
  {
    key: 'KTM',
    label: 'kilometre',
    Description: '',
  },
  {
    key: 'KMT',
    label: 'kilometre',
    Description: '',
  },
  {
    key: 'C45',
    label: 'nanometre',
    Description: '',
  },
  {
    key: 'C52',
    label: 'picometre',
    Description: '',
  },
  {
    key: 'A71',
    label: 'femtometre',
    Description: '',
  },
  {
    key: 'A45',
    label: 'decametre',
    Description: '',
  },
  {
    key: 'NMI',
    label: 'nautical mile',
    Description: '',
  },
  {
    key: 'A11',
    label: 'angstrom',
    Description: '',
  },
  {
    key: 'A12',
    label: 'astronomical unit',
    Description: '',
  },
  {
    key: 'C63',
    label: 'parsec',
    Description: '',
  },
  {
    key: 'F52',
    label: 'metre per kelvin',
    Description: '',
  },
  {
    key: 'F50',
    label: 'micrometre per kelvin',
    Description: '',
  },
  {
    key: 'F51',
    label: 'centimetre per kelvin',
    Description: '',
  },
  {
    key: 'G06',
    label: 'millimetre per bar',
    Description: '',
  },
  {
    key: 'H84',
    label: 'gram millimetre',
    Description: '',
  },
  {
    key: 'G04',
    label: 'centimetre per bar',
    Description: '',
  },
  {
    key: 'G05',
    label: 'metre per bar',
    Description: '',
  },
  {
    key: 'H79',
    label: 'French gauge',
    Description:
      'A unit of distance used for measuring the diameter of small tubes such as urological instruments and catheters.',
  },
  {
    key: 'AK',
    label: 'fathom',
    Description: '',
  },
  {
    key: 'X1',
    label: "Gunter's chain",
    Description:
      'A unit of distance used or formerly used by British surveyors.',
  },
  {
    key: 'INH',
    label: 'inch',
    Description: '',
  },
  {
    key: 'M7',
    label: 'micro-inch',
    Description: '',
  },
  {
    key: 'FOT',
    label: 'foot',
    Description: '',
  },
  {
    key: 'YRD',
    label: 'yard',
    Description: '',
  },
  {
    key: 'SMI',
    label: 'mile (statute mile)',
    Description: '',
  },
  {
    key: '77',
    label: 'milli-inch',
    Description: '',
  },
  {
    key: 'B57',
    label: 'light year',
    Description:
      'A unit of length defining the distance that light travels in a vacuum in one year.',
  },
  {
    key: 'F49',
    label: 'rod [unit of distance]',
    Description: 'A unit of distance equal to 5.5 yards (16 feet 6 inches).',
  },
  {
    key: 'MAM',
    label: 'megametre',
    Description: '',
  },
  {
    key: 'K13',
    label: 'foot per degree Fahrenheit',
    Description: '',
  },
  {
    key: 'K17',
    label: 'foot per psi',
    Description: '',
  },
  {
    key: 'K45',
    label: 'inch per degree Fahrenheit',
    Description: '',
  },
  {
    key: 'K46',
    label: 'inch per psi',
    Description: '',
  },
  {
    key: 'L98',
    label: 'yard per degree Fahrenheit',
    Description: '',
  },
  {
    key: 'L99',
    label: 'yard per psi',
    Description: '',
  },
  {
    key: 'M49',
    label: 'chain (based on U.S. survey foot)',
    Description:
      'Unit of the length according the Anglo-American system of units.',
  },
  {
    key: 'M50',
    label: 'furlong',
    Description:
      'Unit commonly used in Great Britain at rural distances: 1 furlong = 40 rods = 10 chains (UK) = 1/8 mile = 1/10 furlong = 220 yards = 660 foot.',
  },
  {
    key: 'M51',
    label: 'foot (U.S. survey) ',
    Description: 'Unit commonly used in the United States for ordnance survey.',
  },
  {
    key: 'M52',
    label: 'mile (based on U.S. survey foot) ',
    Description: 'Unit commonly used in the United States for ordnance survey.',
  },
  {
    key: 'M53',
    label: 'metre per pascal',
    Description: 'SI base unit metre divided by the derived SI unit pascal.',
  },
  {
    key: 'MTK',
    label: 'square metre',
    Description: '',
  },
  {
    key: 'KMK',
    label: 'square kilometre',
    Description: '',
  },
  {
    key: 'H30',
    label: 'square micrometre (square micron)',
    Description: '',
  },
  {
    key: 'H59',
    label: 'square metre per newton',
    Description: '',
  },
  {
    key: 'DAA',
    label: 'decare',
    Description: '',
  },
  {
    key: 'CMK',
    label: 'square centimetre',
    Description: '',
  },
  {
    key: 'DMK',
    label: 'square decimetre',
    Description: '',
  },
  {
    key: 'H16',
    label: 'square decametre',
    Description: 'Synonym: are',
  },
  {
    key: 'H18',
    label: 'square hectometre',
    Description: 'Synonym: hectare',
  },
  {
    key: 'MMK',
    label: 'square millimetre',
    Description: '',
  },
  {
    key: 'ARE',
    label: 'are',
    Description: 'Synonym: square decametre',
  },
  {
    key: 'HAR',
    label: 'hectare',
    Description: 'Synonym: square hectometre',
  },
  {
    key: 'INK',
    label: 'square inch',
    Description: '',
  },
  {
    key: 'FTK',
    label: 'square foot',
    Description: '',
  },
  {
    key: 'YDK',
    label: 'square yard',
    Description: '',
  },
  {
    key: 'MIK',
    label: 'square mile (statute mile)',
    Description: '',
  },
  {
    key: 'M48',
    label: 'square mile (based on U.S. survey foot) ',
    Description:
      'Unit of the area, which is mainly common in the agriculture and forestry.',
  },
  {
    key: 'ACR',
    label: 'acre',
    Description: '',
  },
  {
    key: 'M47',
    label: 'circular mil ',
    Description:
      'Unit of an area, of which the size is given by a diameter of length of 1 mm (0,001 in) based on the formula: area = p·(diameter/2)².',
  },
  {
    key: 'MTQ',
    label: 'cubic metre',
    Description: 'Synonym: metre cubed',
  },
  {
    key: 'MAL',
    label: 'megalitre',
    Description: '',
  },
  {
    key: 'LTR',
    label: 'litre',
    Description: '',
  },
  {
    key: 'MMQ',
    label: 'cubic millimetre',
    Description: '',
  },
  {
    key: 'CMQ',
    label: 'cubic centimetre',
    Description: '',
  },
  {
    key: 'DMQ',
    label: 'cubic decimetre',
    Description: '',
  },
  {
    key: 'MLT',
    label: 'millilitre',
    Description: '',
  },
  {
    key: 'HLT',
    label: 'hectolitre',
    Description: '',
  },
  {
    key: 'CLT',
    label: 'centilitre',
    Description: '',
  },
  {
    key: 'DMA',
    label: 'cubic decametre',
    Description: '',
  },
  {
    key: 'H19',
    label: 'cubic hectometre',
    Description: '',
  },
  {
    key: 'H20',
    label: 'cubic kilometre',
    Description: '',
  },
  {
    key: 'M71',
    label: 'cubic metre per pascal',
    Description:
      'Power of the SI base unit meter by exponent 3 divided by the derived SI base unit pascal.',
  },
  {
    key: 'DLT',
    label: 'decilitre',
    Description: '',
  },
  {
    key: '4G',
    label: 'microlitre',
    Description: '',
  },
  {
    key: 'K6',
    label: 'kilolitre',
    Description: '',
  },
  {
    key: 'A44',
    label: 'decalitre',
    Description: '',
  },
  {
    key: 'G94',
    label: 'cubic centimetre per bar',
    Description: '',
  },
  {
    key: 'G95',
    label: 'litre per bar',
    Description: '',
  },
  {
    key: 'G96',
    label: 'cubic metre per bar',
    Description: '',
  },
  {
    key: 'G97',
    label: 'millilitre per bar',
    Description: '',
  },
  {
    key: '5I',
    label: 'standard cubic foot',
    Description: 'Use standard (common code WSD)',
  },
  {
    key: 'INQ',
    label: 'cubic inch',
    Description: 'Synonym: inch cubed',
  },
  {
    key: 'FTQ',
    label: 'cubic foot',
    Description: '',
  },
  {
    key: 'YDQ',
    label: 'cubic yard',
    Description: '',
  },
  {
    key: 'GLI',
    label: 'gallon (UK)',
    Description: '',
  },
  {
    key: 'GLL',
    label: 'gallon (US)',
    Description: '',
  },
  {
    key: 'PT',
    label: 'pint (US)',
    Description: 'Use liquid pint (common code PTL)',
  },
  {
    key: 'PTI',
    label: 'pint (UK)',
    Description: '',
  },
  {
    key: 'QTI',
    label: 'quart (UK)',
    Description: '',
  },
  {
    key: 'PTL',
    label: 'liquid pint (US)',
    Description: '',
  },
  {
    key: 'QTL',
    label: 'liquid quart (US)',
    Description: '',
  },
  {
    key: 'PTD',
    label: 'dry pint (US)',
    Description: '',
  },
  {
    key: 'OZI',
    label: 'fluid ounce (UK)',
    Description: '',
  },
  {
    key: 'QT',
    label: 'quart (US)',
    Description: 'Use liquid quart (common code QTL)',
  },
  {
    key: 'J57',
    label: 'barrel (UK petroleum)',
    Description: '',
  },
  {
    key: 'K21',
    label: 'cubic foot per degree Fahrenheit',
    Description: '',
  },
  {
    key: 'K23',
    label: 'cubic foot per psi',
    Description: '',
  },
  {
    key: 'L43',
    label: 'peck (UK)',
    Description: '',
  },
  {
    key: 'L61',
    label: 'pint (US dry)',
    Description: 'Use dry pint (common code PTD)',
  },
  {
    key: 'L62',
    label: 'quart (US dry)',
    Description: 'Use dry quart (US) (common code QTD)',
  },
  {
    key: 'L84',
    label: 'ton (UK shipping)',
    Description: '',
  },
  {
    key: 'L86',
    label: 'ton (US shipping)',
    Description: '',
  },
  {
    key: 'M11',
    label: 'cubic yard per degree Fahrenheit',
    Description: '',
  },
  {
    key: 'M14',
    label: 'cubic yard per psi',
    Description: '',
  },
  {
    key: 'OZA',
    label: 'fluid ounce (US)',
    Description: '',
  },
  {
    key: 'BUI',
    label: 'bushel (UK)',
    Description: '',
  },
  {
    key: 'BUA',
    label: 'bushel (US)',
    Description: '',
  },
  {
    key: 'BLL',
    label: 'barrel (US)',
    Description: '',
  },
  {
    key: 'BLD',
    label: 'dry barrel (US)',
    Description: '',
  },
  {
    key: 'GLD',
    label: 'dry gallon (US)',
    Description: '',
  },
  {
    key: 'QTD',
    label: 'dry quart (US)',
    Description: '',
  },
  {
    key: 'G26',
    label: 'stere',
    Description: '',
  },
  {
    key: 'G21',
    label: 'cup [unit of volume]',
    Description: '',
  },
  {
    key: 'G24',
    label: 'tablespoon (US)',
    Description: '',
  },
  {
    key: 'G25',
    label: 'teaspoon (US)',
    Description: '',
  },
  {
    key: 'G23',
    label: 'peck',
    Description: '',
  },
  {
    key: 'M67',
    label: 'acre-foot (based on U.S. survey foot)',
    Description:
      'Unit of the volume, which is used in the United States to measure/gauge the capacity of reservoirs.',
  },
  {
    key: 'M68',
    label: 'cord (128 ft3)',
    Description:
      'Traditional unit of the volume of stacked firewood which has been measured with a cord.',
  },
  {
    key: 'M69',
    label: 'cubic mile (UK statute)',
    Description: 'Unit of volume according to the Imperial system of units.',
  },
  {
    key: 'M70',
    label: 'ton, register ',
    Description: 'Traditional unit of the cargo capacity.',
  },
  {
    key: 'G27',
    label: 'cubic centimetre per kelvin',
    Description: '',
  },
  {
    key: 'G29',
    label: 'cubic metre per kelvin',
    Description: '',
  },
  {
    key: 'G28',
    label: 'litre per kelvin',
    Description: '',
  },
  {
    key: 'G30',
    label: 'millilitre per kelvin',
    Description: '',
  },
  {
    key: 'J36',
    label: 'microlitre per litre',
    Description: '',
  },
  {
    key: 'J87',
    label: 'cubic centimetre per cubic metre',
    Description: '',
  },
  {
    key: 'J91',
    label: 'cubic decimetre per cubic metre',
    Description: '',
  },
  {
    key: 'K62',
    label: 'litre per litre',
    Description: '',
  },
  {
    key: 'L19',
    label: 'millilitre per litre',
    Description: '',
  },
  {
    key: 'L21',
    label: 'cubic millimetre per cubic metre',
    Description: '',
  },
  {
    key: 'SEC',
    label: 'second [unit of time]',
    Description: '',
  },
  {
    key: 'MIN',
    label: 'minute [unit of time]',
    Description: '',
  },
  {
    key: 'HUR',
    label: 'hour',
    Description: '',
  },
  {
    key: 'DAY',
    label: 'day',
    Description: '',
  },
  {
    key: 'B52',
    label: 'kilosecond',
    Description: '',
  },
  {
    key: 'C26',
    label: 'millisecond',
    Description: '',
  },
  {
    key: 'H70',
    label: 'picosecond',
    Description: '',
  },
  {
    key: 'B98',
    label: 'microsecond',
    Description: '',
  },
  {
    key: 'C47',
    label: 'nanosecond',
    Description: '',
  },
  {
    key: 'WEE',
    label: 'week',
    Description: '',
  },
  {
    key: 'MON',
    label: 'month',
    Description: 'Unit of time equal to 1/12 of a year of 365,25 days.',
  },
  {
    key: 'ANN',
    label: 'year',
    Description: 'Unit of time equal to 365,25 days.',
  },
  {
    key: 'D42',
    label: 'tropical year',
    Description: 'Unit of time equal to about 365.242 19 days.',
  },
  {
    key: 'L95',
    label: 'common year',
    Description: '',
  },
  {
    key: 'L96',
    label: 'sidereal year',
    Description: '',
  },
  {
    key: 'M56',
    label: 'shake',
    Description: 'Unit for a very short period.',
  },
  {
    key: '2A',
    label: 'radian per second',
    Description: 'Refer ISO/TC12 SI Guide',
  },
  {
    key: 'M46',
    label: 'revolution per minute ',
    Description: 'Unit of the angular velocity.',
  },
  {
    key: '2B',
    label: 'radian per second squared',
    Description: 'Refer ISO/TC12 SI Guide',
  },
  {
    key: 'M45',
    label: 'degree [unit of angle] per second squared',
    Description:
      '360 part of a full circle divided by the power of the SI base unit second and the exponent 2.',
  },
  {
    key: 'MTS',
    label: 'metre per second',
    Description: '',
  },
  {
    key: 'KNT',
    label: 'knot',
    Description: '',
  },
  {
    key: 'KMH',
    label: 'kilometre per hour',
    Description: '',
  },
  {
    key: 'C16',
    label: 'millimetre per second',
    Description: '',
  },
  {
    key: '2M',
    label: 'centimetre per second',
    Description: '',
  },
  {
    key: 'H49',
    label: 'centimetre per hour',
    Description: '',
  },
  {
    key: 'H81',
    label: 'millimetre per minute',
    Description: '',
  },
  {
    key: '2X',
    label: 'metre per minute',
    Description: '',
  },
  {
    key: 'M59',
    label: 'metre per second pascal',
    Description:
      'SI base unit meter divided by the product of SI base unit second and the derived SI unit pascal.',
  },
  {
    key: 'H66',
    label: 'millimetre per year',
    Description: '',
  },
  {
    key: 'H67',
    label: 'millimetre per hour',
    Description: '',
  },
  {
    key: 'FR',
    label: 'foot per minute',
    Description: '',
  },
  {
    key: 'IU',
    label: 'inch per second',
    Description: '',
  },
  {
    key: 'FS',
    label: 'foot per second',
    Description: '',
  },
  {
    key: 'HM',
    label: 'mile per hour (statute mile)',
    Description: '',
  },
  {
    key: 'J84',
    label: 'centimetre per second kelvin',
    Description: '',
  },
  {
    key: 'J85',
    label: 'centimetre per second bar',
    Description: '',
  },
  {
    key: 'K14',
    label: 'foot per hour',
    Description: '',
  },
  {
    key: 'K18',
    label: 'foot per second degree Fahrenheit',
    Description: '',
  },
  {
    key: 'K19',
    label: 'foot per second psi',
    Description: '',
  },
  {
    key: 'K47',
    label: 'inch per second degree Fahrenheit',
    Description: '',
  },
  {
    key: 'K48',
    label: 'inch per second psi',
    Description: '',
  },
  {
    key: 'L12',
    label: 'metre per second kelvin',
    Description: '',
  },
  {
    key: 'L13',
    label: 'metre per second bar',
    Description: '',
  },
  {
    key: 'M22',
    label: 'millilitre per square centimetre minute',
    Description: '',
  },
  {
    key: 'M57',
    label: 'mile per minute ',
    Description: 'Unit of velocity from the Imperial system of units.',
  },
  {
    key: 'M58',
    label: 'mile per second ',
    Description: 'Unit of the velocity from the Imperial system of units.',
  },
  {
    key: 'M60',
    label: 'metre per hour',
    Description: 'SI base unit metre divided by the unit hour.',
  },
  {
    key: 'M61',
    label: 'inch per year',
    Description:
      'Unit of the length according to the Anglo-American and Imperial system of units divided by the unit common year with 365 days.',
  },
  {
    key: 'M62',
    label: 'kilometre per second ',
    Description:
      '1000-fold of the SI base unit metre divided by the SI base unit second.',
  },
  {
    key: 'M63',
    label: 'inch per minute',
    Description:
      'Unit inch according to the Anglo-American and Imperial system of units divided by the unit minute.',
  },
  {
    key: 'M64',
    label: 'yard per second',
    Description:
      'Unit yard according to the Anglo-American and Imperial system of units divided by the SI base unit second.',
  },
  {
    key: 'M65',
    label: 'yard per minute',
    Description:
      'Unit yard according to the Anglo-American and Imperial system of units divided by the unit minute.',
  },
  {
    key: 'M66',
    label: 'yard per hour',
    Description:
      'Unit yard according to the Anglo-American and Imperial system of units divided by the unit hour.',
  },
  {
    key: 'MSK',
    label: 'metre per second squared',
    Description: '',
  },
  {
    key: 'A76',
    label: 'gal',
    Description: '',
  },
  {
    key: 'C11',
    label: 'milligal',
    Description: '',
  },
  {
    key: 'M38',
    label: 'kilometre per second squared',
    Description:
      '1000-fold of the SI base unit metre divided by the power of the SI base unit second by exponent 2.',
  },
  {
    key: 'M39',
    label: 'centimetre per second squared',
    Description:
      '0,01-fold of the SI base unit metre divided by the power of the SI base unit second by exponent 2.',
  },
  {
    key: 'M41',
    label: 'millimetre per second squared',
    Description:
      '0,001-fold of the SI base unit metre divided by the power of the SI base unit second by exponent 2.',
  },
  {
    key: 'A73',
    label: 'foot per second squared',
    Description: '',
  },
  {
    key: 'IV',
    label: 'inch per second squared',
    Description: '',
  },
  {
    key: 'K40',
    label: 'standard acceleration of free fall',
    Description: '',
  },
  {
    key: 'M40',
    label: 'yard per second squared',
    Description:
      'Unit of the length according to the Anglo-American and Imperial system of units divided by the power of the SI base unit second by exponent 2.',
  },
  {
    key: 'M42',
    label: 'mile (statute mile) per second squared',
    Description:
      'Unit of the length according to the Imperial system of units divided by the power of the SI base unit second by exponent 2.',
  },
  {
    key: 'C92',
    label: 'reciprocal metre',
    Description: '',
  },
  {
    key: 'Q32',
    label: 'femtolitre',
    Description: '',
  },
  {
    key: 'Q33',
    label: 'picolitre',
    Description: '',
  },
  {
    key: 'Q34',
    label: 'nanolitre',
    Description: '',
  },
  {
    key: 'AWG',
    label: 'american wire gauge',
    Description:
      'A unit of distance used for measuring the diameter of small tubes or wires such as the outer diameter od hypodermic or suture needles.',
  },
  {
    key: 'NM3',
    label: 'Normalised cubic metre',
    Description:
      'Normalised cubic metre (temperature 0°C and pressure 101325 millibars )',
  },
  {
    key: 'SM3',
    label: 'Standard cubic metre',
    Description:
      'Standard cubic metre (temperature 15°C and pressure 101325 millibars )',
  },
  {
    key: 'HTZ',
    label: 'hertz',
    Description: '',
  },
  {
    key: 'KHZ',
    label: 'kilohertz',
    Description: '',
  },
  {
    key: 'MHZ',
    label: 'megahertz',
    Description: '',
  },
  {
    key: 'D29',
    label: 'terahertz',
    Description: '',
  },
  {
    key: 'A86',
    label: 'gigahertz',
    Description: '',
  },
  {
    key: 'MTZ',
    label: 'millihertz',
    Description: 'A unit of frequency equal to 0.001 cycle per second',
  },
  {
    key: 'H10',
    label: 'reciprocal hour',
    Description: '',
  },
  {
    key: 'H11',
    label: 'reciprocal month',
    Description: '',
  },
  {
    key: 'H09',
    label: 'reciprocal year',
    Description: '',
  },
  {
    key: 'H85',
    label: 'reciprocal week',
    Description: '',
  },
  {
    key: 'C97',
    label: 'reciprocal second',
    Description: '',
  },
  {
    key: 'RPS',
    label: 'revolutions per second',
    Description: 'Refer ISO/TC12 SI Guide',
  },
  {
    key: 'RPM',
    label: 'revolutions per minute',
    Description: 'Refer ISO/TC12 SI Guide',
  },
  {
    key: 'C94',
    label: 'reciprocal minute',
    Description: '',
  },
  {
    key: 'C50',
    label: 'neper',
    Description: '',
  },
  {
    key: '2N',
    label: 'decibel',
    Description: '',
  },
  {
    key: 'M72',
    label: 'bel',
    Description: 'Logarithmic relationship to base 10.',
  },
  {
    key: 'C51',
    label: 'neper per second',
    Description: '',
  },
  {
    key: 'KGM',
    label: 'kilogram',
    Description: 'A unit of mass equal to one thousand grams.',
  },
  {
    key: 'MC',
    label: 'microgram',
    Description: '',
  },
  {
    key: 'DJ',
    label: 'decagram',
    Description: '',
  },
  {
    key: 'DG',
    label: 'decigram',
    Description: '',
  },
  {
    key: 'GRM',
    label: 'gram',
    Description: '',
  },
  {
    key: 'CGM',
    label: 'centigram',
    Description: '',
  },
  {
    key: 'TNE',
    label: 'tonne (metric ton)',
    Description: 'Synonym: metric ton',
  },
  {
    key: 'DTN',
    label: 'decitonne',
    Description: 'Synonym: centner, metric 100 kg; quintal, metric 100 kg',
  },
  {
    key: 'MGM',
    label: 'milligram',
    Description: '',
  },
  {
    key: 'HGM',
    label: 'hectogram',
    Description: '',
  },
  {
    key: 'KTN',
    label: 'kilotonne',
    Description: '',
  },
  {
    key: '2U',
    label: 'megagram',
    Description: '',
  },
  {
    key: 'LBR',
    label: 'pound',
    Description: '',
  },
  {
    key: 'GRN',
    label: 'grain',
    Description: '',
  },
  {
    key: 'ONZ',
    label: 'ounce (avoirdupois)',
    Description: '',
  },
  {
    key: 'CWI',
    label: 'hundred weight (UK)',
    Description: '',
  },
  {
    key: 'CWA',
    label: 'hundred pound (cwt) / hundred weight (US)',
    Description: '',
  },
  {
    key: 'LTN',
    label: 'ton (UK) or long ton (US)',
    Description: 'Synonym: gross ton (2240 lb)',
  },
  {
    key: 'STI',
    label: 'stone (UK)',
    Description: '',
  },
  {
    key: 'STN',
    label: 'ton (US) or short ton (UK/US)',
    Description: 'Synonym: net ton (2000 lb)',
  },
  {
    key: 'APZ',
    label: 'troy ounce or apothecary ounce',
    Description: '',
  },
  {
    key: 'F13',
    label: 'slug',
    Description:
      'A unit of mass. One slug is the mass accelerated at 1 foot per second per second by a force of 1 pound.',
  },
  {
    key: 'K64',
    label: 'pound (avoirdupois) per degree Fahrenheit',
    Description: '',
  },
  {
    key: 'L69',
    label: 'tonne per kelvin',
    Description: '',
  },
  {
    key: 'L87',
    label: 'ton short per degree Fahrenheit',
    Description: '',
  },
  {
    key: 'M85',
    label: 'ton, assay',
    Description:
      'Non SI-conforming unit of the mass used in the mineralogy to determine the concentration of precious metals in ore according to the mass of the precious metal in milligrams in a sample of the mass of an assay sound (number of troy ounces in a short ton (1 000 lb)).',
  },
  {
    key: 'M86',
    label: 'pfund',
    Description: 'Outdated unit of the mass used in Germany.',
  },
  {
    key: 'KMQ',
    label: 'kilogram per cubic metre',
    Description:
      'A unit of weight expressed in kilograms of a substance that fills a volume of one cubic metre.',
  },
  {
    key: '23',
    label: 'gram per cubic centimetre',
    Description: '',
  },
  {
    key: 'D41',
    label: 'tonne per cubic metre',
    Description: '',
  },
  {
    key: 'GJ',
    label: 'gram per millilitre',
    Description: '',
  },
  {
    key: 'B35',
    label: 'kilogram per litre',
    Description: '',
  },
  {
    key: 'GL',
    label: 'gram per litre',
    Description: '',
  },
  {
    key: 'A93',
    label: 'gram per cubic metre',
    Description: '',
  },
  {
    key: 'GP',
    label: 'milligram per cubic metre',
    Description: '',
  },
  {
    key: 'B72',
    label: 'megagram per cubic metre',
    Description: '',
  },
  {
    key: 'B34',
    label: 'kilogram per cubic decimetre',
    Description: '',
  },
  {
    key: 'H64',
    label: 'milligram per gram',
    Description: '',
  },
  {
    key: 'H29',
    label: 'microgram per litre',
    Description: '',
  },
  {
    key: 'M1',
    label: 'milligram per litre',
    Description: '',
  },
  {
    key: 'GQ',
    label: 'microgram per cubic metre',
    Description: '',
  },
  {
    key: 'G11',
    label: 'gram per cubic centimetre bar',
    Description: '',
  },
  {
    key: 'G33',
    label: 'gram per cubic centimetre kelvin',
    Description: '',
  },
  {
    key: 'F23',
    label: 'gram per cubic decimetre',
    Description: '',
  },
  {
    key: 'G12',
    label: 'gram per cubic decimetre bar',
    Description: '',
  },
  {
    key: 'G34',
    label: 'gram per cubic decimetre kelvin',
    Description: '',
  },
  {
    key: 'G14',
    label: 'gram per cubic metre bar',
    Description: '',
  },
  {
    key: 'G36',
    label: 'gram per cubic metre kelvin',
    Description: '',
  },
  {
    key: 'G13',
    label: 'gram per litre bar',
    Description: '',
  },
  {
    key: 'G35',
    label: 'gram per litre kelvin',
    Description: '',
  },
  {
    key: 'G15',
    label: 'gram per millilitre bar',
    Description: '',
  },
  {
    key: 'G37',
    label: 'gram per millilitre kelvin',
    Description: '',
  },
  {
    key: 'G31',
    label: 'kilogram per cubic centimetre',
    Description: '',
  },
  {
    key: 'G16',
    label: 'kilogram per cubic centimetre bar',
    Description: '',
  },
  {
    key: 'G38',
    label: 'kilogram per cubic centimetre kelvin',
    Description: '',
  },
  {
    key: 'G18',
    label: 'kilogram per cubic metre bar',
    Description: '',
  },
  {
    key: 'G40',
    label: 'kilogram per cubic metre kelvin',
    Description: '',
  },
  {
    key: 'H54',
    label: 'kilogram per cubic decimetre kelvin',
    Description: '',
  },
  {
    key: 'H55',
    label: 'kilogram per cubic decimetre bar',
    Description: '',
  },
  {
    key: 'F14',
    label: 'gram per kelvin',
    Description: '',
  },
  {
    key: 'F15',
    label: 'kilogram per kelvin',
    Description: '',
  },
  {
    key: 'F24',
    label: 'kilogram per kilomole',
    Description: '',
  },
  {
    key: 'G17',
    label: 'kilogram per litre bar',
    Description: '',
  },
  {
    key: 'G39',
    label: 'kilogram per litre kelvin',
    Description: '',
  },
  {
    key: 'H53',
    label: 'kilogram per bar',
    Description: '',
  },
  {
    key: 'F18',
    label: 'kilogram square centimetre',
    Description: '',
  },
  {
    key: 'F19',
    label: 'kilogram square millimetre',
    Description: '',
  },
  {
    key: 'F74',
    label: 'gram per bar',
    Description: '',
  },
  {
    key: 'F75',
    label: 'milligram per bar',
    Description: '',
  },
  {
    key: 'F16',
    label: 'milligram per kelvin',
    Description: '',
  },
  {
    key: 'M73',
    label: 'kilogram per cubic metre pascal',
    Description:
      'SI base unit kilogram divided by the product of the power of the SI base unit metre with exponent 3 and the derived SI unit pascal.',
  },
  {
    key: '87',
    label: 'pound per cubic foot',
    Description: '',
  },
  {
    key: 'GE',
    label: 'pound per gallon (US)',
    Description: '',
  },
  {
    key: 'LA',
    label: 'pound per cubic inch',
    Description: '',
  },
  {
    key: 'G32',
    label: 'ounce (avoirdupois) per cubic yard',
    Description: '',
  },
  {
    key: 'J34',
    label: 'microgram per cubic metre kelvin',
    Description: '',
  },
  {
    key: 'J35',
    label: 'microgram per cubic metre bar',
    Description: '',
  },
  {
    key: 'K41',
    label: 'grain per gallon (US)',
    Description: '',
  },
  {
    key: 'K69',
    label: 'pound (avoirdupois) per cubic foot degree Fahrenheit',
    Description: '',
  },
  {
    key: 'K70',
    label: 'pound (avoirdupois) per cubic foot psi',
    Description: '',
  },
  {
    key: 'K71',
    label: 'pound (avoirdupois) per gallon (UK)',
    Description: '',
  },
  {
    key: 'K75',
    label: 'pound (avoirdupois) per cubic inch degree Fahrenheit',
    Description: '',
  },
  {
    key: 'K76',
    label: 'pound (avoirdupois) per cubic inch psi',
    Description: '',
  },
  {
    key: 'K84',
    label: 'pound per cubic yard',
    Description: '',
  },
  {
    key: 'L17',
    label: 'milligram per cubic metre kelvin',
    Description: '',
  },
  {
    key: 'L18',
    label: 'milligram per cubic metre bar',
    Description: '',
  },
  {
    key: 'L37',
    label: 'ounce (avoirdupois) per gallon (UK)',
    Description: '',
  },
  {
    key: 'L38',
    label: 'ounce (avoirdupois) per gallon (US)',
    Description: '',
  },
  {
    key: 'L39',
    label: 'ounce (avoirdupois) per cubic inch',
    Description: '',
  },
  {
    key: 'L65',
    label: 'slug per cubic foot',
    Description: '',
  },
  {
    key: 'L76',
    label: 'tonne per cubic metre kelvin',
    Description: '',
  },
  {
    key: 'L77',
    label: 'tonne per cubic metre bar',
    Description: '',
  },
  {
    key: 'L92',
    label: 'ton (UK long) per cubic yard',
    Description: '',
  },
  {
    key: 'L93',
    label: 'ton (US short) per cubic yard',
    Description: '',
  },
  {
    key: 'K77',
    label: 'pound (avoirdupois) per psi',
    Description: '',
  },
  {
    key: 'L70',
    label: 'tonne per bar',
    Description: '',
  },
  {
    key: 'L91',
    label: 'ton short per psi',
    Description: '',
  },
  {
    key: 'M74',
    label: 'kilogram per pascal',
    Description: 'SI base unit kilogram divided by the derived SI unit pascal.',
  },
  {
    key: 'C62',
    label: 'one',
    Description: 'Synonym: unit',
  },
  {
    key: 'A39',
    label: 'cubic metre per kilogram',
    Description: '',
  },
  {
    key: '22',
    label: 'decilitre per gram',
    Description: '',
  },
  {
    key: 'H65',
    label: 'millilitre per cubic metre',
    Description: '',
  },
  {
    key: 'H83',
    label: 'litre per kilogram',
    Description: '',
  },
  {
    key: 'KX',
    label: 'millilitre per kilogram',
    Description: '',
  },
  {
    key: 'H15',
    label: 'square centimetre per gram',
    Description: '',
  },
  {
    key: 'N28',
    label: 'cubic decimetre per kilogram',
    Description:
      '0,001 fold of the power of the SI base unit meter by exponent 3 divided by the SI based unit kilogram.',
  },
  {
    key: 'N29',
    label: 'cubic foot per pound',
    Description:
      'Power of the unit foot according to the Anglo-American and Imperial system of units by exponent 3 divided by the unit avoirdupois pound according to the avoirdupois unit system.',
  },
  {
    key: 'N30',
    label: 'cubic inch per pound',
    Description:
      'Power of the unit inch according to the Anglo-American and Imperial system of units by exponent 3 divided by the avoirdupois pound according to the avoirdupois unit system .',
  },
  {
    key: 'KL',
    label: 'kilogram per metre',
    Description: '',
  },
  {
    key: 'GF',
    label: 'gram per metre (gram per 100 centimetres)',
    Description: '',
  },
  {
    key: 'H76',
    label: 'gram per millimetre',
    Description: '',
  },
  {
    key: 'KW',
    label: 'kilogram per millimetre',
    Description: '',
  },
  {
    key: 'C12',
    label: 'milligram per metre',
    Description: '',
  },
  {
    key: 'M31',
    label: 'kilogram per kilometre',
    Description: '',
  },
  {
    key: 'P2',
    label: 'pound per foot',
    Description: '',
  },
  {
    key: 'PO',
    label: 'pound per inch of length',
    Description: '',
  },
  {
    key: 'M83',
    label: 'denier ',
    Description:
      'Traditional unit for the indication of the linear mass of textile fibers and yarns.',
  },
  {
    key: 'M84',
    label: 'pound per yard ',
    Description:
      'Unit for linear mass according to avoirdupois system of units.',
  },
  {
    key: 'GO',
    label: 'milligram per square metre',
    Description: '',
  },
  {
    key: '25',
    label: 'gram per square centimetre',
    Description: '',
  },
  {
    key: 'H63',
    label: 'milligram per square centimetre',
    Description: '',
  },
  {
    key: 'GM',
    label: 'gram per square metre',
    Description: '',
  },
  {
    key: '28',
    label: 'kilogram per square metre',
    Description: '',
  },
  {
    key: 'D5',
    label: 'kilogram per square centimetre',
    Description: '',
  },
  {
    key: 'ON',
    label: 'ounce per square yard',
    Description: '',
  },
  {
    key: '37',
    label: 'ounce per square foot',
    Description: '',
  },
  {
    key: 'B31',
    label: 'kilogram metre per second',
    Description: '',
  },
  {
    key: 'M98',
    label: 'kilogram centimetre per second',
    Description:
      'Product of the SI base unit kilogram and the 0,01-fold of the SI base unit metre divided by the SI base unit second.',
  },
  {
    key: 'M99',
    label: 'gram centimetre per second',
    Description:
      'Product of the 0,001-fold of the SI base unit kilogram and the 0,01-fold of the SI base unit metre divided by the SI base unit second.',
  },
  {
    key: 'N10',
    label: 'pound foot per second',
    Description:
      'Product of the avoirdupois pound according to the avoirdupois unit system and the unit foot according to the Anglo-American and Imperial system of units divided by the SI base unit second.',
  },
  {
    key: 'N11',
    label: 'pound inch per second',
    Description:
      'Product of the avoirdupois pound according to the avoirdupois unit system and the unit inch according to the Anglo-American and Imperial system of units divided by the SI base unit second.',
  },
  {
    key: 'B33',
    label: 'kilogram metre squared per second',
    Description: '',
  },
  {
    key: 'B32',
    label: 'kilogram metre squared',
    Description: '',
  },
  {
    key: 'F20',
    label: 'pound inch squared',
    Description: '',
  },
  {
    key: 'K65',
    label: 'pound (avoirdupois) square foot',
    Description: '',
  },
  {
    key: 'NEW',
    label: 'newton',
    Description: '',
  },
  {
    key: 'B73',
    label: 'meganewton',
    Description: '',
  },
  {
    key: 'B47',
    label: 'kilonewton',
    Description: '',
  },
  {
    key: 'C20',
    label: 'millinewton',
    Description: '',
  },
  {
    key: 'B92',
    label: 'micronewton',
    Description: '',
  },
  {
    key: 'DU',
    label: 'dyne',
    Description: '',
  },
  {
    key: 'C78',
    label: 'pound-force',
    Description: '',
  },
  {
    key: 'B37',
    label: 'kilogram-force',
    Description: '',
  },
  {
    key: 'B51',
    label: 'kilopond',
    Description: 'Synonym: kilogram-force',
  },
  {
    key: 'L40',
    label: 'ounce (avoirdupois)-force',
    Description: '',
  },
  {
    key: 'L94',
    label: 'ton-force (US short)',
    Description: '',
  },
  {
    key: 'M75',
    label: 'kilopound-force',
    Description:
      '1000-fold of the unit of the force pound-force (lbf) according to the Anglo-American system of units with the relationship.',
  },
  {
    key: 'M76',
    label: 'poundal',
    Description:
      'Non SI-conforming unit of the power, which corresponds to a mass of a pound multiplied with the acceleration of a foot per square second.',
  },
  {
    key: 'M77',
    label: 'kilogram metre per second squared',
    Description:
      'Product of the SI base unit kilogram and the SI base unit metre divided by the power of the SI base unit second by exponent 2.',
  },
  {
    key: 'M78',
    label: 'pond',
    Description:
      '0,001-fold of the unit of the weight, defined as a mass of 1 kg which finds out about a weight strength from 1 kp by the gravitational force at sea level which corresponds to a strength of 9,806 65 newton.',
  },
  {
    key: 'F17',
    label: 'pound-force per foot',
    Description: '',
  },
  {
    key: 'F48',
    label: 'pound-force per inch',
    Description: '',
  },
  {
    key: 'C54',
    label: 'newton metre squared per kilogram squared',
    Description: '',
  },
  {
    key: 'NU',
    label: 'newton metre',
    Description: '',
  },
  {
    key: 'H40',
    label: 'newton per ampere',
    Description: '',
  },
  {
    key: 'B74',
    label: 'meganewton metre',
    Description: '',
  },
  {
    key: 'B48',
    label: 'kilonewton metre',
    Description: '',
  },
  {
    key: 'D83',
    label: 'millinewton metre',
    Description: '',
  },
  {
    key: 'B93',
    label: 'micronewton metre',
    Description: '',
  },
  {
    key: 'DN',
    label: 'decinewton metre',
    Description: '',
  },
  {
    key: 'J72',
    label: 'centinewton metre',
    Description: '',
  },
  {
    key: 'M94',
    label: 'kilogram metre',
    Description:
      'Unit of imbalance as a product of the SI base unit kilogram and the SI base unit metre.',
  },
  {
    key: 'F88',
    label: 'newton centimetre',
    Description: '',
  },
  {
    key: 'F90',
    label: 'newton metre per ampere',
    Description: '',
  },
  {
    key: 'F89',
    label: 'newton metre per degree',
    Description: '',
  },
  {
    key: 'G19',
    label: 'newton metre per kilogram',
    Description: '',
  },
  {
    key: 'F47',
    label: 'newton per millimetre',
    Description: '',
  },
  {
    key: 'M93',
    label: 'newton metre per radian',
    Description:
      'Product of the derived SI unit newton and the SI base unit metre divided by the unit radian.',
  },
  {
    key: 'H41',
    label: 'newton metre watt to the power minus 0,5',
    Description: '',
  },
  {
    key: 'B38',
    label: 'kilogram-force metre',
    Description: '',
  },
  {
    key: 'IA',
    label: 'inch pound (pound inch)',
    Description: '',
  },
  {
    key: '4Q',
    label: 'ounce inch',
    Description: '',
  },
  {
    key: '4R',
    label: 'ounce foot',
    Description: '',
  },
  {
    key: 'F22',
    label: 'pound-force foot per ampere',
    Description: '',
  },
  {
    key: 'F21',
    label: 'pound-force inch',
    Description: '',
  },
  {
    key: 'G20',
    label: 'pound-force foot per pound',
    Description: '',
  },
  {
    key: 'J94',
    label: 'dyne centimetre',
    Description: '',
  },
  {
    key: 'L41',
    label: 'ounce (avoirdupois)-force inch',
    Description: '',
  },
  {
    key: 'M92',
    label: 'pound-force foot',
    Description:
      'Product of the unit pound-force according to the Anglo-American system of units and the unit foot according to the Anglo-American and the Imperial system of units.',
  },
  {
    key: 'M95',
    label: 'poundal foot',
    Description:
      'Product of the non SI-conforming unit of the force poundal and the unit foot according to the Anglo-American and Imperial system of units .',
  },
  {
    key: 'M96',
    label: 'poundal inch',
    Description:
      'Product of the non SI-conforming unit of the force poundal and the unit inch according to the Anglo-American and Imperial system of units .',
  },
  {
    key: 'M97',
    label: 'dyne metre',
    Description:
      'CGS (Centimetre-Gram-Second system) unit of the rotational moment.',
  },
  {
    key: 'C57',
    label: 'newton second',
    Description: '',
  },
  {
    key: 'C53',
    label: 'newton metre second',
    Description: '',
  },
  {
    key: '74',
    label: 'millipascal',
    Description: '',
  },
  {
    key: 'MPA',
    label: 'megapascal',
    Description: '',
  },
  {
    key: 'PAL',
    label: 'pascal',
    Description: '',
  },
  {
    key: 'KPA',
    label: 'kilopascal',
    Description: '',
  },
  {
    key: 'BAR',
    label: 'bar [unit of pressure]',
    Description: '',
  },
  {
    key: 'HBA',
    label: 'hectobar',
    Description: '',
  },
  {
    key: 'MBR',
    label: 'millibar',
    Description: '',
  },
  {
    key: 'KBA',
    label: 'kilobar',
    Description: '',
  },
  {
    key: 'ATM',
    label: 'standard atmosphere',
    Description: '',
  },
  {
    key: 'A89',
    label: 'gigapascal',
    Description: '',
  },
  {
    key: 'B96',
    label: 'micropascal',
    Description: '',
  },
  {
    key: 'A97',
    label: 'hectopascal',
    Description: '',
  },
  {
    key: 'H75',
    label: 'decapascal',
    Description: '',
  },
  {
    key: 'B85',
    label: 'microbar',
    Description: '',
  },
  {
    key: 'C55',
    label: 'newton per square metre',
    Description: '',
  },
  {
    key: 'C56',
    label: 'newton per square millimetre',
    Description: '',
  },
  {
    key: 'H07',
    label: 'pascal second per bar',
    Description: '',
  },
  {
    key: 'F94',
    label: 'hectopascal cubic metre per second',
    Description: '',
  },
  {
    key: 'F93',
    label: 'hectopascal litre per second',
    Description: '',
  },
  {
    key: 'F82',
    label: 'hectopascal per kelvin',
    Description: '',
  },
  {
    key: 'F83',
    label: 'kilopascal per kelvin',
    Description: '',
  },
  {
    key: 'F98',
    label: 'megapascal cubic metre per second',
    Description: '',
  },
  {
    key: 'F97',
    label: 'megapascal litre per second',
    Description: '',
  },
  {
    key: 'F85',
    label: 'megapascal per kelvin',
    Description: '',
  },
  {
    key: 'F96',
    label: 'millibar cubic metre per second',
    Description: '',
  },
  {
    key: 'F95',
    label: 'millibar litre per second',
    Description: '',
  },
  {
    key: 'F84',
    label: 'millibar per kelvin',
    Description: '',
  },
  {
    key: 'G01',
    label: 'pascal cubic metre per second',
    Description: '',
  },
  {
    key: 'F99',
    label: 'pascal litre per second',
    Description: '',
  },
  {
    key: 'F77',
    label: 'pascal second per kelvin',
    Description: '',
  },
  {
    key: 'E01',
    label: 'newton per square centimetre',
    Description:
      'A measure of pressure expressed in newtons per square centimetre.',
  },
  {
    key: 'FP',
    label: 'pound per square foot',
    Description: '',
  },
  {
    key: 'PS',
    label: 'pound-force per square inch',
    Description: '',
  },
  {
    key: 'B40',
    label: 'kilogram-force per square metre',
    Description: '',
  },
  {
    key: 'UA',
    label: 'torr',
    Description: '',
  },
  {
    key: 'ATT',
    label: 'technical atmosphere',
    Description: '',
  },
  {
    key: '80',
    label: 'pound per square inch absolute',
    Description: '',
  },
  {
    key: 'H78',
    label: 'conventional centimetre of water',
    Description: '',
  },
  {
    key: 'HP',
    label: 'conventional millimetre of water',
    Description: '',
  },
  {
    key: 'HN',
    label: 'conventional millimetre of mercury',
    Description: '',
  },
  {
    key: 'F79',
    label: 'inch of mercury',
    Description: '',
  },
  {
    key: 'F78',
    label: 'inch of water',
    Description: '',
  },
  {
    key: 'J89',
    label: 'centimetre of mercury',
    Description: '',
  },
  {
    key: 'K24',
    label: 'foot of water',
    Description: '',
  },
  {
    key: 'K25',
    label: 'foot of mercury',
    Description: '',
  },
  {
    key: 'K31',
    label: 'gram-force per square centimetre',
    Description: '',
  },
  {
    key: 'E42',
    label: 'kilogram-force per square centimetre',
    Description: '',
  },
  {
    key: 'E41',
    label: 'kilogram-force per square millimetre',
    Description: '',
  },
  {
    key: 'K85',
    label: 'pound-force per square foot',
    Description: '',
  },
  {
    key: 'K86',
    label: 'pound-force per square inch degree Fahrenheit',
    Description: '',
  },
  {
    key: '84',
    label:
      'A unit of pressure defining the number of kilopounds force per square inch.',
    Description:
      'A unit of pressure defining the number of kilopounds force per square inch.',
  },
  {
    key: 'N13',
    label: 'centimetre of mercury (0 ºC)',
    Description:
      'Non SI-conforming unit of pressure, at which a value of 1 cmHg meets the static pressure, which is generated by a mercury at a temperature of 0 °C with a height of 1 centimetre .',
  },
  {
    key: 'N14',
    label: 'centimetre of water (4 ºC)',
    Description:
      'Non SI-conforming unit of pressure, at which a value of 1 cmH2O meets the static pressure, which is generated by a head of water at a temperature of 4 °C with a height of 1 centimetre .',
  },
  {
    key: 'N15',
    label: 'foot of water (39.2 ºF)',
    Description:
      'Non SI-conforming unit of pressure according to the Anglo-American and Imperial system for units, whereas the value of 1 ftH2O is equivalent to the static pressure, which is generated by a head of water at a temperature 39,2°F with a height of 1 foot .',
  },
  {
    key: 'N16',
    label: 'inch of mercury (32 ºF)',
    Description:
      'Non SI-conforming unit of pressure according to the Anglo-American and Imperial system for units, whereas the value of 1 inHg meets the static pressure, which is generated by a mercury at a temperature of 32°F with a height of 1 inch.',
  },
  {
    key: 'N17',
    label: 'inch of mercury (60 ºF)',
    Description:
      'Non SI-conforming unit of pressure according to the Anglo-American and Imperial system for units, whereas the value of 1 inHg meets the static pressure, which is generated by a mercury at a temperature of 60°F with a height of 1 inch.',
  },
  {
    key: 'N18',
    label: 'inch of water (39.2 ºF)',
    Description:
      'Non SI-conforming unit of pressure according to the Anglo-American and Imperial system for units, whereas the value of 1 inH2O meets the static pressure, which is generated by a head of water at a temperature of 39,2°F with a height of 1 inch .',
  },
  {
    key: 'N19',
    label: 'inch of water (60 ºF)',
    Description:
      'Non SI-conforming unit of pressure according to the Anglo-American and Imperial system for units, whereas the value of 1 inH2O meets the static pressure, which is generated by a head of water at a temperature of 60°F with a height of 1 inch .',
  },
  {
    key: 'N20',
    label: 'kip per square inch',
    Description:
      'Non SI-conforming unit of the pressure according to the Anglo-American system of units as the 1000-fold of the unit of the force pound-force divided by the power of the unit inch by exponent 2.',
  },
  {
    key: 'N21',
    label: 'poundal per square foot ',
    Description:
      'Non SI-conforming unit of pressure by the Imperial system of units according to NIST: 1 pdl/ft² = 1,488 164 Pa.',
  },
  {
    key: 'N22',
    label: 'ounce (avoirdupois) per square inch ',
    Description:
      'Unit of the surface specific mass (avoirdupois ounce according to the avoirdupois system of units according to the surface square inch according to the Anglo-American and Imperial system of units).',
  },
  {
    key: 'N23',
    label: 'conventional metre of water',
    Description:
      'Not SI-conforming unit of pressure, whereas a value of 1 mH2O is equivalent to the static pressure, which is produced by one metre high water column .',
  },
  {
    key: 'N24',
    label: 'gram per square millimetre',
    Description:
      '0,001-fold of the SI base unit kilogram divided by the 0.000 001-fold of the power of the SI base unit meter by exponent 2.',
  },
  {
    key: 'N25',
    label: 'pound per square yard',
    Description:
      'Unit for areal-related mass as a unit pound according to the avoirdupois unit system divided by the power of the unit yard according to the Anglo-American and Imperial system of units with exponent 2.',
  },
  {
    key: 'N26',
    label: 'poundal per square inch',
    Description:
      'Non SI-conforming unit of the pressure according to the Imperial system of units (poundal by square inch).',
  },
  {
    key: 'E99',
    label: 'hectopascal per bar',
    Description: '',
  },
  {
    key: 'F05',
    label: 'megapascal per bar',
    Description: '',
  },
  {
    key: 'F04',
    label: 'millibar per bar',
    Description: '',
  },
  {
    key: 'F07',
    label: 'pascal per bar',
    Description: '',
  },
  {
    key: 'F03',
    label: 'kilopascal per bar',
    Description: '',
  },
  {
    key: 'L52',
    label: 'psi per psi',
    Description: '',
  },
  {
    key: 'J56',
    label: 'bar per bar',
    Description: '',
  },
  {
    key: 'C96',
    label: 'reciprocal pascal or pascal to the power minus one',
    Description: '',
  },
  {
    key: 'F58',
    label: 'reciprocal bar',
    Description: '',
  },
  {
    key: 'B83',
    label: 'metre to the fourth power',
    Description: '',
  },
  {
    key: 'G77',
    label: 'millimetre to the fourth power',
    Description: '',
  },
  {
    key: 'D69',
    label: 'inch to the fourth power',
    Description: '',
  },
  {
    key: 'N27',
    label: 'foot to the fourth power ',
    Description:
      'Power of the unit foot according to the Anglo-American and Imperial system of units by exponent 4 according to NIST: 1 ft4 = 8,630 975 m4.',
  },
  {
    key: 'C65',
    label: 'pascal second',
    Description: '',
  },
  {
    key: 'N37',
    label: 'kilogram per metre second',
    Description:
      'Unit of the dynamic viscosity as a quotient SI base unit kilogram divided by the SI base unit metre and by the SI base unit second.',
  },
  {
    key: 'N38',
    label: 'kilogram per metre minute',
    Description:
      'Unit of the dynamic viscosity as a quotient SI base unit kilogram divided by the SI base unit metre and by the unit minute.',
  },
  {
    key: 'C24',
    label: 'millipascal second',
    Description: '',
  },
  {
    key: 'N36',
    label: 'newton second per square metre',
    Description:
      'Unit of the dynamic viscosity as a product of unit of the pressure (newton by square metre) multiplied with the SI base unit second.',
  },
  {
    key: 'N39',
    label: 'kilogram per metre day',
    Description:
      'Unit of the dynamic viscosity as a quotient SI base unit kilogram divided by the SI base unit metre and by the unit day.',
  },
  {
    key: 'N40',
    label: 'kilogram per metre hour',
    Description:
      'Unit of the dynamic viscosity as a quotient SI base unit kilogram divided by the SI base unit metre and by the unit hour.',
  },
  {
    key: 'N41',
    label: 'gram per centimetre second',
    Description:
      'Unit of the dynamic viscosity as a quotient of the 0,001-fold of the SI base unit kilogram divided by the 0,01-fold of the SI base unit metre and SI base unit second.',
  },
  {
    key: '89',
    label: 'poise',
    Description: '',
  },
  {
    key: 'C7',
    label: 'centipoise',
    Description: '',
  },
  {
    key: 'F06',
    label: 'poise per bar',
    Description: '',
  },
  {
    key: 'F86',
    label: 'poise per kelvin',
    Description: '',
  },
  {
    key: 'J32',
    label: 'micropoise',
    Description: '',
  },
  {
    key: 'J73',
    label: 'centipoise per kelvin',
    Description: '',
  },
  {
    key: 'J74',
    label: 'centipoise per bar',
    Description: '',
  },
  {
    key: 'K67',
    label: 'pound per foot hour',
    Description: '',
  },
  {
    key: 'K68',
    label: 'pound per foot second',
    Description: '',
  },
  {
    key: 'K91',
    label: 'pound-force second per square foot',
    Description: '',
  },
  {
    key: 'K92',
    label: 'pound-force second per square inch',
    Description: '',
  },
  {
    key: 'L15',
    label: 'millipascal second per kelvin',
    Description: '',
  },
  {
    key: 'L16',
    label: 'millipascal second per bar',
    Description: '',
  },
  {
    key: 'L64',
    label: 'slug per foot second',
    Description: '',
  },
  {
    key: 'N34',
    label: 'poundal second per square foot ',
    Description: 'Non SI-conforming unit of viscosity.',
  },
  {
    key: 'N35',
    label: 'poise per pascal',
    Description:
      'CGS (Centimetre-Gram-Second system) unit poise divided by the derived SI unit pascal.',
  },
  {
    key: 'N42',
    label: 'poundal second per square inch',
    Description:
      'Non SI-conforming unit of dynamic viscosity according to the Imperial system of units as product unit of the pressure (poundal by square inch) multiplied by the SI base unit second.',
  },
  {
    key: 'N43',
    label: 'pound per foot minute',
    Description:
      'Unit of the dynamic viscosity according to the Anglo-American unit system.',
  },
  {
    key: 'N44',
    label: 'pound per foot day',
    Description:
      'Unit of the dynamic viscosity according to the Anglo-American unit system.',
  },
  {
    key: 'S4',
    label: 'square metre per second',
    Description: 'Synonym: metre squared per second (square metres/second US)',
  },
  {
    key: 'M82',
    label: 'square metre per second pascal',
    Description:
      'Power of the SI base unit metre with the exponent 2 divided by the SI base unit second and the derived SI unit pascal.',
  },
  {
    key: 'C17',
    label: 'millimetre squared per second',
    Description: '',
  },
  {
    key: 'G41',
    label: 'square metre per second bar',
    Description: '',
  },
  {
    key: 'G09',
    label: 'square metre per second kelvin',
    Description: '',
  },
  {
    key: '91',
    label: 'stokes',
    Description: '',
  },
  {
    key: '4C',
    label: 'centistokes',
    Description: '',
  },
  {
    key: 'G46',
    label: 'stokes per bar',
    Description: '',
  },
  {
    key: 'G10',
    label: 'stokes per kelvin',
    Description: '',
  },
  {
    key: 'S3',
    label: 'square foot per second',
    Description: 'Synonym: foot squared per second',
  },
  {
    key: 'G08',
    label: 'square inch per second',
    Description: '',
  },
  {
    key: 'M79',
    label: 'square foot per hour ',
    Description:
      'Power of the unit foot according to the Anglo-American and Imperial system of units by exponent 2 divided by the unit of time hour.',
  },
  {
    key: 'M80',
    label: 'stokes per pascal',
    Description:
      'CGS (Centimetre-Gram-Second system) unit stokes divided by the derived SI unit pascal.',
  },
  {
    key: 'M81',
    label: 'square centimetre per second',
    Description:
      '0,000 1-fold of the power of the SI base unit metre by exponent 2 divided by the SI base unit second.',
  },
  {
    key: '4P',
    label: 'newton per metre',
    Description: '',
  },
  {
    key: 'C22',
    label: 'millinewton per metre',
    Description: '',
  },
  {
    key: 'M23',
    label: 'newton per centimetre',
    Description: '',
  },
  {
    key: 'N31',
    label: 'kilonewton per metre',
    Description:
      '1000-fold of the derived SI unit newton divided by the SI base unit metre.',
  },
  {
    key: 'DX',
    label: 'dyne per centimetre',
    Description: '',
  },
  {
    key: 'N32',
    label: 'poundal per inch',
    Description:
      'Non SI-conforming unit of the surface tension according to the Imperial unit system as quotient poundal by inch.',
  },
  {
    key: 'N33',
    label: 'pound-force per yard',
    Description:
      'Unit of force per unit length based on the Anglo-American system of units.',
  },
  {
    key: 'M34',
    label: 'newton metre per square metre',
    Description: '',
  },
  {
    key: 'JOU',
    label: 'joule',
    Description: '',
  },
  {
    key: 'KJO',
    label: 'kilojoule',
    Description: '',
  },
  {
    key: 'A68',
    label: 'exajoule',
    Description: '',
  },
  {
    key: 'C68',
    label: 'petajoule',
    Description: '',
  },
  {
    key: 'D30',
    label: 'terajoule',
    Description: '',
  },
  {
    key: 'GV',
    label: 'gigajoule',
    Description: '',
  },
  {
    key: '3B',
    label: 'megajoule',
    Description: '',
  },
  {
    key: 'C15',
    label: 'millijoule',
    Description: '',
  },
  {
    key: 'A70',
    label: 'femtojoule',
    Description: '',
  },
  {
    key: 'A13',
    label: 'attojoule',
    Description: '',
  },
  {
    key: 'WHR',
    label: 'watt hour',
    Description: '',
  },
  {
    key: 'MWH',
    label: 'megawatt hour (1000 kW.h)',
    Description:
      'A unit of power defining the total amount of bulk energy transferred or consumed.',
  },
  {
    key: 'KWH',
    label: 'kilowatt hour',
    Description: '',
  },
  {
    key: 'GWH',
    label: 'gigawatt hour',
    Description: '',
  },
  {
    key: 'D32',
    label: 'terawatt hour',
    Description: '',
  },
  {
    key: 'A53',
    label: 'electronvolt',
    Description: '',
  },
  {
    key: 'B71',
    label: 'megaelectronvolt',
    Description: '',
  },
  {
    key: 'A85',
    label: 'gigaelectronvolt',
    Description: '',
  },
  {
    key: 'B29',
    label: 'kiloelectronvolt',
    Description: '',
  },
  {
    key: 'A57',
    label: 'erg',
    Description: '',
  },
  {
    key: '85',
    label: 'foot pound-force',
    Description: '',
  },
  {
    key: 'N46',
    label: 'foot poundal',
    Description: 'Unit of the work (force-path).',
  },
  {
    key: 'N47',
    label: 'inch poundal',
    Description:
      'Unit of work (force multiplied by path) according to the Imperial system of units as a product unit inch multiplied by poundal.',
  },
  {
    key: 'WTT',
    label: 'watt',
    Description: '',
  },
  {
    key: 'KWT',
    label: 'kilowatt',
    Description: '',
  },
  {
    key: 'MAW',
    label: 'megawatt',
    Description:
      'A unit of power defining the rate of energy transferred or consumed when a current of 1000 amperes flows due to a potential of 1000 volts at unity power factor.',
  },
  {
    key: 'A90',
    label: 'gigawatt',
    Description: '',
  },
  {
    key: 'C31',
    label: 'milliwatt',
    Description: '',
  },
  {
    key: 'D80',
    label: 'microwatt',
    Description: '',
  },
  {
    key: 'F80',
    label: 'water horse power',
    Description:
      'A unit of power defining the amount of power required to move a given volume of water against acceleration of gravity to a specified elevation (pressure head).',
  },
  {
    key: 'A63',
    label: 'erg per second',
    Description: '',
  },
  {
    key: 'A74',
    label: 'foot pound-force per second',
    Description: '',
  },
  {
    key: 'B39',
    label: 'kilogram-force metre per second',
    Description: '',
  },
  {
    key: 'HJ',
    label: 'metric horse power',
    Description: '',
  },
  {
    key: 'A25',
    label: 'cheval vapeur',
    Description: 'Synonym: metric horse power',
  },
  {
    key: 'BHP',
    label: 'brake horse power',
    Description: '',
  },
  {
    key: 'K15',
    label: 'foot pound-force per hour',
    Description: '',
  },
  {
    key: 'K16',
    label: 'foot pound-force per minute',
    Description: '',
  },
  {
    key: 'K42',
    label: 'horsepower (boiler)',
    Description: '',
  },
  {
    key: 'N12',
    label: 'Pferdestaerke',
    Description:
      'Obsolete unit of the power relating to DIN 1301-3:1979: 1 PS = 735,498 75 W.',
  },
  {
    key: 'KGS',
    label: 'kilogram per second',
    Description: '',
  },
  {
    key: 'H56',
    label: 'kilogram per square metre second',
    Description: '',
  },
  {
    key: 'M87',
    label: 'kilogram per second pascal',
    Description:
      'SI base unit kilogram divided by the product of the SI base unit second and the derived SI unit pascal.',
  },
  {
    key: '4M',
    label: 'milligram per hour',
    Description: '',
  },
  {
    key: 'F26',
    label: 'gram per day',
    Description: '',
  },
  {
    key: 'F62',
    label: 'gram per day bar',
    Description: '',
  },
  {
    key: 'F35',
    label: 'gram per day kelvin',
    Description: '',
  },
  {
    key: 'F27',
    label: 'gram per hour',
    Description: '',
  },
  {
    key: 'F63',
    label: 'gram per hour bar',
    Description: '',
  },
  {
    key: 'F36',
    label: 'gram per hour kelvin',
    Description: '',
  },
  {
    key: 'F28',
    label: 'gram per minute',
    Description: '',
  },
  {
    key: 'F64',
    label: 'gram per minute bar',
    Description: '',
  },
  {
    key: 'F37',
    label: 'gram per minute kelvin',
    Description: '',
  },
  {
    key: 'F29',
    label: 'gram per second',
    Description: '',
  },
  {
    key: 'F65',
    label: 'gram per second bar',
    Description: '',
  },
  {
    key: 'F38',
    label: 'gram per second kelvin',
    Description: '',
  },
  {
    key: 'F30',
    label: 'kilogram per day',
    Description: '',
  },
  {
    key: 'F66',
    label: 'kilogram per day bar',
    Description: '',
  },
  {
    key: 'F39',
    label: 'kilogram per day kelvin',
    Description: '',
  },
  {
    key: 'E93',
    label: 'kilogram per hour',
    Description: '',
  },
  {
    key: 'F67',
    label: 'kilogram per hour bar',
    Description: '',
  },
  {
    key: 'F40',
    label: 'kilogram per hour kelvin',
    Description: '',
  },
  {
    key: 'F31',
    label: 'kilogram per minute',
    Description: '',
  },
  {
    key: 'F68',
    label: 'kilogram per minute bar',
    Description: '',
  },
  {
    key: 'F41',
    label: 'kilogram per minute kelvin',
    Description: '',
  },
  {
    key: 'F69',
    label: 'kilogram per second bar',
    Description: '',
  },
  {
    key: 'F42',
    label: 'kilogram per second kelvin',
    Description: '',
  },
  {
    key: 'F32',
    label: 'milligram per day',
    Description: '',
  },
  {
    key: 'F70',
    label: 'milligram per day bar',
    Description: '',
  },
  {
    key: 'F43',
    label: 'milligram per day kelvin',
    Description: '',
  },
  {
    key: 'F71',
    label: 'milligram per hour bar',
    Description: '',
  },
  {
    key: 'F44',
    label: 'milligram per hour kelvin',
    Description: '',
  },
  {
    key: 'F33',
    label: 'milligram per minute',
    Description: '',
  },
  {
    key: 'F72',
    label: 'milligram per minute bar',
    Description: '',
  },
  {
    key: 'F45',
    label: 'milligram per minute kelvin',
    Description: '',
  },
  {
    key: 'F34',
    label: 'milligram per second',
    Description: '',
  },
  {
    key: 'F73',
    label: 'milligram per second bar',
    Description: '',
  },
  {
    key: 'F46',
    label: 'milligram per second kelvin',
    Description: '',
  },
  {
    key: 'F25',
    label: 'gram per hertz',
    Description: '',
  },
  {
    key: '4W',
    label: 'ton (US) per hour',
    Description: '',
  },
  {
    key: '4U',
    label: 'pound per hour',
    Description: '',
  },
  {
    key: 'K66',
    label: 'pound (avoirdupois) per day',
    Description: '',
  },
  {
    key: 'K73',
    label: 'pound (avoirdupois) per hour degree Fahrenheit',
    Description: '',
  },
  {
    key: 'K74',
    label: 'pound (avoirdupois) per hour psi',
    Description: '',
  },
  {
    key: 'K78',
    label: 'pound (avoirdupois) per minute',
    Description: '',
  },
  {
    key: 'K79',
    label: 'pound (avoirdupois) per minute degree Fahrenheit',
    Description: '',
  },
  {
    key: 'K80',
    label: 'pound (avoirdupois) per minute psi',
    Description: '',
  },
  {
    key: 'K81',
    label: 'pound (avoirdupois) per second',
    Description: '',
  },
  {
    key: 'K82',
    label: 'pound (avoirdupois) per second degree Fahrenheit',
    Description: '',
  },
  {
    key: 'K83',
    label: 'pound (avoirdupois) per second psi',
    Description: '',
  },
  {
    key: 'L33',
    label: 'ounce (avoirdupois) per day',
    Description: '',
  },
  {
    key: 'L34',
    label: 'ounce (avoirdupois) per hour',
    Description: '',
  },
  {
    key: 'L35',
    label: 'ounce (avoirdupois) per minute',
    Description: '',
  },
  {
    key: 'L36',
    label: 'ounce (avoirdupois) per second',
    Description: '',
  },
  {
    key: 'L63',
    label: 'slug per day',
    Description: '',
  },
  {
    key: 'L66',
    label: 'slug per hour',
    Description: '',
  },
  {
    key: 'L67',
    label: 'slug per minute',
    Description: '',
  },
  {
    key: 'L68',
    label: 'slug per second',
    Description: '',
  },
  {
    key: 'L71',
    label: 'tonne per day',
    Description: '',
  },
  {
    key: 'L72',
    label: 'tonne per day kelvin',
    Description: '',
  },
  {
    key: 'L73',
    label: 'tonne per day bar',
    Description: '',
  },
  {
    key: 'E18',
    label: 'tonne per hour',
    Description: 'A unit of weight or mass equal to one tonne per hour.',
  },
  {
    key: 'L74',
    label: 'tonne per hour kelvin',
    Description: '',
  },
  {
    key: 'L75',
    label: 'tonne per hour bar',
    Description: '',
  },
  {
    key: 'L78',
    label: 'tonne per minute',
    Description: '',
  },
  {
    key: 'L79',
    label: 'tonne per minute kelvin',
    Description: '',
  },
  {
    key: 'L80',
    label: 'tonne per minute bar',
    Description: '',
  },
  {
    key: 'L81',
    label: 'tonne per second',
    Description: '',
  },
  {
    key: 'L82',
    label: 'tonne per second kelvin',
    Description: '',
  },
  {
    key: 'L83',
    label: 'tonne per second bar',
    Description: '',
  },
  {
    key: 'L85',
    label: 'ton long per day',
    Description: '',
  },
  {
    key: 'L88',
    label: 'ton short per day',
    Description: '',
  },
  {
    key: 'L89',
    label: 'ton short per hour degree Fahrenheit',
    Description: '',
  },
  {
    key: 'L90',
    label: 'ton short per hour psi',
    Description: '',
  },
  {
    key: 'M88',
    label: 'tonne per month',
    Description: 'Unit tonne divided by the unit month.',
  },
  {
    key: 'M89',
    label: 'tonne per year',
    Description: 'Unit tonne divided by the unit year with 365 days.',
  },
  {
    key: 'M90',
    label: 'kilopound per hour',
    Description:
      '1000-fold of the unit of the mass avoirdupois pound according to the avoirdupois unit system divided by the unit hour.',
  },
  {
    key: 'J33',
    label: 'microgram per kilogram',
    Description: '',
  },
  {
    key: 'L32',
    label: 'nanogram per kilogram',
    Description: '',
  },
  {
    key: 'NA',
    label: 'milligram per kilogram',
    Description: '',
  },
  {
    key: 'M29',
    label: 'kilogram per kilogram',
    Description: '',
  },
  {
    key: 'M91',
    label: 'pound per pound',
    Description:
      'Proportion of the mass consisting of the avoirdupois pound according to the avoirdupois unit system divided by the avoirdupois pound according to the avoirdupois unit system.',
  },
  {
    key: 'MQS',
    label: 'cubic metre per second',
    Description: '',
  },
  {
    key: 'MQH',
    label: 'cubic metre per hour',
    Description: '',
  },
  {
    key: '40',
    label: 'millilitre per second',
    Description: '',
  },
  {
    key: '41',
    label: 'millilitre per minute',
    Description: '',
  },
  {
    key: 'LD',
    label: 'litre per day',
    Description: '',
  },
  {
    key: '2J',
    label: 'cubic centimetre per second',
    Description: '',
  },
  {
    key: '4X',
    label: 'kilolitre per hour',
    Description: '',
  },
  {
    key: 'L2',
    label: 'litre per minute',
    Description: '',
  },
  {
    key: 'G47',
    label: 'cubic centimetre per day',
    Description: '',
  },
  {
    key: 'G78',
    label: 'cubic centimetre per day bar',
    Description: '',
  },
  {
    key: 'G61',
    label: 'cubic centimetre per day kelvin',
    Description: '',
  },
  {
    key: 'G48',
    label: 'cubic centimetre per hour',
    Description: '',
  },
  {
    key: 'G79',
    label: 'cubic centimetre per hour bar',
    Description: '',
  },
  {
    key: 'G62',
    label: 'cubic centimetre per hour kelvin',
    Description: '',
  },
  {
    key: 'G49',
    label: 'cubic centimetre per minute',
    Description: '',
  },
  {
    key: 'G80',
    label: 'cubic centimetre per minute bar',
    Description: '',
  },
  {
    key: 'G63',
    label: 'cubic centimetre per minute kelvin',
    Description: '',
  },
  {
    key: 'G81',
    label: 'cubic centimetre per second bar',
    Description: '',
  },
  {
    key: 'G64',
    label: 'cubic centimetre per second kelvin',
    Description: '',
  },
  {
    key: 'E92',
    label: 'cubic decimetre per hour',
    Description: '',
  },
  {
    key: 'G52',
    label: 'cubic metre per day',
    Description: '',
  },
  {
    key: 'G86',
    label: 'cubic metre per day bar',
    Description: '',
  },
  {
    key: 'G69',
    label: 'cubic metre per day kelvin',
    Description: '',
  },
  {
    key: 'G87',
    label: 'cubic metre per hour bar',
    Description: '',
  },
  {
    key: 'G70',
    label: 'cubic metre per hour kelvin',
    Description: '',
  },
  {
    key: 'G53',
    label: 'cubic metre per minute',
    Description: '',
  },
  {
    key: 'G88',
    label: 'cubic metre per minute bar',
    Description: '',
  },
  {
    key: 'G71',
    label: 'cubic metre per minute kelvin',
    Description: '',
  },
  {
    key: 'G89',
    label: 'cubic metre per second bar',
    Description: '',
  },
  {
    key: 'G72',
    label: 'cubic metre per second kelvin',
    Description: '',
  },
  {
    key: 'G82',
    label: 'litre per day bar',
    Description: '',
  },
  {
    key: 'G65',
    label: 'litre per day kelvin',
    Description: '',
  },
  {
    key: 'G83',
    label: 'litre per hour bar',
    Description: '',
  },
  {
    key: 'G66',
    label: 'litre per hour kelvin',
    Description: '',
  },
  {
    key: 'G84',
    label: 'litre per minute bar',
    Description: '',
  },
  {
    key: 'G67',
    label: 'litre per minute kelvin',
    Description: '',
  },
  {
    key: 'G51',
    label: 'litre per second',
    Description: '',
  },
  {
    key: 'G85',
    label: 'litre per second bar',
    Description: '',
  },
  {
    key: 'G68',
    label: 'litre per second kelvin',
    Description: '',
  },
  {
    key: 'G54',
    label: 'millilitre per day',
    Description: '',
  },
  {
    key: 'G90',
    label: 'millilitre per day bar',
    Description: '',
  },
  {
    key: 'G73',
    label: 'millilitre per day kelvin',
    Description: '',
  },
  {
    key: 'G55',
    label: 'millilitre per hour',
    Description: '',
  },
  {
    key: 'G91',
    label: 'millilitre per hour bar',
    Description: '',
  },
  {
    key: 'G74',
    label: 'millilitre per hour kelvin',
    Description: '',
  },
  {
    key: 'G92',
    label: 'millilitre per minute bar',
    Description: '',
  },
  {
    key: 'G75',
    label: 'millilitre per minute kelvin',
    Description: '',
  },
  {
    key: 'G93',
    label: 'millilitre per second bar',
    Description: '',
  },
  {
    key: 'G76',
    label: 'millilitre per second kelvin',
    Description: '',
  },
  {
    key: '2K',
    label: 'cubic foot per hour',
    Description: '',
  },
  {
    key: '2L',
    label: 'cubic foot per minute',
    Description: '',
  },
  {
    key: '5A',
    label: 'barrel (US) per minute',
    Description: '',
  },
  {
    key: 'G2',
    label: 'US gallon per minute',
    Description: '',
  },
  {
    key: 'G3',
    label: 'Imperial gallon per minute',
    Description: '',
  },
  {
    key: 'G56',
    label: 'cubic inch per hour',
    Description: '',
  },
  {
    key: 'G57',
    label: 'cubic inch per minute',
    Description: '',
  },
  {
    key: 'G58',
    label: 'cubic inch per second',
    Description: '',
  },
  {
    key: 'G50',
    label: 'gallon (US) per hour',
    Description: '',
  },
  {
    key: 'J58',
    label: 'barrel (UK petroleum) per minute',
    Description: '',
  },
  {
    key: 'J59',
    label: 'barrel (UK petroleum) per day',
    Description: '',
  },
  {
    key: 'J60',
    label: 'barrel (UK petroleum) per hour',
    Description: '',
  },
  {
    key: 'J61',
    label: 'barrel (UK petroleum) per second',
    Description: '',
  },
  {
    key: 'J62',
    label: 'barrel (US petroleum) per hour',
    Description: '',
  },
  {
    key: 'J63',
    label: 'barrel (US petroleum) per second',
    Description: '',
  },
  {
    key: 'J64',
    label: 'bushel (UK) per day',
    Description: '',
  },
  {
    key: 'J65',
    label: 'bushel (UK) per hour',
    Description: '',
  },
  {
    key: 'J66',
    label: 'bushel (UK) per minute',
    Description: '',
  },
  {
    key: 'J67',
    label: 'bushel (UK) per second',
    Description: '',
  },
  {
    key: 'J68',
    label: 'bushel (US dry) per day',
    Description: '',
  },
  {
    key: 'J69',
    label: 'bushel (US dry) per hour',
    Description: '',
  },
  {
    key: 'J70',
    label: 'bushel (US dry) per minute',
    Description: '',
  },
  {
    key: 'J71',
    label: 'bushel (US dry) per second',
    Description: '',
  },
  {
    key: 'J90',
    label: 'cubic decimetre per day',
    Description: '',
  },
  {
    key: 'J92',
    label: 'cubic decimetre per minute',
    Description: '',
  },
  {
    key: 'J93',
    label: 'cubic decimetre per second',
    Description: '',
  },
  {
    key: 'N45',
    label: 'cubic metre per second pascal',
    Description:
      'Power of the SI base unit meter by exponent 3 divided by the product of the SI base unit second and the derived SI base unit pascal.',
  },
  {
    key: 'J95',
    label: 'ounce (UK fluid) per day',
    Description: '',
  },
  {
    key: 'J96',
    label: 'ounce (UK fluid) per hour',
    Description: '',
  },
  {
    key: 'J97',
    label: 'ounce (UK fluid) per minute',
    Description: '',
  },
  {
    key: 'J98',
    label: 'ounce (UK fluid) per second',
    Description: '',
  },
  {
    key: 'J99',
    label: 'ounce (US fluid) per day',
    Description: '',
  },
  {
    key: 'K10',
    label: 'ounce (US fluid) per hour',
    Description: '',
  },
  {
    key: 'K11',
    label: 'ounce (US fluid) per minute',
    Description: '',
  },
  {
    key: 'K12',
    label: 'ounce (US fluid) per second',
    Description: '',
  },
  {
    key: 'K22',
    label: 'cubic foot per day',
    Description: '',
  },
  {
    key: 'K26',
    label: 'gallon (UK) per day',
    Description: '',
  },
  {
    key: 'K27',
    label: 'gallon (UK) per hour',
    Description: '',
  },
  {
    key: 'K28',
    label: 'gallon (UK) per second',
    Description: '',
  },
  {
    key: 'K30',
    label: 'gallon (US liquid) per second',
    Description: '',
  },
  {
    key: 'K32',
    label: 'gill (UK) per day',
    Description: '',
  },
  {
    key: 'K33',
    label: 'gill (UK) per hour',
    Description: '',
  },
  {
    key: 'K34',
    label: 'gill (UK) per minute',
    Description: '',
  },
  {
    key: 'K35',
    label: 'gill (UK) per second',
    Description: '',
  },
  {
    key: 'K36',
    label: 'gill (US) per day',
    Description: '',
  },
  {
    key: 'K37',
    label: 'gill (US) per hour',
    Description: '',
  },
  {
    key: 'K38',
    label: 'gill (US) per minute',
    Description: '',
  },
  {
    key: 'K39',
    label: 'gill (US) per second',
    Description: '',
  },
  {
    key: 'K94',
    label: 'quart (UK liquid) per day',
    Description: '',
  },
  {
    key: 'K95',
    label: 'quart (UK liquid) per hour',
    Description: '',
  },
  {
    key: 'K96',
    label: 'quart (UK liquid) per minute',
    Description: '',
  },
  {
    key: 'K97',
    label: 'quart (UK liquid) per second',
    Description: '',
  },
  {
    key: 'K98',
    label: 'quart (US liquid) per day',
    Description: '',
  },
  {
    key: 'K99',
    label: 'quart (US liquid) per hour',
    Description: '',
  },
  {
    key: 'L10',
    label: 'quart (US liquid) per minute',
    Description: '',
  },
  {
    key: 'L11',
    label: 'quart (US liquid) per second',
    Description: '',
  },
  {
    key: 'L44',
    label: 'peck (UK) per day',
    Description: '',
  },
  {
    key: 'L45',
    label: 'peck (UK) per hour',
    Description: '',
  },
  {
    key: 'L46',
    label: 'peck (UK) per minute',
    Description: '',
  },
  {
    key: 'L47',
    label: 'peck (UK) per second',
    Description: '',
  },
  {
    key: 'L48',
    label: 'peck (US dry) per day',
    Description: '',
  },
  {
    key: 'L49',
    label: 'peck (US dry) per hour',
    Description: '',
  },
  {
    key: 'L50',
    label: 'peck (US dry) per minute',
    Description: '',
  },
  {
    key: 'L51',
    label: 'peck (US dry) per second',
    Description: '',
  },
  {
    key: 'L53',
    label: 'pint (UK) per day',
    Description: '',
  },
  {
    key: 'L54',
    label: 'pint (UK) per hour',
    Description: '',
  },
  {
    key: 'L55',
    label: 'pint (UK) per minute',
    Description: '',
  },
  {
    key: 'L56',
    label: 'pint (UK) per second',
    Description: '',
  },
  {
    key: 'L57',
    label: 'pint (US liquid) per day',
    Description: '',
  },
  {
    key: 'L58',
    label: 'pint (US liquid) per hour',
    Description: '',
  },
  {
    key: 'L59',
    label: 'pint (US liquid) per minute',
    Description: '',
  },
  {
    key: 'L60',
    label: 'pint (US liquid) per second',
    Description: '',
  },
  {
    key: 'M12',
    label: 'cubic yard per day',
    Description: '',
  },
  {
    key: 'M13',
    label: 'cubic yard per hour',
    Description: '',
  },
  {
    key: 'M15',
    label: 'cubic yard per minute',
    Description: '',
  },
  {
    key: 'M16',
    label: 'cubic yard per second',
    Description: '',
  },
  {
    key: 'H60',
    label: 'cubic metre per cubic metre',
    Description: '',
  },
  {
    key: 'F92',
    label: 'bar cubic metre per second',
    Description: '',
  },
  {
    key: 'F91',
    label: 'bar litre per second',
    Description: '',
  },
  {
    key: 'K87',
    label: 'psi cubic inch per second',
    Description: '',
  },
  {
    key: 'K88',
    label: 'psi litre per second',
    Description: '',
  },
  {
    key: 'K89',
    label: 'psi cubic metre per second',
    Description: '',
  },
  {
    key: 'K90',
    label: 'psi cubic yard per second',
    Description: '',
  },
  {
    key: 'Q29',
    label: 'microgram per hectogram',
    Description: 'Microgram per hectogram.',
  },
  {
    key: 'Q37',
    label: 'Standard cubic metre per day',
    Description:
      'Standard cubic metre (temperature 15°C and pressure 101325 millibars ) per day',
  },
  {
    key: 'Q38',
    label: 'Standard cubic metre per hour',
    Description:
      'Standard cubic metre (temperature 15°C and pressure 101325 millibars ) per hour',
  },
  {
    key: 'Q39',
    label: 'Normalized cubic metre per day',
    Description:
      'Normalized cubic metre (temperature 0°C and pressure 101325 millibars ) per day',
  },
  {
    key: 'Q40',
    label: 'Normalized cubic metre per hour',
    Description:
      'Normalized cubic metre (temperature 0°C and pressure 101325 millibars ) per hour',
  },
  {
    key: 'KWN',
    label: 'Kilowatt hour per normalized cubic metre',
    Description:
      'Kilowatt hour per normalized cubic metre (temperature 0°C and pressure 101325 millibars ).',
  },
  {
    key: 'KWS',
    label: 'Kilowatt hour per standard cubic metre',
    Description:
      'Kilowatt hour per standard cubic metre (temperature 15°C and pressure 101325 millibars).',
  },
  {
    key: 'Q41',
    label: 'Joule per normalised cubic metre',
    Description:
      'Joule per normalised cubic metre (temperature 0°C and pressure 101325 millibars).',
  },
  {
    key: 'Q42',
    label: 'Joule per standard cubic metre',
    Description:
      'Joule per standard cubic metre (temperature 15°C and pressure 101325 millibars).',
  },
  {
    key: 'MNJ',
    label: 'Mega Joule per Normalised cubic Metre',
    Description:
      'Energy in Mega Joules per normalised cubic metre for gas (temperature 0°C and pressure 101325 millibars)',
  },
  {
    key: 'KEL',
    label: 'kelvin',
    Description:
      'Refer ISO 80000-5 (Quantities and units — Part 5: Thermodynamics)',
  },
  {
    key: 'CEL',
    label: 'degree Celsius',
    Description:
      'Refer ISO 80000-5 (Quantities and units — Part 5: Thermodynamics)',
  },
  {
    key: 'H12',
    label: 'degree Celsius per hour',
    Description: '',
  },
  {
    key: 'F60',
    label: 'degree Celsius per bar',
    Description: '',
  },
  {
    key: 'E98',
    label: 'degree Celsius per kelvin',
    Description: '',
  },
  {
    key: 'H13',
    label: 'degree Celsius per minute',
    Description: '',
  },
  {
    key: 'H14',
    label: 'degree Celsius per second',
    Description: '',
  },
  {
    key: 'F61',
    label: 'kelvin per bar',
    Description: '',
  },
  {
    key: 'F10',
    label: 'kelvin per hour',
    Description: '',
  },
  {
    key: 'F02',
    label: 'kelvin per kelvin',
    Description: '',
  },
  {
    key: 'F11',
    label: 'kelvin per minute',
    Description: '',
  },
  {
    key: 'F12',
    label: 'kelvin per second',
    Description: '',
  },
  {
    key: 'N79',
    label: 'kelvin per pascal',
    Description: 'SI base unit kelvin divided by the derived SI unit pascal.',
  },
  {
    key: 'J20',
    label: 'degree Fahrenheit per kelvin',
    Description: '',
  },
  {
    key: 'J21',
    label: 'degree Fahrenheit per bar',
    Description: '',
  },
  {
    key: 'J26',
    label: 'reciprocal degree Fahrenheit',
    Description: '',
  },
  {
    key: 'A48',
    label: 'degree Rankine',
    Description:
      'Refer ISO 80000-5 (Quantities and units — Part 5: Thermodynamics)',
  },
  {
    key: 'FAH',
    label: 'degree Fahrenheit',
    Description:
      'Refer ISO 80000-5 (Quantities and units — Part 5: Thermodynamics)',
  },
  {
    key: 'J23',
    label: 'degree Fahrenheit per hour',
    Description: '',
  },
  {
    key: 'J24',
    label: 'degree Fahrenheit per minute',
    Description: '',
  },
  {
    key: 'J25',
    label: 'degree Fahrenheit per second',
    Description: '',
  },
  {
    key: 'J28',
    label: 'degree Rankine per hour',
    Description: '',
  },
  {
    key: 'J29',
    label: 'degree Rankine per minute',
    Description: '',
  },
  {
    key: 'J30',
    label: 'degree Rankine per second',
    Description: '',
  },
  {
    key: 'C91',
    label: 'reciprocal kelvin or kelvin to the power minus one',
    Description: '',
  },
  {
    key: 'M20',
    label: 'reciprocal megakelvin or megakelvin to the power minus one',
    Description: '',
  },
  {
    key: 'C64',
    label: 'pascal per kelvin',
    Description: '',
  },
  {
    key: 'F81',
    label: 'bar per kelvin',
    Description: '',
  },
  {
    key: 'J55',
    label: 'watt second',
    Description: '',
  },
  {
    key: 'BTU',
    label: 'British thermal unit (international table)',
    Description: '',
  },
  {
    key: 'A1',
    label: '15 °C calorie',
    Description: '',
  },
  {
    key: 'D70',
    label: 'calorie (international table) ',
    Description: '',
  },
  {
    key: 'J39',
    label: 'British thermal unit (mean)',
    Description: '',
  },
  {
    key: 'J75',
    label: 'calorie (mean)',
    Description: '',
  },
  {
    key: 'K51',
    label: 'kilocalorie (mean)',
    Description: '',
  },
  {
    key: 'E14',
    label: 'kilocalorie (international table)',
    Description: '',
  },
  {
    key: 'K53',
    label: 'kilocalorie (thermochemical)',
    Description: '',
  },
  {
    key: 'N66',
    label: 'British thermal unit (39 ºF) ',
    Description:
      'Unit of heat energy according to the Imperial system of units in a reference temperature of 39 °F.',
  },
  {
    key: 'N67',
    label: 'British thermal unit (59 ºF)',
    Description:
      'Unit of heat energy according to the Imperial system of units in a reference temperature of 59 °F.',
  },
  {
    key: 'N68',
    label: 'British thermal unit (60 ºF) ',
    Description:
      'Unit of head energy according to the Imperial system of units at a reference temperature of 60 °F.',
  },
  {
    key: 'N69',
    label: 'calorie (20 ºC) ',
    Description:
      'Unit for quantity of heat, which is to be required for 1 g air free water at a constant pressure from 101,325 kPa, to warm up the pressure of standard atmosphere at sea level, from 19,5 °C on 20,5 °C.',
  },
  {
    key: 'N70',
    label: 'quad (1015 BtuIT)',
    Description:
      'Unit of heat energy according to the imperial system of units.',
  },
  {
    key: 'N71',
    label: 'therm (EC)',
    Description:
      'Unit of heat energy in commercial use, within the EU defined: 1 thm (EC) = 100 000 BtuIT.',
  },
  {
    key: 'N72',
    label: 'therm (U.S.)',
    Description: 'Unit of heat energy in commercial use.',
  },
  {
    key: 'D35',
    label: 'calorie (thermochemical)',
    Description: '',
  },
  {
    key: '2I',
    label: 'British thermal unit (international table) per hour',
    Description: '',
  },
  {
    key: 'J44',
    label: 'British thermal unit (international table) per minute',
    Description: '',
  },
  {
    key: 'J45',
    label: 'British thermal unit (international table) per second',
    Description: '',
  },
  {
    key: 'J47',
    label: 'British thermal unit (thermochemical) per hour',
    Description: '',
  },
  {
    key: 'J51',
    label: 'British thermal unit (thermochemical) per minute',
    Description: '',
  },
  {
    key: 'J52',
    label: 'British thermal unit (thermochemical) per second',
    Description: '',
  },
  {
    key: 'J81',
    label: 'calorie (thermochemical) per minute',
    Description: '',
  },
  {
    key: 'J82',
    label: 'calorie (thermochemical) per second',
    Description: '',
  },
  {
    key: 'E15',
    label: 'kilocalorie (thermochemical) per hour',
    Description: '',
  },
  {
    key: 'K54',
    label: 'kilocalorie (thermochemical) per minute',
    Description: '',
  },
  {
    key: 'K55',
    label: 'kilocalorie (thermochemical) per second',
    Description: '',
  },
  {
    key: 'D54',
    label: 'watt per square metre',
    Description: '',
  },
  {
    key: 'N48',
    label: 'watt per square centimetre ',
    Description:
      'Derived SI unit watt divided by the power of the 0,01-fold the SI base unit metre by exponent 2.',
  },
  {
    key: 'N49',
    label: 'watt per square inch ',
    Description:
      'Derived SI unit watt divided by the power of the unit inch according to the Anglo-American and Imperial system of units by exponent 2.',
  },
  {
    key: 'N50',
    label: 'British thermal unit (international table) per square foot hour',
    Description:
      'Unit of the surface heat flux according to the Imperial system of units.',
  },
  {
    key: 'N51',
    label: 'British thermal unit (thermochemical) per square foot hour',
    Description:
      'Unit of the surface heat flux according to the Imperial system of units.',
  },
  {
    key: 'N52',
    label: 'British thermal unit (thermochemical) per square foot minute',
    Description:
      'Unit of the surface heat flux according to the Imperial system of units.',
  },
  {
    key: 'N53',
    label: 'British thermal unit (international table) per square foot second',
    Description:
      'Unit of the surface heat flux according to the Imperial system of units.',
  },
  {
    key: 'N54',
    label: 'British thermal unit (thermochemical) per square foot second',
    Description:
      'Unit of the surface heat flux according to the Imperial system of units.',
  },
  {
    key: 'N55',
    label: 'British thermal unit (international table) per square inch second',
    Description:
      'Unit of the surface heat flux according to the Imperial system of units.',
  },
  {
    key: 'N56',
    label: 'calorie (thermochemical) per square centimetre minute',
    Description:
      'Unit of the surface heat flux according to the Imperial system of units.',
  },
  {
    key: 'N57',
    label: 'calorie (thermochemical) per square centimetre second',
    Description:
      'Unit of the surface heat flux according to the Imperial system of units.',
  },
  {
    key: 'D53',
    label: 'watt per metre kelvin',
    Description: '',
  },
  {
    key: 'N80',
    label: 'watt per metre degree Celsius',
    Description:
      'Derived SI unit watt divided by the product of the SI base unit metre and the unit for temperature degree Celsius.',
  },
  {
    key: 'N81',
    label: 'kilowatt per metre kelvin',
    Description:
      '1000-fold of the derived SI unit watt divided by the product of the SI base unit metre and the SI base unit kelvin.',
  },
  {
    key: 'N82',
    label: 'kilowatt per metre degree Celsius',
    Description:
      '1000-fold of the derived SI unit watt divided by the product of the SI base unit metre and the unit for temperature degree Celsius.',
  },
  {
    key: 'A22',
    label:
      'British thermal unit (international table) per second foot degree Rankine',
    Description: '',
  },
  {
    key: 'D71',
    label: 'calorie (international table) per second centimetre kelvin',
    Description: '',
  },
  {
    key: 'D38',
    label: 'calorie (thermochemical) per second centimetre kelvin',
    Description: '',
  },
  {
    key: 'J40',
    label:
      'British thermal unit (international table) foot per hour square foot degree Fahrenheit',
    Description: '',
  },
  {
    key: 'J41',
    label:
      'British thermal unit (international table) inch per hour square foot degree Fahrenheit',
    Description: '',
  },
  {
    key: 'J42',
    label:
      'British thermal unit (international table) inch per second square foot degree Fahrenheit',
    Description: '',
  },
  {
    key: 'J46',
    label:
      'British thermal unit (thermochemical) foot per hour square foot degree Fahrenheit',
    Description: '',
  },
  {
    key: 'J48',
    label:
      'British thermal unit (thermochemical) inch per hour square foot degree Fahrenheit',
    Description: '',
  },
  {
    key: 'J49',
    label:
      'British thermal unit (thermochemical) inch per second square foot degree Fahrenheit',
    Description: '',
  },
  {
    key: 'J78',
    label: 'calorie (thermochemical) per centimetre second degree Celsius',
    Description: '',
  },
  {
    key: 'K52',
    label: 'kilocalorie (international table) per hour metre degree Celsius',
    Description: '',
  },
  {
    key: 'D55',
    label: 'watt per square metre kelvin',
    Description: '',
  },
  {
    key: 'N78',
    label: 'kilowatt per square metre kelvin',
    Description:
      '1000-fold of the derived SI unit watt divided by the product of the power of the SI base unit metre by exponent 2 and the SI base unit kelvin.',
  },
  {
    key: 'D72',
    label: 'calorie (international table) per second square centimetre kelvin',
    Description: '',
  },
  {
    key: 'D39',
    label: 'calorie (thermochemical) per second square centimetre kelvin',
    Description: '',
  },
  {
    key: 'A20',
    label:
      'British thermal unit (international table) per second square foot degree Rankine',
    Description: '',
  },
  {
    key: 'A23',
    label:
      'British thermal unit (international table) per hour square foot degree Rankine',
    Description: '',
  },
  {
    key: 'N74',
    label:
      'British thermal unit (international table) per hour square foot degree Fahrenheit',
    Description:
      'Unit of the heat transition coefficient according to the Imperial system of units.',
  },
  {
    key: 'N75',
    label:
      'British thermal unit (thermochemical) per hour square foot degree Fahrenheit',
    Description:
      'Unit of the heat transition coefficient according to the imperial system of units.',
  },
  {
    key: 'N76',
    label:
      'British thermal unit (international table) per second square foot degree Fahrenheit',
    Description:
      'Unit of the heat transition coefficient according to the imperial system of units.',
  },
  {
    key: 'N77',
    label:
      'British thermal unit (thermochemical) per second square foot degree Fahrenheit',
    Description:
      'Unit of the heat transition coefficient according to the imperial system of units.',
  },
  {
    key: 'D19',
    label: 'square metre kelvin per watt',
    Description: '',
  },
  {
    key: 'J19',
    label:
      'degree Fahrenheit hour square foot per British thermal unit (thermochemical)',
    Description: '',
  },
  {
    key: 'J22',
    label:
      'degree Fahrenheit hour square foot per British thermal unit (international table)',
    Description: '',
  },
  {
    key: 'J83',
    label: 'clo',
    Description: '',
  },
  {
    key: 'L14',
    label:
      'square metre hour degree Celsius per kilocalorie (international table)',
    Description: '',
  },
  {
    key: 'B21',
    label: 'kelvin per watt',
    Description: '',
  },
  {
    key: 'H35',
    label: 'kelvin metre per watt',
    Description: '',
  },
  {
    key: 'N84',
    label:
      'degree Fahrenheit hour per British thermal unit (international table)',
    Description:
      'Non SI-conforming unit of the thermal resistance according to the Imperial system of units.',
  },
  {
    key: 'N85',
    label: 'degree Fahrenheit hour per British thermal unit (thermochemical)',
    Description:
      'Non SI-conforming unit of the thermal resistance according to the Imperial system of units.',
  },
  {
    key: 'N86',
    label:
      'degree Fahrenheit second per British thermal unit (international table)',
    Description:
      'Non SI-conforming unit of the thermal resistance according to the Imperial system of units.',
  },
  {
    key: 'N87',
    label: 'degree Fahrenheit second per British thermal unit (thermochemical)',
    Description:
      'Non SI-conforming unit of the thermal resistance according to the Imperial system of units.',
  },
  {
    key: 'N88',
    label:
      'degree Fahrenheit hour square foot per British thermal unit (international table) inch',
    Description:
      'Unit of specific thermal resistance according to the Imperial system of units.',
  },
  {
    key: 'N89',
    label:
      'degree Fahrenheit hour square foot per British thermal unit (thermochemical) inch',
    Description:
      'Unit of specific thermal resistance according to the Imperial system of units.',
  },
  {
    key: 'D52',
    label: 'watt per kelvin',
    Description: '',
  },
  {
    key: 'E97',
    label: 'millimetre per degree Celcius metre',
    Description: '',
  },
  {
    key: 'F53',
    label: 'millimetre per kelvin',
    Description: '',
  },
  {
    key: 'N83',
    label: 'metre per degree Celcius metre',
    Description:
      'SI base unit metre divided by the product of the unit degree Celsius and the SI base unit metre.',
  },
  {
    key: 'JE',
    label: 'joule per kelvin',
    Description: '',
  },
  {
    key: 'B41',
    label: 'kilojoule per kelvin',
    Description: '',
  },
  {
    key: 'J43',
    label:
      'British thermal unit (international table) per pound degree Fahrenheit',
    Description: '',
  },
  {
    key: 'J50',
    label: 'British thermal unit (thermochemical) per pound degree Fahrenheit',
    Description: '',
  },
  {
    key: 'J76',
    label: 'calorie (international table) per gram degree Celsius',
    Description: '',
  },
  {
    key: 'J79',
    label: 'calorie (thermochemical) per gram degree Celsius',
    Description: '',
  },
  {
    key: 'N60',
    label: 'British thermal unit (international table) per degree Fahrenheit',
    Description:
      'Unit of the heat capacity according to the Imperial system of units.',
  },
  {
    key: 'N61',
    label: 'British thermal unit (thermochemical) per degree Fahrenheit',
    Description:
      'Unit of the heat capacity according to the Imperial system of units.',
  },
  {
    key: 'N62',
    label: 'British thermal unit (international table) per degree Rankine',
    Description:
      'Unit of the heat capacity according to the Imperial system of units.',
  },
  {
    key: 'N63',
    label: 'British thermal unit (thermochemical) per degree Rankine',
    Description:
      'Unit of the heat capacity according to the Imperial system of units.',
  },
  {
    key: 'N64',
    label: 'British thermal unit (thermochemical) per pound degree Rankine',
    Description:
      'Unit of the heat capacity (British thermal unit according to the international table according to the Rankine degree) according to the Imperial system of units divided by the unit avoirdupois pound according to the avoirdupois system of units.',
  },
  {
    key: 'N65',
    label: 'kilocalorie (international table) per gram kelvin',
    Description:
      'Unit of the mass-related heat capacity as quotient 1000-fold of the calorie (international table) divided by the product of the 0,001-fold of the SI base units kilogram and kelvin.',
  },
  {
    key: 'B11',
    label: 'joule per kilogram kelvin',
    Description: '',
  },
  {
    key: 'B43',
    label: 'kilojoule per kilogram kelvin',
    Description: '',
  },
  {
    key: 'A21',
    label:
      'British thermal unit (international table) per pound degree Rankine',
    Description: '',
  },
  {
    key: 'D76',
    label: 'calorie (international table) per gram kelvin',
    Description: '',
  },
  {
    key: 'D37',
    label: 'calorie (thermochemical) per gram kelvin',
    Description: '',
  },
  {
    key: 'J2',
    label: 'joule per kilogram',
    Description: '',
  },
  {
    key: 'D95',
    label: 'joule per gram',
    Description: '',
  },
  {
    key: 'JK',
    label: 'megajoule per kilogram',
    Description: '',
  },
  {
    key: 'B42',
    label: 'kilojoule per kilogram',
    Description: '',
  },
  {
    key: 'AZ',
    label: 'British thermal unit (international table) per pound',
    Description: '',
  },
  {
    key: 'D75',
    label: 'calorie (international table) per gram',
    Description: '',
  },
  {
    key: 'N73',
    label: 'British thermal unit (thermochemical) per pound',
    Description:
      'Unit of the heat energy according to the Imperial system of units divided the unit avoirdupois pound according to the avoirdupois system of units.',
  },
  {
    key: 'B36',
    label: 'calorie (thermochemical) per gram',
    Description: '',
  },
  {
    key: 'N58',
    label: 'British thermal unit (international table) per cubic foot ',
    Description:
      'Unit of the energy density according to the Imperial system of units.',
  },
  {
    key: 'N59',
    label: 'British thermal unit (thermochemical) per cubic foot',
    Description:
      'Unit of the energy density according to the Imperial system of units.',
  },
  {
    key: 'Q31',
    label: 'kilojoule per gram',
    Description: '',
  },
  {
    key: 'AMP',
    label: 'ampere',
    Description: '',
  },
  {
    key: 'B22',
    label: 'kiloampere',
    Description: '',
  },
  {
    key: 'H38',
    label: 'megaampere',
    Description: '',
  },
  {
    key: '4K',
    label: 'milliampere',
    Description: '',
  },
  {
    key: 'B84',
    label: 'microampere',
    Description: '',
  },
  {
    key: 'C39',
    label: 'nanoampere',
    Description: '',
  },
  {
    key: 'C70',
    label: 'picoampere',
    Description: '',
  },
  {
    key: 'N96',
    label: 'biot',
    Description:
      'CGS (Centimetre-Gram-Second system) unit of the electric power which is defined by a force of 2 dyn per cm between two parallel conductors of infinite length with negligible cross-section in the distance of 1 cm.',
  },
  {
    key: 'N97',
    label: 'gilbert',
    Description:
      'CGS (Centimetre-Gram-Second system) unit of the magnetomotive force, which is defined by the work to increase the magnetic potential of a positive common pol with 1 erg.',
  },
  {
    key: 'COU',
    label: 'coulomb',
    Description: '',
  },
  {
    key: 'A8',
    label: 'ampere second',
    Description: '',
  },
  {
    key: 'H32',
    label: 'ampere squared second',
    Description: '',
  },
  {
    key: 'AMH',
    label: 'ampere hour',
    Description:
      'A unit of electric charge defining the amount of charge accumulated by a steady flow of one ampere for one hour.',
  },
  {
    key: 'TAH',
    label: 'kiloampere hour (thousand ampere hour)',
    Description: '',
  },
  {
    key: 'D77',
    label: 'megacoulomb',
    Description: '',
  },
  {
    key: 'D86',
    label: 'millicoulomb',
    Description: '',
  },
  {
    key: 'B26',
    label: 'kilocoulomb',
    Description: '',
  },
  {
    key: 'B86',
    label: 'microcoulomb',
    Description: '',
  },
  {
    key: 'C40',
    label: 'nanocoulomb',
    Description: '',
  },
  {
    key: 'C71',
    label: 'picocoulomb',
    Description: '',
  },
  {
    key: 'E09',
    label: 'milliampere hour',
    Description:
      'A unit of power load delivered at the rate of one thousandth of an ampere over a period of one hour.',
  },
  {
    key: 'N95',
    label: 'ampere minute',
    Description:
      'A unit of electric charge defining the amount of charge accumulated by a steady flow of one ampere for one minute..',
  },
  {
    key: 'N94',
    label: 'franklin',
    Description:
      'CGS (Centimetre-Gram-Second system) unit of the electrical charge, where the charge amounts to exactly 1 Fr where the force of 1 dyn on an equal load is performed at a distance of 1 cm.',
  },
  {
    key: 'A29',
    label: 'coulomb per cubic metre',
    Description: '',
  },
  {
    key: 'A84',
    label: 'gigacoulomb per cubic metre',
    Description: '',
  },
  {
    key: 'A30',
    label: 'coulomb per cubic millimetre',
    Description: '',
  },
  {
    key: 'B69',
    label: 'megacoulomb per cubic metre',
    Description: '',
  },
  {
    key: 'A28',
    label: 'coulomb per cubic centimetre',
    Description: '',
  },
  {
    key: 'B27',
    label: 'kilocoulomb per cubic metre',
    Description: '',
  },
  {
    key: 'D88',
    label: 'millicoulomb per cubic metre',
    Description: '',
  },
  {
    key: 'B87',
    label: 'microcoulomb per cubic metre',
    Description: '',
  },
  {
    key: 'A34',
    label: 'coulomb per square metre',
    Description: '',
  },
  {
    key: 'B70',
    label: 'megacoulomb per square metre',
    Description: '',
  },
  {
    key: 'A35',
    label: 'coulomb per square millimetre',
    Description: '',
  },
  {
    key: 'A33',
    label: 'coulomb per square centimetre',
    Description: '',
  },
  {
    key: 'B28',
    label: 'kilocoulomb per square metre',
    Description: '',
  },
  {
    key: 'D89',
    label: 'millicoulomb per square metre',
    Description: '',
  },
  {
    key: 'B88',
    label: 'microcoulomb per square metre',
    Description: '',
  },
  {
    key: 'D50',
    label: 'volt per metre',
    Description: '',
  },
  {
    key: 'H45',
    label: 'volt second per metre',
    Description: '',
  },
  {
    key: 'D45',
    label: 'volt squared per kelvin squared',
    Description: '',
  },
  {
    key: 'D51',
    label: 'volt per millimetre',
    Description: '',
  },
  {
    key: 'H24',
    label: 'volt per microsecond',
    Description: '',
  },
  {
    key: 'H62',
    label: 'millivolt per minute',
    Description: '',
  },
  {
    key: 'H46',
    label: 'volt per second',
    Description: '',
  },
  {
    key: 'B79',
    label: 'megavolt per metre',
    Description: '',
  },
  {
    key: 'B55',
    label: 'kilovolt per metre',
    Description: '',
  },
  {
    key: 'D47',
    label: 'volt per centimetre',
    Description: '',
  },
  {
    key: 'C30',
    label: 'millivolt per metre',
    Description: '',
  },
  {
    key: 'C3',
    label: 'microvolt per metre',
    Description: '',
  },
  {
    key: 'G60',
    label: 'volt per bar',
    Description: '',
  },
  {
    key: 'N98',
    label: 'volt per pascal',
    Description: 'Derived SI unit volt divided by the derived SI unit pascal.',
  },
  {
    key: 'F87',
    label: 'volt per litre minute',
    Description: '',
  },
  {
    key: 'H22',
    label: 'volt square inch per pound-force',
    Description: '',
  },
  {
    key: 'H23',
    label: 'volt per inch',
    Description: '',
  },
  {
    key: 'VLT',
    label: 'volt',
    Description: '',
  },
  {
    key: 'B78',
    label: 'megavolt',
    Description: '',
  },
  {
    key: 'KVT',
    label: 'kilovolt',
    Description: '',
  },
  {
    key: '2Z',
    label: 'millivolt',
    Description: '',
  },
  {
    key: 'D82',
    label: 'microvolt',
    Description: '',
  },
  {
    key: 'N99',
    label: 'picovolt',
    Description: '0,000 000 000 001-fold of the derived SI unit volt.',
  },
  {
    key: 'FAR',
    label: 'farad',
    Description: '',
  },
  {
    key: 'H48',
    label: 'attofarad',
    Description: '',
  },
  {
    key: 'C10',
    label: 'millifarad',
    Description: '',
  },
  {
    key: '4O',
    label: 'microfarad',
    Description: '',
  },
  {
    key: 'C41',
    label: 'nanofarad',
    Description: '',
  },
  {
    key: '4T',
    label: 'picofarad',
    Description: '',
  },
  {
    key: 'N90',
    label: 'kilofarad',
    Description: '1000-fold of the derived SI unit farad.',
  },
  {
    key: 'A69',
    label: 'farad per metre',
    Description: '',
  },
  {
    key: 'H28',
    label: 'microfarad per kilometre',
    Description: '',
  },
  {
    key: 'H33',
    label: 'farad per kilometre',
    Description: '',
  },
  {
    key: 'B89',
    label: 'microfarad per metre',
    Description: '',
  },
  {
    key: 'C42',
    label: 'nanofarad per metre',
    Description: '',
  },
  {
    key: 'C72',
    label: 'picofarad per metre',
    Description: '',
  },
  {
    key: 'A26',
    label: 'coulomb metre',
    Description: '',
  },
  {
    key: 'A41',
    label: 'ampere per square metre',
    Description: '',
  },
  {
    key: 'H31',
    label: 'ampere per kilogram',
    Description: '',
  },
  {
    key: 'B66',
    label: 'megaampere per square metre',
    Description: '',
  },
  {
    key: 'A7',
    label: 'ampere per square millimetre',
    Description: '',
  },
  {
    key: 'A4',
    label: 'ampere per square centimetre',
    Description: '',
  },
  {
    key: 'B23',
    label: 'kiloampere per square metre',
    Description: '',
  },
  {
    key: 'G59',
    label: 'milliampere per litre minute',
    Description: '',
  },
  {
    key: 'N93',
    label: 'ampere per pascal',
    Description: 'SI base unit ampere divided by the derived SI unit pascal.',
  },
  {
    key: 'F57',
    label: 'milliampere per pound-force per square inch',
    Description: '',
  },
  {
    key: 'F59',
    label: 'milliampere per bar',
    Description: '',
  },
  {
    key: 'AE',
    label: 'ampere per metre',
    Description: '',
  },
  {
    key: 'B24',
    label: 'kiloampere per metre',
    Description: '',
  },
  {
    key: 'A3',
    label: 'ampere per millimetre',
    Description: '',
  },
  {
    key: 'A2',
    label: 'ampere per centimetre',
    Description: '',
  },
  {
    key: 'F76',
    label: 'milliampere per millimetre',
    Description: '',
  },
  {
    key: 'F08',
    label: 'milliampere per inch',
    Description: '',
  },
  {
    key: 'P10',
    label: 'coulomb per metre',
    Description: 'Derived SI unit coulomb divided by the SI base unit metre.',
  },
  {
    key: 'D33',
    label: 'tesla',
    Description: '',
  },
  {
    key: 'C29',
    label: 'millitesla',
    Description: '',
  },
  {
    key: 'D81',
    label: 'microtesla',
    Description: '',
  },
  {
    key: 'C48',
    label: 'nanotesla',
    Description: '',
  },
  {
    key: 'P13',
    label: 'kilotesla',
    Description: '1000-fold of the derived SI unit tesla.',
  },
  {
    key: 'P12',
    label: 'gamma',
    Description: 'Unit of magnetic flow density.',
  },
  {
    key: 'WEB',
    label: 'weber',
    Description: '',
  },
  {
    key: 'C33',
    label: 'milliweber',
    Description: '',
  },
  {
    key: 'P11',
    label: 'kiloweber',
    Description: '1000 fold of the derived SI unit weber.',
  },
  {
    key: 'D59',
    label: 'weber per metre',
    Description: '',
  },
  {
    key: 'B56',
    label: 'kiloweber per metre',
    Description: '',
  },
  {
    key: 'D60',
    label: 'weber per millimetre',
    Description: '',
  },
  {
    key: '81',
    label: 'henry',
    Description: '',
  },
  {
    key: 'C14',
    label: 'millihenry',
    Description: '',
  },
  {
    key: 'B90',
    label: 'microhenry',
    Description: '',
  },
  {
    key: 'C43',
    label: 'nanohenry',
    Description: '',
  },
  {
    key: 'C73',
    label: 'picohenry',
    Description: '',
  },
  {
    key: 'H03',
    label: 'henry per kiloohm',
    Description: '',
  },
  {
    key: 'H04',
    label: 'henry per ohm',
    Description: '',
  },
  {
    key: 'G98',
    label: 'microhenry per kiloohm',
    Description: '',
  },
  {
    key: 'G99',
    label: 'microhenry per ohm',
    Description: '',
  },
  {
    key: 'H05',
    label: 'millihenry per kiloohm',
    Description: '',
  },
  {
    key: 'H06',
    label: 'millihenry per ohm',
    Description: '',
  },
  {
    key: 'P24',
    label: 'kilohenry',
    Description: '1000-fold of the derived SI unit henry.',
  },
  {
    key: 'A98',
    label: 'henry per metre',
    Description: '',
  },
  {
    key: 'B91',
    label: 'microhenry per metre',
    Description: '',
  },
  {
    key: 'C44',
    label: 'nanohenry per metre',
    Description: '',
  },
  {
    key: 'A5',
    label: 'ampere square metre',
    Description: '',
  },
  {
    key: 'B8',
    label: 'joule per cubic metre',
    Description: '',
  },
  {
    key: 'OHM',
    label: 'ohm',
    Description: '',
  },
  {
    key: 'A87',
    label: 'gigaohm',
    Description: '',
  },
  {
    key: 'B75',
    label: 'megaohm',
    Description: '',
  },
  {
    key: 'H44',
    label: 'teraohm',
    Description: '',
  },
  {
    key: 'B49',
    label: 'kiloohm',
    Description: '',
  },
  {
    key: 'E45',
    label: 'milliohm',
    Description: '',
  },
  {
    key: 'B94',
    label: 'microohm',
    Description: '',
  },
  {
    key: 'P22',
    label: 'nanoohm',
    Description: '0,000 000 001-fold of the derived SI unit ohm.',
  },
  {
    key: 'M26',
    label: 'gigaohm per metre',
    Description: '',
  },
  {
    key: 'SIE',
    label: 'siemens',
    Description: '',
  },
  {
    key: 'B53',
    label: 'kilosiemens',
    Description: '',
  },
  {
    key: 'C27',
    label: 'millisiemens',
    Description: '',
  },
  {
    key: 'B99',
    label: 'microsiemens',
    Description: '',
  },
  {
    key: 'G42',
    label: 'microsiemens per centimetre',
    Description: '',
  },
  {
    key: 'G43',
    label: 'microsiemens per metre',
    Description: '',
  },
  {
    key: 'N92',
    label: 'picosiemens',
    Description: '0,000 000 000 001-fold of the derived SI unit siemens.',
  },
  {
    key: 'NQ',
    label: 'mho',
    Description: '',
  },
  {
    key: 'NR',
    label: 'micromho',
    Description: '',
  },
  {
    key: 'C61',
    label: 'ohm metre',
    Description: '',
  },
  {
    key: 'A88',
    label: 'gigaohm metre',
    Description: '',
  },
  {
    key: 'B76',
    label: 'megaohm metre',
    Description: '',
  },
  {
    key: 'H88',
    label: 'megaohm kilometre',
    Description: '',
  },
  {
    key: 'B50',
    label: 'kiloohm metre',
    Description: '',
  },
  {
    key: 'C60',
    label: 'ohm centimetre',
    Description: '',
  },
  {
    key: 'C23',
    label: 'milliohm metre',
    Description: '',
  },
  {
    key: 'B95',
    label: 'microohm metre',
    Description: '',
  },
  {
    key: 'C46',
    label: 'nanoohm metre',
    Description: '',
  },
  {
    key: 'M24',
    label: 'ohm kilometre',
    Description: '',
  },
  {
    key: 'P23',
    label: 'ohm circular-mil per foot ',
    Description: 'Unit of resistivity.',
  },
  {
    key: 'F56',
    label: 'ohm per kilometre',
    Description: '',
  },
  {
    key: 'H26',
    label: 'ohm per metre',
    Description: '',
  },
  {
    key: 'H37',
    label: 'megaohm per metre',
    Description: '',
  },
  {
    key: 'F54',
    label: 'milliohm per metre',
    Description: '',
  },
  {
    key: 'H36',
    label: 'megaohm per kilometre',
    Description: '',
  },
  {
    key: 'F55',
    label: 'ohm per mile (statute mile)',
    Description: '',
  },
  {
    key: 'D10',
    label: 'siemens per metre',
    Description: '',
  },
  {
    key: 'H43',
    label: 'siemens per centimetre',
    Description: '',
  },
  {
    key: 'H61',
    label: 'millisiemens per centimetre',
    Description: '',
  },
  {
    key: 'B77',
    label: 'megasiemens per metre',
    Description: '',
  },
  {
    key: 'B54',
    label: 'kilosiemens per metre',
    Description: '',
  },
  {
    key: 'G45',
    label: 'nanosiemens per metre',
    Description: '',
  },
  {
    key: 'G44',
    label: 'nanosiemens per centimetre',
    Description: '',
  },
  {
    key: 'L42',
    label: 'picosiemens per metre',
    Description: '',
  },
  {
    key: 'C89',
    label: 'reciprocal henry',
    Description: '',
  },
  {
    key: 'P14',
    label: 'joule per second',
    Description:
      'Quotient of the derived SI unit joule divided by the SI base unit second.',
  },
  {
    key: 'D31',
    label: 'terawatt',
    Description: '',
  },
  {
    key: 'P15',
    label: 'joule per minute',
    Description:
      'Quotient from the derived SI unit joule divided by the unit minute.',
  },
  {
    key: 'P16',
    label: 'joule per hour',
    Description:
      'Quotient from the derived SI unit joule divided by the unit hour.',
  },
  {
    key: 'P17',
    label: 'joule per day',
    Description:
      'Quotient from the derived SI unit joule divided by the unit day.',
  },
  {
    key: 'P18',
    label: 'kilojoule per second',
    Description:
      'Quotient from the 1000-fold of the derived SI unit joule divided by the SI base unit second.',
  },
  {
    key: 'P19',
    label: 'kilojoule per minute',
    Description:
      'Quotient from the 1000-fold of the derived SI unit joule divided by the unit minute.',
  },
  {
    key: 'P20',
    label: 'kilojoule per hour',
    Description:
      'Quotient from the 1000-fold of the derived SI unit joule divided by the unit hour.',
  },
  {
    key: 'P21',
    label: 'kilojoule per day',
    Description:
      'Quotient from the 1000-fold of the derived SI unit joule divided by the unit day.',
  },
  {
    key: 'K43',
    label: 'horsepower (electric)',
    Description: '',
  },
  {
    key: 'C49',
    label: 'nanowatt',
    Description: '',
  },
  {
    key: 'C75',
    label: 'picowatt',
    Description: '',
  },
  {
    key: 'D46',
    label: 'volt - ampere',
    Description: '',
  },
  {
    key: 'MVA',
    label: 'megavolt - ampere',
    Description: '',
  },
  {
    key: 'KVA',
    label: 'kilovolt - ampere',
    Description: '',
  },
  {
    key: 'M35',
    label: 'millivolt - ampere',
    Description: '',
  },
  {
    key: 'D44',
    label: 'var',
    Description: 'The name of the unit is an acronym for volt-ampere-reactive.',
  },
  {
    key: 'K5',
    label: 'kilovolt ampere (reactive)',
    Description: 'Use kilovar (common code KVR)',
  },
  {
    key: 'KVR',
    label: 'kilovar',
    Description: '',
  },
  {
    key: 'MAR',
    label: 'megavar',
    Description:
      'A unit of electrical reactive power represented by a current of one thousand amperes flowing due a potential difference of one thousand volts where the sine of the phase angle between them is 1.',
  },
  {
    key: 'N91',
    label: 'reciprocal joule',
    Description: 'Reciprocal of the derived SI unit joule.',
  },
  {
    key: 'M30',
    label: 'reciprocal volt - ampere reciprocal second',
    Description: '',
  },
  {
    key: 'M17',
    label: 'kilohertz metre',
    Description: '',
  },
  {
    key: 'M18',
    label: 'gigahertz metre',
    Description: '',
  },
  {
    key: 'M27',
    label: 'megahertz metre',
    Description: '',
  },
  {
    key: 'M21',
    label: 'reciprocal kilovolt - ampere reciprocal hour',
    Description: '',
  },
  {
    key: 'H34',
    label: 'hertz metre',
    Description: '',
  },
  {
    key: 'H39',
    label: 'megahertz kilometre',
    Description: '',
  },
  {
    key: 'C84',
    label: 'radian per metre',
    Description: '',
  },
  {
    key: 'JM',
    label: 'megajoule per cubic metre',
    Description: '',
  },
  {
    key: 'B14',
    label: 'joule per metre to the fourth power',
    Description: '',
  },
  {
    key: 'B13',
    label: 'joule per square metre',
    Description: 'Synonym: joule per metre squared',
  },
  {
    key: 'D1',
    label: 'reciprocal second per steradian',
    Description: '',
  },
  {
    key: 'D2',
    label: 'reciprocal second per steradian metre squared',
    Description: '',
  },
  {
    key: 'C99',
    label: 'reciprocal second per metre squared',
    Description: '',
  },
  {
    key: 'C93',
    label: 'reciprocal square metre',
    Description: 'Synonym: reciprocal metre squared',
  },
  {
    key: 'H47',
    label: 'watt per cubic metre',
    Description: '',
  },
  {
    key: 'H74',
    label: 'watt per metre',
    Description: '',
  },
  {
    key: 'E43',
    label: 'joule per square centimetre',
    Description:
      'A unit of energy defining the number of joules per square centimetre.',
  },
  {
    key: 'P37',
    label: 'British thermal unit (international table) per square foot',
    Description:
      'Unit of the areal-related energy transmission according to the Imperial system of units.',
  },
  {
    key: 'P38',
    label: 'British thermal unit (thermochemical) per square foot',
    Description:
      'Unit of the areal-related energy transmission according to the Imperial system of units.',
  },
  {
    key: 'P39',
    label: 'calorie (thermochemical) per square centimetre ',
    Description:
      'Unit of the areal-related energy transmission according to the Imperial system of units.',
  },
  {
    key: 'P40',
    label: 'langley',
    Description:
      "CGS (Centimetre-Gram-Second system) unit of the areal-related energy transmission (as a measure of the incident quantity of heat of solar radiation on the earth's surface).",
  },
  {
    key: 'D57',
    label: 'watt per steradian',
    Description: '',
  },
  {
    key: 'D58',
    label: 'watt per steradian square metre',
    Description: '',
  },
  {
    key: 'D56',
    label: 'watt per square metre kelvin to the fourth power',
    Description: '',
  },
  {
    key: 'D18',
    label: 'metre kelvin',
    Description: '',
  },
  {
    key: 'CDL',
    label: 'candela',
    Description: '',
  },
  {
    key: 'P33',
    label: 'kilocandela',
    Description: '1000-fold of the SI base unit candela.',
  },
  {
    key: 'P34',
    label: 'millicandela',
    Description: '0,001-fold of the SI base unit candela.',
  },
  {
    key: 'P35',
    label: 'Hefner-Kerze',
    Description:
      'Obsolete, non-legal unit of the power in Germany relating to DIN 1301-3:1979: 1 HK = 0,903 cd.',
  },
  {
    key: 'P36',
    label: 'international candle ',
    Description:
      'Obsolete, non-legal unit of the power in Germany relating to DIN 1301-3:1979: 1 HK = 1,019 cd.',
  },
  {
    key: 'LUM',
    label: 'lumen',
    Description: '',
  },
  {
    key: 'B62',
    label: 'lumen second',
    Description: '',
  },
  {
    key: 'B59',
    label: 'lumen hour',
    Description: '',
  },
  {
    key: 'A24',
    label: 'candela per square metre',
    Description: '',
  },
  {
    key: 'P28',
    label: 'candela per square inch ',
    Description:
      'SI base unit candela divided by the power of unit inch according to the Anglo-American and Imperial system of units by exponent 2.',
  },
  {
    key: 'P29',
    label: 'footlambert',
    Description:
      'Unit of the luminance according to the Anglo-American system of units, defined as emitted or reflected luminance of a lm/ft².',
  },
  {
    key: 'P30',
    label: 'lambert',
    Description:
      'CGS (Centimetre-Gram-Second system) unit of luminance, defined as the emitted or reflected luminance by one lumen per square centimetre.',
  },
  {
    key: 'P31',
    label: 'stilb',
    Description:
      'CGS (Centimetre-Gram-Second system) unit of luminance, defined as emitted or reflected luminance by one lumen per square centimetre.',
  },
  {
    key: 'P32',
    label: 'candela per square foot',
    Description:
      'Base unit SI candela divided by the power of the unit foot according to the Anglo-American and Imperial system of units by exponent 2.',
  },
  {
    key: 'B60',
    label: 'lumen per square metre',
    Description: '',
  },
  {
    key: 'LUX',
    label: 'lux',
    Description: '',
  },
  {
    key: 'KLX',
    label: 'kilolux',
    Description: 'A unit of illuminance equal to one thousand lux.',
  },
  {
    key: 'P25',
    label: 'lumen per square foot ',
    Description:
      'Derived SI unit lumen divided by the power of the unit foot according to the Anglo-American and Imperial system of units by exponent 2.',
  },
  {
    key: 'P26',
    label: 'phot',
    Description:
      'CGS (Centimetre-Gram-Second system) unit of the illuminance, defined as lumen by square centimetre.',
  },
  {
    key: 'P27',
    label: 'footcandle',
    Description:
      'Non SI conform traditional unit, defined as density of light which impinges on a surface which has a distance of one foot from a light source, which shines with an intensity of an international candle.',
  },
  {
    key: 'B64',
    label: 'lux second',
    Description: '',
  },
  {
    key: 'B63',
    label: 'lux hour',
    Description: '',
  },
  {
    key: 'B61',
    label: 'lumen per watt',
    Description: '',
  },
  {
    key: 'D22',
    label: 'square metre per mole',
    Description: '',
  },
  {
    key: 'C59',
    label: 'octave',
    Description:
      'A unit used in music to describe the ratio in frequency between notes.',
  },
  {
    key: 'D9',
    label: 'dyne per square centimetre',
    Description: '',
  },
  {
    key: 'A60',
    label: 'erg per cubic centimetre',
    Description: '',
  },
  {
    key: 'C32',
    label: 'milliwatt per square metre',
    Description: '',
  },
  {
    key: 'D85',
    label: 'microwatt per square metre',
    Description: '',
  },
  {
    key: 'C76',
    label: 'picowatt per square metre',
    Description: '',
  },
  {
    key: 'A64',
    label: 'erg per second square centimetre',
    Description: '',
  },
  {
    key: 'C67',
    label: 'pascal second per metre',
    Description: '',
  },
  {
    key: 'A50',
    label: 'dyne second per cubic centimetre',
    Description: '',
  },
  {
    key: 'C66',
    label: 'pascal second per cubic metre',
    Description: '',
  },
  {
    key: 'A52',
    label: 'dyne second per centimetre to the fifth power',
    Description: '',
  },
  {
    key: 'M32',
    label: 'pascal second per litre',
    Description: '',
  },
  {
    key: 'C58',
    label: 'newton second per metre',
    Description: '',
  },
  {
    key: 'A51',
    label: 'dyne second per centimetre',
    Description: '',
  },
  {
    key: 'P43',
    label: 'bel per metre',
    Description: 'Unit bel divided by the SI base unit metre.',
  },
  {
    key: 'H51',
    label: 'decibel per kilometre',
    Description: '',
  },
  {
    key: 'H52',
    label: 'decibel per metre',
    Description: '',
  },
  {
    key: 'C69',
    label: 'phon',
    Description:
      'A unit of subjective sound loudness. A sound has loudness p phons if it seems to the listener to be equal in loudness to the sound of a pure tone of frequency 1 kilohertz and strength p decibels.',
  },
  {
    key: 'D15',
    label: 'sone',
    Description:
      'A unit of subjective sound loudness. One sone is the loudness of a pure tone of frequency one kilohertz and strength 40 decibels.',
  },
  {
    key: 'P42',
    label: 'pascal squared second',
    Description:
      'Unit of the set as a product of the power of derived SI unit pascal with exponent 2 and the SI base unit second.',
  },
  {
    key: 'P41',
    label: 'decade (logarithmic)',
    Description:
      '1 Dec := log2 10 ˜ 3,32 according to the logarithm for frequency range between f1 and f2, when f2/f1 = 10.',
  },
  {
    key: 'C34',
    label: 'mole',
    Description: '',
  },
  {
    key: 'B45',
    label: 'kilomole',
    Description: '',
  },
  {
    key: 'C18',
    label: 'millimole',
    Description: '',
  },
  {
    key: 'FH',
    label: 'micromole',
    Description: '',
  },
  {
    key: 'Z9',
    label: 'nanomole',
    Description: 'An SI unit of amount of substance equal to 10−9 moles',
  },
  {
    key: 'P44',
    label: 'pound mole',
    Description:
      'Non SI-conforming unit of quantity of a substance relating that one pound mole of a chemical composition corresponds to the same number of pounds as the molecular weight of one molecule of this composition in atomic mass units.',
  },
  {
    key: 'C95',
    label: 'reciprocal mole',
    Description: '',
  },
  {
    key: 'D74',
    label: 'kilogram per mole',
    Description: '',
  },
  {
    key: 'A94',
    label: 'gram per mole',
    Description: '',
  },
  {
    key: 'A40',
    label: 'cubic metre per mole',
    Description: '',
  },
  {
    key: 'A37',
    label: 'cubic decimetre per mole',
    Description: '',
  },
  {
    key: 'A36',
    label: 'cubic centimetre per mole',
    Description: '',
  },
  {
    key: 'B58',
    label: 'litre per mole',
    Description: '',
  },
  {
    key: 'B15',
    label: 'joule per mole',
    Description: '',
  },
  {
    key: 'B44',
    label: 'kilojoule per mole',
    Description: '',
  },
  {
    key: 'B16',
    label: 'joule per mole kelvin',
    Description: '',
  },
  {
    key: 'C86',
    label: 'reciprocal cubic metre',
    Description: '',
  },
  {
    key: 'H50',
    label: 'reciprocal cubic centimetre',
    Description: '',
  },
  {
    key: 'L20',
    label: 'reciprocal cubic millimetre',
    Description: '',
  },
  {
    key: 'K20',
    label: 'reciprocal cubic foot',
    Description: '',
  },
  {
    key: 'K49',
    label: 'reciprocal cubic inch',
    Description: '',
  },
  {
    key: 'K63',
    label: 'reciprocal litre',
    Description: '',
  },
  {
    key: 'M10',
    label: 'reciprocal cubic yard',
    Description: '',
  },
  {
    key: 'C36',
    label: 'mole per cubic metre',
    Description: '',
  },
  {
    key: 'C38',
    label: 'mole per litre',
    Description: '',
  },
  {
    key: 'C35',
    label: 'mole per cubic decimetre',
    Description: '',
  },
  {
    key: 'B46',
    label: 'kilomole per cubic metre',
    Description: '',
  },
  {
    key: 'E95',
    label: 'mole per second',
    Description: '',
  },
  {
    key: 'M33',
    label: 'millimole per litre',
    Description: '',
  },
  {
    key: 'P51',
    label: 'mol per kilogram pascal',
    Description:
      'SI base unit mol divided by the product of the SI base unit kilogram and the derived SI unit pascal.',
  },
  {
    key: 'P52',
    label: 'mol per cubic metre pascal',
    Description:
      'SI base unit mol divided by the product of the power from the SI base unit metre with exponent 3 and the derived SI unit pascal.',
  },
  {
    key: 'K59',
    label: 'kilomole per cubic metre kelvin',
    Description: '',
  },
  {
    key: 'K60',
    label: 'kilomole per cubic metre bar',
    Description: '',
  },
  {
    key: 'K93',
    label: 'reciprocal psi',
    Description: '',
  },
  {
    key: 'L24',
    label: 'mole per kilogram kelvin',
    Description: '',
  },
  {
    key: 'L25',
    label: 'mole per kilogram bar',
    Description: '',
  },
  {
    key: 'L26',
    label: 'mole per litre kelvin',
    Description: '',
  },
  {
    key: 'L27',
    label: 'mole per litre bar',
    Description: '',
  },
  {
    key: 'L28',
    label: 'mole per cubic metre kelvin',
    Description: '',
  },
  {
    key: 'L29',
    label: 'mole per cubic metre bar',
    Description: '',
  },
  {
    key: 'C19',
    label: 'mole per kilogram',
    Description: '',
  },
  {
    key: 'D93',
    label: 'second per cubic metre',
    Description: '',
  },
  {
    key: 'D87',
    label: 'millimole per kilogram',
    Description: '',
  },
  {
    key: 'H68',
    label: 'millimole per gram',
    Description: '',
  },
  {
    key: 'P47',
    label: 'kilomole per kilogram',
    Description:
      '1000-fold of the SI base unit mol divided by the SI base unit kilogram.',
  },
  {
    key: 'P48',
    label: 'pound mole per pound',
    Description:
      'Non SI-conforming unit of the material molar flux divided by the avoirdupois pound for mass according to the avoirdupois unit system.',
  },
  {
    key: 'KAT',
    label: 'katal',
    Description:
      'A unit of catalytic activity defining the catalytic activity of enzymes and other catalysts.',
  },
  {
    key: 'E94',
    label: 'kilomole per second',
    Description: '',
  },
  {
    key: 'P45',
    label: 'pound mole per second',
    Description:
      'Non SI-conforming unit of the power of the amount of substance non-SI compliant unit of the molar flux relating that a pound mole of a chemical composition the same number of pound corresponds like the molecular weight of a molecule of this composition in atomic mass units.',
  },
  {
    key: 'P46',
    label: 'pound mole per minute',
    Description:
      'Non SI-conforming unit of the power of the amount of substance non-SI compliant unit of the molar flux relating that a pound mole of a chemical composition the same number of pound corresponds like the molecular weight of a molecule of this composition in atomic mass units.',
  },
  {
    key: 'D43',
    label: 'unified atomic mass unit',
    Description: '',
  },
  {
    key: 'A27',
    label: 'coulomb metre squared per volt',
    Description: '',
  },
  {
    key: 'A32',
    label: 'coulomb per mole',
    Description: '',
  },
  {
    key: 'D12',
    label: 'siemens square metre per mole',
    Description: '',
  },
  {
    key: 'K58',
    label: 'kilomole per hour',
    Description: '',
  },
  {
    key: 'K61',
    label: 'kilomole per minute',
    Description: '',
  },
  {
    key: 'L23',
    label: 'mole per hour',
    Description: '',
  },
  {
    key: 'L30',
    label: 'mole per minute',
    Description: '',
  },
  {
    key: 'C82',
    label: 'radian square metre per mole',
    Description: '',
  },
  {
    key: 'C83',
    label: 'radian square metre per kilogram',
    Description: '',
  },
  {
    key: 'P49',
    label: 'newton square metre per ampere',
    Description:
      'Product of the derived SI unit newton and the power of SI base unit metre with exponent 2 divided by the SI base unit ampere.',
  },
  {
    key: 'P50',
    label: 'weber metre',
    Description: 'Product of the derived SI unit weber and SI base unit metre.',
  },
  {
    key: 'Q30',
    label: 'pH (potential of Hydrogen)',
    Description:
      'The activity of the (solvated) hydrogen ion (a logarithmic measure used to state the acidity or alkalinity of a chemical solution).',
  },
  {
    key: 'B18',
    label: 'joule second',
    Description: '',
  },
  {
    key: 'A10',
    label: 'ampere square metre per joule second',
    Description: '',
  },
  {
    key: 'CUR',
    label: 'curie',
    Description: '',
  },
  {
    key: 'MCU',
    label: 'millicurie',
    Description: '',
  },
  {
    key: 'M5',
    label: 'microcurie',
    Description: '',
  },
  {
    key: '2R',
    label: 'kilocurie',
    Description: '',
  },
  {
    key: 'BQL',
    label: 'becquerel',
    Description: '',
  },
  {
    key: 'GBQ',
    label: 'gigabecquerel',
    Description: '',
  },
  {
    key: '2Q',
    label: 'kilobecquerel',
    Description: '',
  },
  {
    key: '4N',
    label: 'megabecquerel',
    Description: '',
  },
  {
    key: 'H08',
    label: 'microbecquerel',
    Description: '',
  },
  {
    key: 'A42',
    label: 'curie per kilogram',
    Description: '',
  },
  {
    key: 'A18',
    label: 'becquerel per kilogram',
    Description: '',
  },
  {
    key: 'B67',
    label: 'megabecquerel per kilogram',
    Description: '',
  },
  {
    key: 'B25',
    label: 'kilobecquerel per kilogram',
    Description: '',
  },
  {
    key: 'A19',
    label: 'becquerel per cubic metre',
    Description: '',
  },
  {
    key: 'A14',
    label: 'barn',
    Description: '',
  },
  {
    key: 'D24',
    label: 'square metre per steradian',
    Description: '',
  },
  {
    key: 'A17',
    label: 'barn per steradian',
    Description: '',
  },
  {
    key: 'D20',
    label: 'square metre per joule',
    Description: '',
  },
  {
    key: 'A15',
    label: 'barn per electronvolt',
    Description: '',
  },
  {
    key: 'D16',
    label: 'square centimetre per erg',
    Description: '',
  },
  {
    key: 'D25',
    label: 'square metre per steradian joule',
    Description: '',
  },
  {
    key: 'A16',
    label: 'barn per steradian electronvolt',
    Description: '',
  },
  {
    key: 'D17',
    label: 'square centimetre per steradian erg',
    Description: '',
  },
  {
    key: 'B81',
    label: 'reciprocal metre squared reciprocal second',
    Description: '',
  },
  {
    key: 'A65',
    label: 'erg per square centimetre second',
    Description: '',
  },
  {
    key: 'D21',
    label: 'square metre per kilogram',
    Description: '',
  },
  {
    key: 'B12',
    label: 'joule per metre',
    Description: '',
  },
  {
    key: 'A54',
    label: 'electronvolt per metre',
    Description: '',
  },
  {
    key: 'A58',
    label: 'erg per centimetre',
    Description: '',
  },
  {
    key: 'D73',
    label: 'joule square metre',
    Description: '',
  },
  {
    key: 'A55',
    label: 'electronvolt square metre',
    Description: '',
  },
  {
    key: 'A66',
    label: 'erg square centimetre',
    Description: '',
  },
  {
    key: 'B20',
    label: 'joule square metre per kilogram',
    Description: '',
  },
  {
    key: 'A56',
    label: 'electronvolt square metre per kilogram',
    Description: '',
  },
  {
    key: 'A67',
    label: 'erg square centimetre per gram',
    Description: '',
  },
  {
    key: 'D26',
    label: 'square metre per volt second',
    Description: '',
  },
  {
    key: 'H58',
    label: 'metre per volt second',
    Description: '',
  },
  {
    key: 'C98',
    label: 'reciprocal second per cubic metre',
    Description: '',
  },
  {
    key: 'C87',
    label: 'reciprocal cubic metre per second',
    Description: 'Synonym: reciprocal second per cubic metre',
  },
  {
    key: 'A95',
    label: 'gray',
    Description: '',
  },
  {
    key: 'C13',
    label: 'milligray',
    Description: '',
  },
  {
    key: 'C80',
    label: 'rad',
    Description: '',
  },
  {
    key: 'A61',
    label: 'erg per gram',
    Description: '',
  },
  {
    key: 'D13',
    label: 'sievert',
    Description: '',
  },
  {
    key: 'C28',
    label: 'millisievert',
    Description: '',
  },
  {
    key: 'D91',
    label: 'rem',
    Description: '',
  },
  {
    key: 'L31',
    label: 'milliroentgen aequivalent men',
    Description: '',
  },
  {
    key: 'A96',
    label: 'gray per second',
    Description: '',
  },
  {
    key: 'A62',
    label: 'erg per gram second',
    Description: '',
  },
  {
    key: 'CKG',
    label: 'coulomb per kilogram',
    Description: '',
  },
  {
    key: 'C8',
    label: 'millicoulomb per kilogram',
    Description: '',
  },
  {
    key: '2C',
    label: 'roentgen',
    Description: '',
  },
  {
    key: '2Y',
    label: 'milliroentgen',
    Description: '',
  },
  {
    key: 'J53',
    label: 'coulomb square metre per kilogram',
    Description: '',
  },
  {
    key: 'KR',
    label: 'kiloroentgen',
    Description: '',
  },
  {
    key: 'A31',
    label: 'coulomb per kilogram second',
    Description: '',
  },
  {
    key: 'D6',
    label: 'roentgen per second',
    Description: '',
  },
  {
    key: 'P54',
    label: 'milligray per second',
    Description:
      '0,001-fold of the derived SI unit gray divided by the SI base unit second.',
  },
  {
    key: 'P55',
    label: 'microgray per second',
    Description:
      '0,000 001-fold of the derived SI unit gray divided by the SI base unit second.',
  },
  {
    key: 'P56',
    label: 'nanogray per second',
    Description:
      '0,000 000 001-fold of the derived SI unit gray divided by the SI base unit second.',
  },
  {
    key: 'P57',
    label: 'gray per minute',
    Description: 'SI derived unit gray divided by the unit minute.',
  },
  {
    key: 'P58',
    label: 'milligray per minute',
    Description:
      '0,001-fold of the derived SI unit gray divided by the unit minute.',
  },
  {
    key: 'P59',
    label: 'microgray per minute',
    Description:
      '0,000 001-fold of the derived SI unit gray divided by the unit minute.',
  },
  {
    key: 'P60',
    label: 'nanogray per minute',
    Description:
      '0,000 000 001-fold of the derived SI unit gray divided by the unit minute.',
  },
  {
    key: 'P61',
    label: 'gray per hour',
    Description: 'SI derived unit gray divided by the unit hour.',
  },
  {
    key: 'P62',
    label: 'milligray per hour',
    Description:
      '0,001-fold of the derived SI unit gray divided by the unit hour.',
  },
  {
    key: 'P63',
    label: 'microgray per hour',
    Description:
      '0,000 001-fold of the derived SI unit gray divided by the unit hour.',
  },
  {
    key: 'P64',
    label: 'nanogray per hour',
    Description:
      '0,000 000 001-fold of the derived SI unit gray divided by the unit hour.',
  },
  {
    key: 'P65',
    label: 'sievert per second',
    Description: 'Derived SI unit sievert divided by the SI base unit second.',
  },
  {
    key: 'P66',
    label: 'millisievert per second',
    Description:
      '0,001-fold of the derived SI unit sievert divided by the SI base unit second.',
  },
  {
    key: 'P67',
    label: 'microsievert per second',
    Description:
      '0,000 001-fold of the derived SI unit sievert divided by the SI base unit second.',
  },
  {
    key: 'P68',
    label: 'nanosievert per second',
    Description:
      '0,000 000 001-fold of the derived SI unit sievert divided by the SI base unit second.',
  },
  {
    key: 'P69',
    label: 'rem per second',
    Description:
      'Unit for the equivalent tin rate relating to DIN 1301-3:1979: 1 rem/s = 0,01 J/(kg·s) = 1 Sv/s.',
  },
  {
    key: 'P70',
    label: 'sievert per hour',
    Description: 'Derived SI unit sievert divided by the unit hour.',
  },
  {
    key: 'P71',
    label: 'millisievert per hour',
    Description:
      '0,001-fold of the derived SI unit sievert divided by the unit hour.',
  },
  {
    key: 'P72',
    label: 'microsievert per hour',
    Description:
      '0,000 001-fold of the derived SI unit sievert divided by the unit hour.',
  },
  {
    key: 'P73',
    label: 'nanosievert per hour',
    Description:
      '0,000 000 001-fold of the derived SI unit sievert divided by the unit hour.',
  },
  {
    key: 'P74',
    label: 'sievert per minute',
    Description: 'Derived SI unit sievert divided by the unit minute.',
  },
  {
    key: 'P75',
    label: 'millisievert per minute',
    Description:
      '0,001-fold of the derived SI unit sievert divided by the unit minute.',
  },
  {
    key: 'P76',
    label: 'microsievert per minute',
    Description:
      '0,000 001-fold of the derived SI unit sievert divided by the unit minute.',
  },
  {
    key: 'P77',
    label: 'nanosievert per minute',
    Description:
      '0,000 000 001-fold of the derived SI unit sievert divided by the unit minute.',
  },
  {
    key: 'P78',
    label: 'reciprocal square inch',
    Description:
      'Complement of the power of the unit inch according to the Anglo-American and Imperial system of units by exponent 2.',
  },
  {
    key: 'P53',
    label: 'unit pole ',
    Description:
      'CGS (Centimetre-Gram-Second system) unit for magnetic flux of a magnetic pole (according to the interaction of identical poles of 1 dyn at a distance of a cm).',
  },
  {
    key: 'C85',
    label: 'reciprocal angstrom',
    Description: '',
  },
  {
    key: 'D94',
    label: 'second per cubic metre radian',
    Description: '',
  },
  {
    key: 'C90',
    label: 'reciprocal joule per cubic metre',
    Description: '',
  },
  {
    key: 'C88',
    label: 'reciprocal electron volt per cubic metre',
    Description: '',
  },
  {
    key: 'A38',
    label: 'cubic metre per coulomb',
    Description: '',
  },
  {
    key: 'D48',
    label: 'volt per kelvin',
    Description: '',
  },
  {
    key: 'D49',
    label: 'millivolt per kelvin',
    Description: '',
  },
  {
    key: 'A6',
    label: 'ampere per square metre kelvin squared',
    Description: '',
  },
  {
    key: '33',
    label: 'kilopascal square metre per gram',
    Description: '',
  },
  {
    key: 'P79',
    label: 'pascal square metre per kilogram',
    Description:
      'Unit of the burst index as derived unit for pressure pascal related to the substance, represented as a quotient from the SI base unit kilogram divided by the power of the SI base unit metre by exponent 2.',
  },
  {
    key: '34',
    label: 'kilopascal per millimetre',
    Description: '',
  },
  {
    key: 'H42',
    label: 'pascal per metre',
    Description: '',
  },
  {
    key: 'H69',
    label: 'picopascal per kilometre',
    Description: '',
  },
  {
    key: 'P80',
    label: 'millipascal per metre',
    Description:
      '0,001-fold of the derived SI unit pascal divided by the SI base unit metre.',
  },
  {
    key: 'P81',
    label: 'kilopascal per metre',
    Description:
      '1000-fold of the derived SI unit pascal divided by the SI base unit metre.',
  },
  {
    key: 'P82',
    label: 'hectopascal per metre',
    Description:
      '100-fold of the derived SI unit pascal divided by the SI base unit metre.',
  },
  {
    key: 'P83',
    label: 'standard atmosphere per metre',
    Description:
      'Outdated unit of the pressure divided by the SI base unit metre.',
  },
  {
    key: 'P84',
    label: 'technical atmosphere per metre',
    Description:
      'Obsolete and non-legal unit of the pressure which is generated by a 10 metre water column divided by the SI base unit metre.',
  },
  {
    key: 'P85',
    label: 'torr per metre',
    Description:
      'CGS (Centimetre-Gram-Second system) unit of the pressure divided by the SI base unit metre.',
  },
  {
    key: 'P86',
    label: 'psi per inch',
    Description:
      'Compound unit for pressure (pound-force according to the Anglo-American unit system divided by the power of the unit inch according to the Anglo-American and Imperial system of units with the exponent 2) divided by the unit inch according to the Anglo-American and Imperial system of units .',
  },
  {
    key: '35',
    label: 'millilitre per square centimetre second',
    Description: '',
  },
  {
    key: '36',
    label: 'cubic foot per minute per square foot',
    Description: 'Conversion factor required',
  },
  {
    key: 'P87',
    label: 'cubic metre per second square metre',
    Description:
      'Unit of volume flow cubic meters by second related to the transmission surface in square metres.',
  },
  {
    key: 'OPM',
    label: 'oscillations per minute',
    Description: 'The number of oscillation per minute',
  },
  {
    key: 'KNM',
    label: 'kilonewton per square metre',
    Description: '',
  },
  {
    key: 'Q35',
    label: 'megawatts per minute',
    Description:
      'A unit of power defining the total amount of bulk energy transferred or consumer per minute',
  },
  {
    key: '10',
    label: 'group',
    Description:
      'A unit of count defining the number of groups (group: set of items classified together).',
  },
  {
    key: '11',
    label: 'outfit',
    Description:
      'A unit of count defining the number of outfits (outfit: a complete set of equipment / materials / objects used for a specific purpose).',
  },
  {
    key: '13',
    label: 'ration',
    Description:
      'A unit of count defining the number of rations (ration: a single portion of provisions).',
  },
  {
    key: '14',
    label: 'shot',
    Description: 'A unit of liquid measure, especially related to spirits.',
  },
  {
    key: '15',
    label: 'stick, military',
    Description:
      'A unit of count defining the number of military sticks (military stick: bombs or paratroops released in rapid succession from an aircraft).',
  },
  {
    key: '20',
    label: 'twenty foot container',
    Description:
      'A unit of count defining the number of shipping containers that measure 20 foot in length.',
  },
  {
    key: '21',
    label: 'forty foot container',
    Description:
      'A unit of count defining the number of shipping containers that measure 40 foot in length.',
  },
  {
    key: '24',
    label: 'theoretical pound',
    Description:
      'A unit of mass defining the expected mass of material expressed as the number of pounds.',
  },
  {
    key: '27',
    label: 'theoretical ton',
    Description:
      'A unit of mass defining the expected mass of material, expressed as the number of tons.',
  },
  {
    key: '38',
    label: 'ounce per square foot per 0,01inch',
    Description: '',
  },
  {
    key: '56',
    label: 'sitas',
    Description:
      'A unit of area for tin plate equal to a surface area of 100 square metres.',
  },
  {
    key: '57',
    label: 'mesh',
    Description:
      'A unit of count defining the number of strands per inch as a measure of the fineness of a woven product.',
  },
  {
    key: '58',
    label: 'net kilogram',
    Description:
      'A unit of mass defining the total number of kilograms after deductions.',
  },
  {
    key: '59',
    label: 'part per million',
    Description: 'A unit of proportion equal to 10⁻⁶.',
  },
  {
    key: '60',
    label: 'percent weight',
    Description: 'A unit of proportion equal to 10⁻².',
  },
  {
    key: '61',
    label: 'part per billion (US)',
    Description: 'A unit of proportion equal to 10⁻⁹.',
  },
  {
    key: '64',
    label: 'pound per square inch, gauge',
    Description: '',
  },
  {
    key: '66',
    label: 'oersted',
    Description: '',
  },
  {
    key: '76',
    label: 'gauss',
    Description: '',
  },
  {
    key: '78',
    label: 'kilogauss',
    Description: '',
  },
  {
    key: '1I',
    label: 'fixed rate',
    Description:
      'A unit of quantity expressed as a predetermined or set rate for usage of a facility or service.',
  },
  {
    key: '2G',
    label: 'volt AC',
    Description:
      'A unit of electric potential in relation to alternating current (AC).',
  },
  {
    key: '2H',
    label: 'volt DC',
    Description:
      'A unit of electric potential in relation to direct current (DC).',
  },
  {
    key: '2P',
    label: 'kilobyte',
    Description: 'A unit of information equal to 10³ (1000) bytes.',
  },
  {
    key: '3C',
    label: 'manmonth',
    Description:
      'A unit of count defining the number of months for a person or persons to perform an undertaking.',
  },
  {
    key: '4L',
    label: 'megabyte',
    Description: 'A unit of information equal to 10⁶ (1000000) bytes.',
  },
  {
    key: '5B',
    label: 'batch',
    Description:
      'A unit of count defining the number of batches (batch: quantity of material produced in one operation or number of animals or persons coming at once).',
  },
  {
    key: '5E',
    label: 'MMSCF/day',
    Description:
      'A unit of volume equal to one million (1000000) cubic feet of gas per day.',
  },
  {
    key: '5J',
    label: 'hydraulic horse power',
    Description:
      'A unit of power defining the hydraulic horse power delivered by a fluid pump depending on the viscosity of the fluid.',
  },
  {
    key: 'A43',
    label: 'deadweight tonnage',
    Description:
      'A unit of mass defining the difference between the weight of a ship when completely empty and its weight when completely loaded, expressed as the number of tons.',
  },
  {
    key: 'A47',
    label: 'decitex',
    Description:
      'A unit of yarn density. One decitex equals a mass of 1 gram per 10 kilometres of length.',
  },
  {
    key: 'A49',
    label: 'denier',
    Description:
      'A unit of yarn density. One denier equals a mass of 1 gram per 9 kilometres of length.',
  },
  {
    key: 'A59',
    label: '8-part cloud cover',
    Description:
      'A unit of count defining the number of eighth-parts as a measure of the celestial dome cloud coverage.',
  },
  {
    key: 'A75',
    label: 'freight ton',
    Description:
      'A unit of information typically used for billing purposes, defined as either the number of metric tons or the number of cubic metres, whichever is the larger.',
  },
  {
    key: 'A77',
    label: 'Gaussian CGS (Centimetre-Gram-Second system) unit of displacement',
    Description: '',
  },
  {
    key: 'A78',
    label:
      'Gaussian CGS (Centimetre-Gram-Second system) unit of electric current',
    Description: '',
  },
  {
    key: 'A79',
    label:
      'Gaussian CGS (Centimetre-Gram-Second system) unit of electric charge',
    Description: '',
  },
  {
    key: 'A80',
    label:
      'Gaussian CGS (Centimetre-Gram-Second system) unit of electric field strength',
    Description: '',
  },
  {
    key: 'A81',
    label:
      'Gaussian CGS (Centimetre-Gram-Second system) unit of electric polarization',
    Description: '',
  },
  {
    key: 'A82',
    label:
      'Gaussian CGS (Centimetre-Gram-Second system) unit of electric potential',
    Description: '',
  },
  {
    key: 'A83',
    label: 'Gaussian CGS (Centimetre-Gram-Second system) unit of magnetization',
    Description: '',
  },
  {
    key: 'A9',
    label: 'rate',
    Description:
      'A unit of quantity expressed as a rate for usage of a facility or service.',
  },
  {
    key: 'A99',
    label: 'bit',
    Description: 'A unit of information equal to one binary digit.',
  },
  {
    key: 'AA',
    label: 'ball',
    Description:
      'A unit of count defining the number of balls (ball: object formed in the shape of sphere).',
  },
  {
    key: 'AB',
    label: 'bulk pack',
    Description: 'A unit of count defining the number of items per bulk pack.',
  },
  {
    key: 'ACT',
    label: 'activity',
    Description:
      'A unit of count defining the number of activities (activity: a unit of work or action).',
  },
  {
    key: 'AD',
    label: 'byte',
    Description: 'A unit of information equal to 8 bits.',
  },
  {
    key: 'AH',
    label: 'additional minute',
    Description:
      'A unit of time defining the number of minutes in addition to the referenced minutes.',
  },
  {
    key: 'AI',
    label: 'average minute per call',
    Description:
      'A unit of count defining the number of minutes for the average interval of a call.',
  },
  {
    key: 'AL',
    label: 'access line',
    Description:
      'A unit of count defining the number of telephone access lines.',
  },
  {
    key: 'AQ',
    label: 'anti-hemophilic factor (AHF) unit',
    Description: 'A unit of measure for blood potency (US).',
  },
  {
    key: 'AS',
    label: 'assortment',
    Description:
      'A unit of count defining the number of assortments (assortment: set of items grouped in a mixed collection).',
  },
  {
    key: 'ASM',
    label: 'alcoholic strength by mass',
    Description: 'A unit of mass defining the alcoholic strength of a liquid.',
  },
  {
    key: 'ASU',
    label: 'alcoholic strength by volume',
    Description:
      'A unit of volume defining the alcoholic strength of a liquid (e.g. spirit, wine, beer, etc), often at a specific temperature.',
  },
  {
    key: 'AY',
    label: 'assembly',
    Description:
      'A unit of count defining the number of assemblies (assembly: items that consist of component parts).',
  },
  {
    key: 'B1',
    label: 'barrel (US) per day',
    Description: '',
  },
  {
    key: 'B10',
    label: 'bit per second',
    Description: 'A unit of information equal to one binary digit per second.',
  },
  {
    key: 'B17',
    label: 'credit',
    Description:
      'A unit of count defining the number of entries made to the credit side of an account.',
  },
  {
    key: 'B19',
    label: 'digit',
    Description:
      'A unit of information defining the quantity of numerals used to form a number.',
  },
  {
    key: 'B3',
    label: 'batting pound',
    Description:
      'A unit of mass defining the number of pounds of wadded fibre.',
  },
  {
    key: 'B30',
    label: 'gibibit',
    Description: 'A unit of information equal to 2³⁰ bits (binary digits).',
  },
  {
    key: 'B4',
    label: 'barrel, imperial',
    Description:
      'A unit of volume used to measure beer.  One beer barrel equals 36 imperial gallons.',
  },
  {
    key: 'B65',
    label: 'maxwell',
    Description: '',
  },
  {
    key: 'B68',
    label: 'gigabit',
    Description: 'A unit of information equal to 10⁹ bits (binary digits).',
  },
  {
    key: 'B7',
    label: 'cycle',
    Description:
      'A unit of count defining the number of cycles (cycle: a recurrent period of definite duration).',
  },
  {
    key: 'B80',
    label: 'gigabit per second',
    Description:
      'A unit of information equal to 10⁹ bits (binary digits) per second.',
  },
  {
    key: 'B82',
    label: 'inch per linear foot',
    Description:
      'A unit of length defining the number of inches per linear foot.',
  },
  {
    key: 'BB',
    label: 'base box',
    Description:
      'A unit of area of 112 sheets of tin mil products (tin plate, tin free steel or black plate) 14 by 20 inches, or 31,360 square inches.',
  },
  {
    key: 'BFT',
    label: 'board foot',
    Description:
      'A unit of volume defining the number of cords (cord: a stack of firewood of 128 cubic feet).',
  },
  {
    key: 'BIL',
    label: 'billion (EUR)',
    Description: 'Synonym: trillion (US)',
  },
  {
    key: 'BP',
    label: 'hundred board foot',
    Description: 'A unit of volume equal to one hundred board foot.',
  },
  {
    key: 'BPM',
    label: 'beats per minute',
    Description: 'The number of beats per minute.',
  },
  {
    key: 'C0',
    label: 'call',
    Description:
      'A unit of count defining the number of calls (call: communication session or visitation).',
  },
  {
    key: 'C21',
    label: 'kibibit',
    Description:
      'A unit of information equal to 2¹⁰ (1024) bits (binary digits).',
  },
  {
    key: 'C37',
    label: 'kilobit',
    Description:
      'A unit of information equal to 10³ (1000) bits (binary digits).',
  },
  {
    key: 'C74',
    label: 'kilobit per second',
    Description:
      'A unit of information equal to 10³ (1000) bits (binary digits) per second.',
  },
  {
    key: 'C79',
    label: 'kilovolt ampere hour',
    Description:
      'A unit of accumulated energy of 1000 volt amperes over a period of one hour.',
  },
  {
    key: 'C9',
    label: 'coil group',
    Description:
      'A unit of count defining the number of coil groups (coil group: groups of items arranged by lengths of those items placed in a joined sequence of concentric circles).',
  },
  {
    key: 'CCT',
    label: 'carrying capacity in metric ton',
    Description:
      'A unit of mass defining the carrying capacity, expressed as the number of metric tons.',
  },
  {
    key: 'CEN',
    label: 'hundred',
    Description:
      'A unit of count defining the number of units in multiples of 100.',
  },
  {
    key: 'CG',
    label: 'card',
    Description:
      'A unit of count defining the number of units of card (card: thick stiff paper or cardboard).',
  },
  {
    key: 'CLF',
    label: 'hundred leave',
    Description:
      'A unit of count defining the number of leaves, expressed in units of one hundred leaves.',
  },
  {
    key: 'CNP',
    label: 'hundred pack',
    Description:
      'A unit of count defining the number of hundred-packs (hundred-pack: set of one hundred items packaged together).',
  },
  {
    key: 'CNT',
    label: 'cental (UK)',
    Description: 'A unit of mass equal to one hundred weight (US).',
  },
  {
    key: 'CTG',
    label: 'content gram',
    Description:
      'A unit of mass defining the number of grams of a named item in a product.',
  },
  {
    key: 'CTM',
    label: 'metric carat',
    Description: '',
  },
  {
    key: 'CTN',
    label: 'content ton (metric)',
    Description:
      'A unit of mass defining the number of metric tons of a named item in a product.',
  },
  {
    key: 'D03',
    label: 'kilowatt hour per hour',
    Description:
      'A unit of accumulated energy of a thousand watts over a period of one hour.',
  },
  {
    key: 'D04',
    label: 'lot [unit of weight]',
    Description: 'A unit of weight equal to about 1/2 ounce or 15 grams.',
  },
  {
    key: 'D11',
    label: 'mebibit',
    Description:
      'A unit of information equal to 2²⁰ (1048576) bits (binary digits).',
  },
  {
    key: 'D23',
    label: 'pen gram (protein)',
    Description:
      'A unit of count defining the number of grams of amino acid prescribed for parenteral/enteral therapy.',
  },
  {
    key: 'D34',
    label: 'tex',
    Description:
      'A unit of yarn density. One decitex equals a mass of 1 gram per 1 kilometre of length.',
  },
  {
    key: 'D36',
    label: 'megabit',
    Description:
      'A unit of information equal to 10⁶ (1000000) bits (binary digits).',
  },
  {
    key: 'D63',
    label: 'book',
    Description:
      'A unit of count defining the number of books (book: set of items bound together or written document of a material whole).',
  },
  {
    key: 'D65',
    label: 'round',
    Description:
      'A unit of count defining the number of rounds (round: A circular or cylindrical object).',
  },
  {
    key: 'D68',
    label: 'number of words',
    Description: 'A unit of count defining the number of words.',
  },
  {
    key: 'D78',
    label: 'megajoule per second',
    Description:
      'A unit of accumulated energy equal to one million joules per second.',
  },
  {
    key: 'DAD',
    label: 'ten day',
    Description:
      'A unit of time defining the number of days in multiples of 10.',
  },
  {
    key: 'DB',
    label: 'dry pound',
    Description:
      'A unit of mass defining the number of pounds of a product, disregarding the water content of the product.',
  },
  {
    key: 'DEC',
    label: 'decade',
    Description:
      'A unit of count defining the number of decades (decade: quantity equal to 10 or time equal to 10 years).',
  },
  {
    key: 'DMO',
    label: 'standard kilolitre',
    Description:
      'A unit of volume defining the number of kilolitres of a product at a temperature of 15 degrees Celsius, especially in relation to hydrocarbon oils.',
  },
  {
    key: 'DPC',
    label: 'dozen piece',
    Description:
      'A unit of count defining the number of pieces in multiples of 12 (piece: a single item, article or exemplar).',
  },
  {
    key: 'DPR',
    label: 'dozen pair',
    Description:
      "A unit of count defining the number of pairs in multiples of 12 (pair: item described by two's).",
  },
  {
    key: 'DPT',
    label: 'displacement tonnage',
    Description:
      'A unit of mass defining the volume of sea water a ship displaces, expressed as the number of tons.',
  },
  {
    key: 'DRA',
    label: 'dram (US)',
    Description: 'Synonym: drachm (UK), troy dram',
  },
  {
    key: 'DRI',
    label: 'dram (UK)',
    Description: 'Synonym: avoirdupois dram',
  },
  {
    key: 'DRL',
    label: 'dozen roll',
    Description:
      'A unit of count defining the number of rolls, expressed in twelve roll units.',
  },
  {
    key: 'DT',
    label: 'dry ton',
    Description:
      'A unit of mass defining the number of tons of a product, disregarding the water content of the product.',
  },
  {
    key: 'DWT',
    label: 'pennyweight',
    Description: '',
  },
  {
    key: 'DZN',
    label: 'dozen',
    Description:
      'A unit of count defining the number of units in multiples of 12.',
  },
  {
    key: 'DZP',
    label: 'dozen pack',
    Description:
      'A unit of count defining the number of packs in multiples of 12 (pack: standard packaging unit).',
  },
  {
    key: 'E07',
    label: 'megawatt hour per hour',
    Description:
      'A unit of accumulated energy of a million watts over a period of one hour.',
  },
  {
    key: 'E08',
    label: 'megawatt per hertz',
    Description:
      'A unit of energy expressed as the load change in million watts that will cause a frequency shift of one hertz.',
  },
  {
    key: 'E10',
    label: 'degree day',
    Description:
      'A unit of measure used in meteorology and engineering to measure the demand for heating or cooling over a given period of days.',
  },
  {
    key: 'E11',
    label: 'gigacalorie',
    Description:
      'A unit of heat energy equal to one thousand million calories.',
  },
  {
    key: 'E12',
    label: 'mille',
    Description:
      'A unit of count defining the number of cigarettes in units of 1000.',
  },
  {
    key: 'E16',
    label: 'million Btu(IT) per hour',
    Description:
      'A unit of power equal to one million British thermal units per hour.',
  },
  {
    key: 'E17',
    label: 'cubic foot per second',
    Description:
      'A unit of volume equal to one cubic foot passing a given point in a period of one second.',
  },
  {
    key: 'E19',
    label: 'ping',
    Description: 'A unit of area equal to 3.3 square metres.',
  },
  {
    key: 'E20',
    label: 'megabit per second',
    Description:
      'A unit of information equal to 10⁶ (1000000) bits (binary digits) per second.',
  },
  {
    key: 'E21',
    label: 'shares',
    Description:
      'A unit of count defining the number of shares (share: a total or portion of the parts into which a business entity’s capital is divided).',
  },
  {
    key: 'E22',
    label: 'TEU',
    Description:
      'A unit of count defining the number of twenty-foot equivalent units (TEUs) as a measure of containerized cargo capacity.',
  },
  {
    key: 'E23',
    label: 'tyre',
    Description:
      'A unit of count defining the number of tyres (a solid or air-filled covering placed around a wheel rim to form a soft contact with the road, absorb shock and provide traction).',
  },
  {
    key: 'E25',
    label: 'active unit',
    Description:
      'A unit of count defining the number of active units within a substance.',
  },
  {
    key: 'E27',
    label: 'dose',
    Description:
      'A unit of count defining the number of doses (dose: a definite quantity of a medicine or drug).',
  },
  {
    key: 'E28',
    label: 'air dry ton',
    Description:
      'A unit of mass defining the number of tons of a product, disregarding the water content of the product.',
  },
  {
    key: 'E30',
    label: 'strand',
    Description:
      'A unit of count defining the number of strands (strand: long, thin, flexible, single thread, strip of fibre, constituent filament or multiples of the same, twisted together).',
  },
  {
    key: 'E31',
    label: 'square metre per litre',
    Description:
      'A unit of count defining the number of square metres per litre.',
  },
  {
    key: 'E32',
    label: 'litre per hour',
    Description: 'A unit of count defining the number of litres per hour.',
  },
  {
    key: 'E33',
    label: 'foot per thousand',
    Description:
      'A unit of count defining the number of feet per thousand units.',
  },
  {
    key: 'E34',
    label: 'gigabyte',
    Description: 'A unit of information equal to 10⁹ bytes.',
  },
  {
    key: 'E35',
    label: 'terabyte',
    Description: 'A unit of information equal to 10¹² bytes.',
  },
  {
    key: 'E36',
    label: 'petabyte',
    Description: 'A unit of information equal to 10¹⁵ bytes.',
  },
  {
    key: 'E37',
    label: 'pixel',
    Description:
      'A unit of count defining the number of pixels (pixel: picture element).',
  },
  {
    key: 'E38',
    label: 'megapixel',
    Description:
      'A unit of count equal to 10⁶ (1000000) pixels (picture elements).',
  },
  {
    key: 'E39',
    label: 'dots per inch',
    Description:
      'A unit of information defining the number of dots per linear inch as a measure of the resolution or sharpness of a graphic image.',
  },
  {
    key: 'E4',
    label: 'gross kilogram',
    Description:
      'A unit of mass defining the total number of kilograms before deductions.',
  },
  {
    key: 'E40',
    label: 'part per hundred thousand',
    Description: 'A unit of proportion equal to 10⁻⁵.',
  },
  {
    key: 'E44',
    label: 'kilogram-force metre per square centimetre',
    Description:
      'A unit of torsion defining the torque kilogram-force metre per square centimetre.',
  },
  {
    key: 'E46',
    label: 'kilowatt hour per cubic metre',
    Description:
      'A unit of energy consumption expressed as kilowatt hour per cubic metre.',
  },
  {
    key: 'E47',
    label: 'kilowatt hour per kelvin',
    Description:
      'A unit of energy consumption expressed as kilowatt hour per kelvin.',
  },
  {
    key: 'E48',
    label: 'service unit',
    Description:
      'A unit of count defining the number of service units (service unit: defined period / property / facility / utility of supply).',
  },
  {
    key: 'E49',
    label: 'working day',
    Description:
      'A unit of count defining the number of working days (working day: a day on which work is ordinarily performed).',
  },
  {
    key: 'E50',
    label: 'accounting unit',
    Description: 'A unit of count defining the number of accounting units.',
  },
  {
    key: 'E51',
    label: 'job',
    Description: 'A unit of count defining the number of jobs.',
  },
  {
    key: 'E52',
    label: 'run foot',
    Description: 'A unit of count defining the number feet per run.',
  },
  {
    key: 'E53',
    label: 'test',
    Description: 'A unit of count defining the number of tests.',
  },
  {
    key: 'E54',
    label: 'trip',
    Description: 'A unit of count defining the number of trips.',
  },
  {
    key: 'E55',
    label: 'use',
    Description:
      'A unit of count defining the number of times an object is used.',
  },
  {
    key: 'E56',
    label: 'well',
    Description: 'A unit of count defining the number of wells.',
  },
  {
    key: 'E57',
    label: 'zone',
    Description: 'A unit of count defining the number of zones.',
  },
  {
    key: 'E58',
    label: 'exabit per second',
    Description:
      'A unit of information equal to 10¹⁸ bits (binary digits) per second.',
  },
  {
    key: 'E59',
    label: 'exbibyte',
    Description: 'A unit of information equal to 2⁶⁰ bytes.',
  },
  {
    key: 'E60',
    label: 'pebibyte',
    Description: 'A unit of information equal to 2⁵⁰ bytes.',
  },
  {
    key: 'E61',
    label: 'tebibyte',
    Description: 'A unit of information equal to 2⁴⁰ bytes.',
  },
  {
    key: 'E62',
    label: 'gibibyte',
    Description: 'A unit of information equal to 2³⁰ bytes.',
  },
  {
    key: 'E63',
    label: 'mebibyte',
    Description: 'A unit of information equal to 2²⁰ bytes.',
  },
  {
    key: 'E64',
    label: 'kibibyte',
    Description: 'A unit of information equal to 2¹⁰ bytes.',
  },
  {
    key: 'E65',
    label: 'exbibit per metre',
    Description:
      'A unit of information equal to 2⁶⁰ bits (binary digits) per metre.',
  },
  {
    key: 'E66',
    label: 'exbibit per square metre',
    Description:
      'A unit of information equal to 2⁶⁰ bits (binary digits) per square metre.',
  },
  {
    key: 'E67',
    label: 'exbibit per cubic metre',
    Description:
      'A unit of information equal to 2⁶⁰ bits (binary digits) per cubic metre.',
  },
  {
    key: 'E68',
    label: 'gigabyte per second',
    Description: 'A unit of information equal to 10⁹ bytes per second.',
  },
  {
    key: 'E69',
    label: 'gibibit per metre',
    Description:
      'A unit of information equal to 2³⁰ bits (binary digits) per metre.',
  },
  {
    key: 'E70',
    label: 'gibibit per square metre',
    Description:
      'A unit of information equal to 2³⁰ bits (binary digits) per square metre.',
  },
  {
    key: 'E71',
    label: 'gibibit per cubic metre',
    Description:
      'A unit of information equal to 2³⁰ bits (binary digits) per cubic metre.',
  },
  {
    key: 'E72',
    label: 'kibibit per metre',
    Description:
      'A unit of information equal to 2¹⁰ bits (binary digits) per metre.',
  },
  {
    key: 'E73',
    label: 'kibibit per square metre',
    Description:
      'A unit of information equal to 2¹⁰ bits (binary digits) per square metre.',
  },
  {
    key: 'E74',
    label: 'kibibit per cubic metre',
    Description:
      'A unit of information equal to 2¹⁰ bits (binary digits) per cubic metre.',
  },
  {
    key: 'E75',
    label: 'mebibit per metre',
    Description:
      'A unit of information equal to 2²⁰ bits (binary digits) per metre.',
  },
  {
    key: 'E76',
    label: 'mebibit per square metre',
    Description:
      'A unit of information equal to 2²⁰ bits (binary digits) per square metre.',
  },
  {
    key: 'E77',
    label: 'mebibit per cubic metre',
    Description:
      'A unit of information equal to 2²⁰ bits (binary digits) per cubic metre.',
  },
  {
    key: 'E78',
    label: 'petabit',
    Description: 'A unit of information equal to 10¹⁵ bits (binary digits).',
  },
  {
    key: 'E79',
    label: 'petabit per second',
    Description:
      'A unit of information equal to 10¹⁵ bits (binary digits) per second.',
  },
  {
    key: 'E80',
    label: 'pebibit per metre',
    Description:
      'A unit of information equal to 2⁵⁰ bits (binary digits) per metre.',
  },
  {
    key: 'E81',
    label: 'pebibit per square metre',
    Description:
      'A unit of information equal to 2⁵⁰ bits (binary digits) per square metre.',
  },
  {
    key: 'E82',
    label: 'pebibit per cubic metre',
    Description:
      'A unit of information equal to 2⁵⁰ bits (binary digits) per cubic metre.',
  },
  {
    key: 'E83',
    label: 'terabit',
    Description: 'A unit of information equal to 10¹² bits (binary digits).',
  },
  {
    key: 'E84',
    label: 'terabit per second',
    Description:
      'A unit of information equal to 10¹² bits (binary digits) per second.',
  },
  {
    key: 'E85',
    label: 'tebibit per metre',
    Description:
      'A unit of information equal to 2⁴⁰ bits (binary digits) per metre.',
  },
  {
    key: 'E86',
    label: 'tebibit per cubic metre',
    Description:
      'A unit of information equal to 2⁴⁰ bits (binary digits) per cubic metre.',
  },
  {
    key: 'E87',
    label: 'tebibit per square metre',
    Description:
      'A unit of information equal to 2⁴⁰ bits (binary digits) per square metre.',
  },
  {
    key: 'E88',
    label: 'bit per metre',
    Description:
      'A unit of information equal to 1 bit (binary digit) per metre.',
  },
  {
    key: 'E89',
    label: 'bit per square metre',
    Description:
      'A unit of information equal to 1 bit (binary digit) per square metre.',
  },
  {
    key: 'E90',
    label: 'reciprocal centimetre',
    Description: '',
  },
  {
    key: 'E91',
    label: 'reciprocal day',
    Description: '',
  },
  {
    key: 'EA',
    label: 'each',
    Description:
      'A unit of count defining the number of items regarded as separate units.',
  },
  {
    key: 'EB',
    label: 'electronic mail box',
    Description:
      'A unit of count defining the number of electronic mail boxes.',
  },
  {
    key: 'EQ',
    label: 'equivalent gallon',
    Description:
      'A unit of volume defining the number of gallons of product produced from concentrate.',
  },
  {
    key: 'F01',
    label: 'bit per cubic metre',
    Description:
      'A unit of information equal to 1 bit (binary digit) per cubic metre.',
  },
  {
    key: 'FBM',
    label: 'fibre metre',
    Description:
      'A unit of length defining the number of metres of individual fibre.',
  },
  {
    key: 'FC',
    label: 'thousand cubic foot',
    Description: 'A unit of volume equal to one thousand cubic foot.',
  },
  {
    key: 'FF',
    label: 'hundred cubic metre',
    Description: 'A unit of volume equal to one hundred cubic metres.',
  },
  {
    key: 'FIT',
    label: 'failures in time',
    Description:
      'A unit of count defining the number of failures that can be expected over a specified time interval. Failure rates of semiconductor components are often specified as FIT (failures in time unit) where 1 FIT = 10⁻⁹ /h.',
  },
  {
    key: 'FL',
    label: 'flake ton',
    Description:
      'A unit of mass defining the number of tons of a flaked substance (flake: a small flattish fragment).',
  },
  {
    key: 'GB',
    label: 'gallon (US) per day',
    Description: '',
  },
  {
    key: 'GDW',
    label: 'gram, dry weight',
    Description:
      'A unit of mass defining the number of grams of a product, disregarding the water content of the product.',
  },
  {
    key: 'GFI',
    label: 'gram of fissile isotope',
    Description:
      'A unit of mass defining the number of grams of a fissile isotope (fissile isotope: an isotope whose nucleus is able to be split when irradiated with low energy neutrons).',
  },
  {
    key: 'GGR',
    label: 'great gross',
    Description:
      'A unit of count defining the number of units in multiples of 1728 (12 x 12 x 12).',
  },
  {
    key: 'GIA',
    label: 'gill (US)',
    Description: '',
  },
  {
    key: 'GIC',
    label: 'gram, including container',
    Description:
      'A unit of mass defining the number of grams of a product, including its container.',
  },
  {
    key: 'GII',
    label: 'gill (UK)',
    Description: '',
  },
  {
    key: 'GIP',
    label: 'gram, including inner packaging',
    Description:
      'A unit of mass defining the number of grams of a product, including its inner packaging materials.',
  },
  {
    key: 'GRO',
    label: 'gross',
    Description:
      'A unit of count defining the number of units in multiples of 144 (12 x 12).',
  },
  {
    key: 'GRT',
    label: 'gross register ton',
    Description:
      'A unit of mass equal to the total cubic footage before deductions, where 1 register ton is equal to 100 cubic feet. Refer International Convention on tonnage measurement of ships.',
  },
  {
    key: 'GT',
    label: 'gross ton',
    Description:
      'A unit of mass equal to 2240 pounds. Refer International Convention on Tonnage measurement of Ships.',
  },
  {
    key: 'H21',
    label: 'blank',
    Description: 'A unit of count defining the number of blanks.',
  },
  {
    key: 'H25',
    label: 'percent per kelvin',
    Description:
      'A unit of proportion, equal to 0.01, in relation to the SI base unit Kelvin.',
  },
  {
    key: 'H71',
    label: 'percent per month',
    Description: 'A unit of proportion, equal to 0.01, in relation to a month.',
  },
  {
    key: 'H72',
    label: 'percent per hectobar',
    Description:
      'A unit of proportion, equal to 0.01, in relation to 100-fold of the unit bar.',
  },
  {
    key: 'H73',
    label: 'percent per decakelvin',
    Description:
      'A unit of proportion, equal to 0.01, in relation to 10-fold of the SI base unit Kelvin.',
  },
  {
    key: 'H77',
    label: 'module width',
    Description:
      'A unit of measure used to describe the breadth of electronic assemblies as an installation standard or mounting dimension.',
  },
  {
    key: 'H80',
    label: 'rack unit',
    Description:
      'A unit of measure used to describe the height in rack units of equipment intended for mounting in a 19-inch rack or a 23-inch rack. One rack unit is 1.75 inches (44.45 mm) high.',
  },
  {
    key: 'H82',
    label: 'big point',
    Description:
      'A unit of length defining the number of big points (big point: Adobe software(US) defines the big point to be exactly 1/72 inch (0.013 888 9 inch or 0.352 777 8 millimeters))',
  },
  {
    key: 'H87',
    label: 'piece',
    Description:
      'A unit of count defining the number of pieces (piece: a single item, article or exemplar).',
  },
  {
    key: 'H89',
    label: 'percent per ohm',
    Description:
      'A unit of proportion, equal to 0.01, in relation to the SI derived unit ohm.',
  },
  {
    key: 'H90',
    label: 'percent per degree',
    Description:
      'A unit of proportion, equal to 0.01, in relation to an angle of one degree.',
  },
  {
    key: 'H91',
    label: 'percent per ten thousand',
    Description:
      'A unit of proportion, equal to 0.01, in relation to multiples of ten thousand.',
  },
  {
    key: 'H92',
    label: 'percent per one hundred thousand',
    Description:
      'A unit of proportion, equal to 0.01, in relation to multiples of one hundred thousand.',
  },
  {
    key: 'H93',
    label: 'percent per hundred',
    Description:
      'A unit of proportion, equal to 0.01, in relation to multiples of one hundred.',
  },
  {
    key: 'H94',
    label: 'percent per thousand',
    Description:
      'A unit of proportion, equal to 0.01, in relation to multiples of one thousand.',
  },
  {
    key: 'H95',
    label: 'percent per volt',
    Description:
      'A unit of proportion, equal to 0.01, in relation to the SI derived unit volt.',
  },
  {
    key: 'H96',
    label: 'percent per bar',
    Description:
      'A unit of proportion, equal to 0.01, in relation to an atmospheric pressure of one bar.',
  },
  {
    key: 'H98',
    label: 'percent per inch',
    Description: 'A unit of proportion, equal to 0.01, in relation to an inch.',
  },
  {
    key: 'H99',
    label: 'percent per metre',
    Description: 'A unit of proportion, equal to 0.01, in relation to a metre.',
  },
  {
    key: 'HA',
    label: 'hank',
    Description: 'A unit of length, typically for yarn.',
  },
  {
    key: 'HBX',
    label: 'hundred boxes',
    Description:
      'A unit of count defining the number of boxes in multiples of one hundred box units.',
  },
  {
    key: 'HC',
    label: 'hundred count',
    Description:
      'A unit of count defining the number of units counted in multiples of 100.',
  },
  {
    key: 'HDW',
    label: 'hundred kilogram, dry weight',
    Description:
      'A unit of mass defining the number of hundred kilograms of a product, disregarding the water content of the product.',
  },
  {
    key: 'HEA',
    label: 'head',
    Description:
      'A unit of count defining the number of heads (head: a person or animal considered as one of a number).',
  },
  {
    key: 'HH',
    label: 'hundred cubic foot',
    Description: 'A unit of volume equal to one hundred cubic foot.',
  },
  {
    key: 'HIU',
    label: 'hundred international unit',
    Description:
      'A unit of count defining the number of international units in multiples of 100.',
  },
  {
    key: 'HKM',
    label: 'hundred kilogram, net mass',
    Description:
      'A unit of mass defining the number of hundred kilograms of a product, after deductions.',
  },
  {
    key: 'HMQ',
    label: 'million cubic metre',
    Description: 'A unit of volume equal to one million cubic metres.',
  },
  {
    key: 'HPA',
    label: 'hectolitre of pure alcohol',
    Description:
      'A unit of volume equal to one hundred litres of pure alcohol.',
  },
  {
    key: 'IE',
    label: 'person',
    Description: 'A unit of count defining the number of persons.',
  },
  {
    key: 'ISD',
    label: 'international sugar degree',
    Description:
      'A unit of measure defining the sugar content of a solution, expressed in degrees.',
  },
  {
    key: 'IUG',
    label: 'international unit per gram',
    Description:
      'A unit of count defining the number of international units per gram.',
  },
  {
    key: 'J10',
    label: 'percent per millimetre',
    Description:
      'A unit of proportion, equal to 0.01, in relation to a millimetre.',
  },
  {
    key: 'J12',
    label: 'per mille per psi',
    Description:
      'A unit of pressure equal to one thousandth of a psi (pound-force per square inch).',
  },
  {
    key: 'J13',
    label: 'degree API',
    Description:
      'A unit of relative density as a measure of how heavy or light a petroleum liquid is compared to water (API: American Petroleum Institute).',
  },
  {
    key: 'J14',
    label: 'degree Baume (origin scale)',
    Description:
      'A traditional unit of relative density for liquids. Named after Antoine Baumé.',
  },
  {
    key: 'J15',
    label: 'degree Baume (US heavy)',
    Description: 'A unit of relative density for liquids heavier than water.',
  },
  {
    key: 'J16',
    label: 'degree Baume (US light)',
    Description: 'A unit of relative density for liquids lighter than water.',
  },
  {
    key: 'J17',
    label: 'degree Balling',
    Description:
      'A unit of density as a measure of sugar content, especially of beer wort. Named after Karl Balling.',
  },
  {
    key: 'J18',
    label: 'degree Brix',
    Description:
      'A unit of proportion used in measuring the dissolved sugar-to-water mass ratio of a liquid. Named after Adolf Brix.',
  },
  {
    key: 'J27',
    label: 'degree Oechsle',
    Description:
      'A unit of density as a measure of sugar content of must, the unfermented liqueur from which wine is made. Named after Ferdinand Oechsle.',
  },
  {
    key: 'J31',
    label: 'degree Twaddell',
    Description:
      'A unit of density for liquids that are heavier than water.  1 degree Twaddle represents a difference in specific gravity of 0.005.',
  },
  {
    key: 'J38',
    label: 'baud',
    Description:
      'A unit of signal transmission speed equal to one signalling event per second.',
  },
  {
    key: 'J54',
    label: 'megabaud',
    Description:
      'A unit of signal transmission speed equal to 10⁶ (1000000) signaling events per second.',
  },
  {
    key: 'JNT',
    label: 'pipeline joint',
    Description: 'A count of the number of pipeline joints.',
  },
  {
    key: 'JPS',
    label: 'hundred metre',
    Description: 'A unit of count defining the number of 100 metre lengths.',
  },
  {
    key: 'JWL',
    label: 'number of jewels',
    Description:
      'A unit of count defining the number of jewels (jewel: precious stone).',
  },
  {
    key: 'K1',
    label: 'kilowatt demand',
    Description:
      'A unit of measure defining the power load measured at predetermined intervals.',
  },
  {
    key: 'K2',
    label: 'kilovolt ampere reactive demand',
    Description:
      'A unit of measure defining the reactive power demand equal to one kilovolt ampere of reactive power.',
  },
  {
    key: 'K3',
    label: 'kilovolt ampere reactive hour',
    Description:
      'A unit of measure defining the accumulated reactive energy equal to one kilovolt ampere of reactive power per hour.',
  },
  {
    key: 'K50',
    label: 'kilobaud',
    Description:
      'A unit of signal transmission speed equal to 10³ (1000) signaling events per second.',
  },
  {
    key: 'KA',
    label: 'cake',
    Description:
      'A unit of count defining the number of cakes (cake: object shaped into a flat, compact mass).',
  },
  {
    key: 'KB',
    label: 'kilocharacter',
    Description: 'A unit of information equal to 10³ (1000) characters.',
  },
  {
    key: 'KCC',
    label: 'kilogram of choline chloride',
    Description:
      'A unit of mass equal to one thousand grams of choline chloride.',
  },
  {
    key: 'KDW',
    label: 'kilogram drained net weight',
    Description:
      'A unit of mass defining the net number of kilograms of a product, disregarding the liquid content of the product.',
  },
  {
    key: 'KHY',
    label: 'kilogram of hydrogen peroxide',
    Description:
      'A unit of mass equal to one thousand grams of hydrogen peroxide.',
  },
  {
    key: 'KI',
    label: 'kilogram per millimetre width',
    Description: '',
  },
  {
    key: 'KIC',
    label: 'kilogram, including container',
    Description:
      'A unit of mass defining the number of kilograms of a product, including its container.',
  },
  {
    key: 'KIP',
    label: 'kilogram, including inner packaging',
    Description:
      'A unit of mass defining the number of kilograms of a product, including its inner packaging materials.',
  },
  {
    key: 'KJ',
    label: 'kilosegment',
    Description: 'A unit of information equal to 10³ (1000) segments.',
  },
  {
    key: 'KLK',
    label: 'lactic dry material percentage',
    Description:
      'A unit of proportion defining the percentage of dry lactic material in a product.',
  },
  {
    key: 'KMA',
    label: 'kilogram of methylamine',
    Description: 'A unit of mass equal to one thousand grams of methylamine.',
  },
  {
    key: 'KNI',
    label: 'kilogram of nitrogen',
    Description: 'A unit of mass equal to one thousand grams of nitrogen.',
  },
  {
    key: 'KNS',
    label: 'kilogram named substance',
    Description: 'A unit of mass equal to one kilogram of a named substance.',
  },
  {
    key: 'KO',
    label: 'milliequivalence caustic potash per gram of product',
    Description:
      'A unit of count defining the number of milligrams of potassium hydroxide per gram of product as a measure of the concentration of potassium hydroxide in the product.',
  },
  {
    key: 'KPH',
    label: 'kilogram of potassium hydroxide (caustic potash)',
    Description:
      'A unit of mass equal to one thousand grams of potassium hydroxide (caustic potash).',
  },
  {
    key: 'KPO',
    label: 'kilogram of potassium oxide',
    Description:
      'A unit of mass equal to one thousand grams of potassium oxide.',
  },
  {
    key: 'KPP',
    label: 'kilogram of phosphorus pentoxide (phosphoric anhydride)',
    Description:
      'A unit of mass equal to one thousand grams of phosphorus pentoxide phosphoric anhydride.',
  },
  {
    key: 'KSD',
    label: 'kilogram of substance 90 % dry',
    Description:
      'A unit of mass equal to one thousand grams of a named substance that is 90% dry.',
  },
  {
    key: 'KSH',
    label: 'kilogram of sodium hydroxide (caustic soda)',
    Description:
      'A unit of mass equal to one thousand grams of sodium hydroxide (caustic soda).',
  },
  {
    key: 'KT',
    label: 'kit',
    Description:
      'A unit of count defining the number of kits (kit: tub, barrel or pail).',
  },
  {
    key: 'KUR',
    label: 'kilogram of uranium',
    Description: 'A unit of mass equal to one thousand grams of uranium.',
  },
  {
    key: 'KWY',
    label: 'kilowatt year',
    Description: 'killowatt year',
  },
  {
    key: 'KWO',
    label: 'kilogram of tungsten trioxide',
    Description:
      'A unit of mass equal to one thousand grams of tungsten trioxide.',
  },
  {
    key: 'LAC',
    label: 'lactose excess percentage',
    Description:
      'A unit of proportion defining the percentage of lactose in a product that exceeds a defined percentage level.',
  },
  {
    key: 'LBT',
    label: 'troy pound (US)',
    Description: '',
  },
  {
    key: 'LEF',
    label: 'leaf',
    Description: 'A unit of count defining the number of leaves.',
  },
  {
    key: 'LF',
    label: 'linear foot',
    Description:
      'A unit of count defining the number of feet (12-inch) in length of a uniform width object.',
  },
  {
    key: 'LH',
    label: 'labour hour',
    Description: 'A unit of time defining the number of labour hours.',
  },
  {
    key: 'LK',
    label: 'link',
    Description: 'A unit of distance equal to 0.01 chain.',
  },
  {
    key: 'LM',
    label: 'linear metre',
    Description:
      'A unit of count defining the number of metres in length of a uniform width object.',
  },
  {
    key: 'LN',
    label: 'length',
    Description:
      'A unit of distance defining the linear extent of an item measured from end to end.',
  },
  {
    key: 'LO',
    label: 'lot [unit of procurement]',
    Description:
      'A unit of count defining the number of lots (lot: a collection of associated items).',
  },
  {
    key: 'LP',
    label: 'liquid pound',
    Description:
      'A unit of mass defining the number of pounds of a liquid substance.',
  },
  {
    key: 'LPA',
    label: 'litre of pure alcohol',
    Description: 'A unit of volume equal to one litre of pure alcohol.',
  },
  {
    key: 'LR',
    label: 'layer',
    Description: 'A unit of count defining the number of layers.',
  },
  {
    key: 'LS',
    label: 'lump sum',
    Description:
      'A unit of count defining the number of whole or a complete monetary amounts.',
  },
  {
    key: 'LUB',
    label: 'metric ton, lubricating oil',
    Description:
      'A unit of mass defining the number of metric tons of lubricating oil.',
  },
  {
    key: 'LY',
    label: 'linear yard',
    Description:
      'A unit of count defining the number of 36-inch units in length of a uniform width object.',
  },
  {
    key: 'M19',
    label: 'Beaufort',
    Description:
      'An empirical measure for describing wind speed based mainly on observed sea conditions. The Beaufort scale indicates the wind speed by numbers that typically range from 0 for calm, to 12 for hurricane.',
  },
  {
    key: 'M25',
    label: 'percent per degree Celsius',
    Description:
      'A unit of proportion, equal to 0.01, in relation to a temperature of one degree.',
  },
  {
    key: 'M36',
    label: '30-day month',
    Description:
      'A unit of count defining the number of months expressed in multiples of 30 days, one day equals 24 hours.',
  },
  {
    key: 'M37',
    label: 'actual/360',
    Description:
      'A unit of count defining the number of years expressed in multiples of 360 days, one day equals 24 hours.',
  },
  {
    key: 'M4',
    label: 'monetary value',
    Description: 'A unit of measure expressed as a monetary amount.',
  },
  {
    key: 'M9',
    label: 'million Btu per 1000 cubic foot',
    Description: '',
  },
  {
    key: 'MAH',
    label: 'megavolt ampere reactive hour',
    Description:
      'A unit of electrical reactive power defining the total amount of reactive power across a power system.',
  },
  {
    key: 'MBE',
    label: 'thousand standard brick equivalent',
    Description:
      'A unit of count defining the number of one thousand brick equivalent units.',
  },
  {
    key: 'MBF',
    label: 'thousand board foot',
    Description: 'A unit of volume equal to one thousand board foot.',
  },
  {
    key: 'MD',
    label: 'air dry metric ton',
    Description:
      'A unit of count defining the number of metric tons of a product, disregarding the water content of the product.',
  },
  {
    key: 'MIL',
    label: 'thousand',
    Description: '',
  },
  {
    key: 'MIO',
    label: 'million',
    Description: '',
  },
  {
    key: 'MIU',
    label: 'million international unit',
    Description:
      'A unit of count defining the number of international units in multiples of 10⁶.',
  },
  {
    key: 'MLD',
    label: 'milliard',
    Description: 'Synonym: billion (US)',
  },
  {
    key: 'MND',
    label: 'kilogram, dry weight',
    Description:
      'A unit of mass defining the number of kilograms of a product, disregarding the water content of the product.',
  },
  {
    key: 'N1',
    label: 'pen calorie',
    Description:
      'A unit of count defining the number of calories prescribed daily for parenteral/enteral therapy.',
  },
  {
    key: 'N3',
    label: 'print point',
    Description: '',
  },
  {
    key: 'NAR',
    label: 'number of articles',
    Description:
      'A unit of count defining the number of articles (article: item).',
  },
  {
    key: 'NCL',
    label: 'number of cells',
    Description:
      'A unit of count defining the number of cells (cell: an enclosed or circumscribed space, cavity, or volume).',
  },
  {
    key: 'NF',
    label: 'message',
    Description: 'A unit of count defining the number of messages.',
  },
  {
    key: 'NIL',
    label: 'nil',
    Description: 'A unit of count defining the number of instances of nothing.',
  },
  {
    key: 'NIU',
    label: 'number of international units',
    Description: 'A unit of count defining the number of international units.',
  },
  {
    key: 'NL',
    label: 'load',
    Description:
      'A unit of volume defining the number of loads (load: a quantity of items carried or processed at one time).',
  },
  {
    key: 'NMP',
    label: 'number of packs',
    Description:
      'A unit of count defining the number of packs (pack: a collection of objects packaged together).',
  },
  {
    key: 'NPR',
    label: 'number of pairs',
    Description:
      "A unit of count defining the number of pairs (pair: item described by two's).",
  },
  {
    key: 'NPT',
    label: 'number of parts',
    Description:
      'A unit of count defining the number of parts (part: component of a larger entity).',
  },
  {
    key: 'NT',
    label: 'net ton',
    Description:
      'A unit of mass equal to 2000 pounds, see ton (US).  Refer International Convention on tonnage measurement of Ships.',
  },
  {
    key: 'NTT',
    label: 'net register ton',
    Description:
      'A unit of mass equal to the total cubic footage after deductions, where 1 register ton is equal to 100 cubic feet. Refer International Convention on tonnage measurement of Ships.',
  },
  {
    key: 'NX',
    label: 'part per thousand',
    Description: 'A unit of proportion equal to 10⁻³.',
  },
  {
    key: 'OA',
    label: 'panel',
    Description:
      'A unit of count defining the number of panels (panel: a distinct, usually rectangular, section of a surface).',
  },
  {
    key: 'ODE',
    label: 'ozone depletion equivalent',
    Description:
      'A unit of mass defining the ozone depletion potential in kilograms of a product relative to the calculated depletion for the reference substance, Trichlorofluoromethane (CFC-11).',
  },
  {
    key: 'ODG',
    label: 'ODS Grams',
    Description:
      'A unit of measure calculated by multiplying the mass of the substance in grams and the ozone-depleting potential for the substance.',
  },
  {
    key: 'ODK',
    label: 'ODS Kilograms',
    Description:
      'A unit of measure calculated by multiplying the mass of the substance in kilograms and the ozone-depleting potential for the substance.',
  },
  {
    key: 'ODM',
    label: 'ODS Milligrams',
    Description:
      'A unit of measure calculated by multiplying the mass of the substance in milligrams and the ozone-depleting potential for the substance.',
  },
  {
    key: 'OT',
    label: 'overtime hour',
    Description: 'A unit of time defining the number of overtime hours.',
  },
  {
    key: 'OZ',
    label: 'ounce av',
    Description:
      'A unit of measure equal to 1/16 of a pound or about 28.3495 grams (av = avoirdupois). Use ounce (common code ONZ).',
  },
  {
    key: 'P1',
    label: 'percent',
    Description: 'A unit of proportion equal to 0.01.',
  },
  {
    key: 'P5',
    label: 'five pack',
    Description:
      'A unit of count defining the number of five-packs (five-pack: set of five items packaged together).',
  },
  {
    key: 'P88',
    label: 'rhe',
    Description: 'Non SI-conforming unit of fluidity of dynamic viscosity.',
  },
  {
    key: 'P89',
    label: 'pound-force foot per inch',
    Description:
      'Unit for length-related rotational moment according to the Anglo-American and Imperial system of units.',
  },
  {
    key: 'P90',
    label: 'pound-force inch per inch',
    Description:
      'Unit for length-related rotational moment according to the Anglo-American and Imperial system of units.',
  },
  {
    key: 'P91',
    label: 'perm (0 ºC)',
    Description:
      'Traditional unit for the ability of a material to allow the transition of the steam, defined at a temperature of 0 °C as steam transmittance, where the mass of one grain steam penetrates an area of one foot squared at a pressure from one inch mercury per hour.',
  },
  {
    key: 'P92',
    label: 'perm (23 ºC)',
    Description:
      'Traditional unit for the ability of a material to allow the transition of the steam, defined at a temperature of 23 °C as steam transmittance at which the mass of one grain of steam penetrates an area of one square foot at a pressure of one inch mercury per hour.',
  },
  {
    key: 'P93',
    label: 'byte per second',
    Description: 'Unit byte divided by the SI base unit second.',
  },
  {
    key: 'P94',
    label: 'kilobyte per second',
    Description:
      '1000-fold of the unit byte divided by the SI base unit second.',
  },
  {
    key: 'P95',
    label: 'megabyte per second',
    Description:
      '1 000 000-fold of the unit byte divided by the SI base unit second.',
  },
  {
    key: 'P96',
    label: 'reciprocal volt',
    Description: 'Reciprocal of the derived SI unit volt.',
  },
  {
    key: 'P97',
    label: 'reciprocal radian',
    Description: 'Reciprocal of the unit radian.',
  },
  {
    key: 'P98',
    label: 'pascal to the power sum of stoichiometric numbers',
    Description:
      'Unit of the equilibrium constant on the basis of the pressure(ISO 80000-9:2009, 9-35.a).',
  },
  {
    key: 'P99',
    label: 'mole per cubiv metre to the power sum of stoichiometric numbers',
    Description:
      'Unit of the equilibrium constant on the basis of the concentration (ISO 80000-9:2009, 9-36.a).',
  },
  {
    key: 'PD',
    label: 'pad',
    Description:
      'A unit of count defining the number of pads (pad: block of paper sheets fastened together at one end).',
  },
  {
    key: 'PFL',
    label: 'proof litre',
    Description:
      'A unit of volume equal to one litre of proof spirits, or the alcohol equivalent thereof. Used for measuring the strength of distilled alcoholic liquors, expressed as a percentage of the alcohol content of a standard mixture at a specific temperature.',
  },
  {
    key: 'PGL',
    label: 'proof gallon',
    Description:
      'A unit of volume equal to one gallon of proof spirits, or the alcohol equivalent thereof. Used for measuring the strength of distilled alcoholic liquors, expressed as a percentage of the alcohol content of a standard mixture at a specific temperature.',
  },
  {
    key: 'PI',
    label: 'pitch',
    Description:
      'A unit of count defining the number of characters that fit in a horizontal inch.',
  },
  {
    key: 'PLA',
    label: 'degree Plato',
    Description:
      'A unit of proportion defining the sugar content of a product, especially in relation to beer.',
  },
  {
    key: 'PQ',
    label: 'page per inch',
    Description:
      'A unit of quantity defining the degree of thickness of a bound publication, expressed as the number of pages per inch of thickness.',
  },
  {
    key: 'PR',
    label: 'pair',
    Description:
      "A unit of count defining the number of pairs (pair: item described by two's).",
  },
  {
    key: 'PTN',
    label: 'portion',
    Description:
      'A quantity of allowance of food allotted to, or enough for, one person.',
  },
  {
    key: 'Q10',
    label: 'joule per tesla',
    Description:
      'Unit of the magnetic dipole moment of the molecule as derived SI unit joule divided by the derived SI unit tesla.',
  },
  {
    key: 'Q11',
    label: 'erlang',
    Description:
      'Unit of the market value according to the feature of a single feature as a statistical measurement of the existing utilization.',
  },
  {
    key: 'Q12',
    label: 'octet',
    Description: 'Synonym for byte: 1 octet = 8 bit = 1 byte.',
  },
  {
    key: 'Q13',
    label: 'octet per second',
    Description: 'Unit octet divided by the SI base unit second.',
  },
  {
    key: 'Q14',
    label: 'shannon',
    Description:
      'Logarithmic unit for information equal to the content of decision of a sentence of two mutually exclusive events, expressed as a logarithm to base 2.',
  },
  {
    key: 'Q15',
    label: 'hartley',
    Description:
      'Logarithmic unit for information equal to the content of decision of a sentence of ten mutually exclusive events, expressed as a logarithm to base 10.',
  },
  {
    key: 'Q16',
    label: 'natural unit of information',
    Description:
      'Logarithmic unit for information equal to the content of decision of a sentence of ,718 281 828 459 mutually exclusive events, expressed as a logarithm to base Euler value e.',
  },
  {
    key: 'Q17',
    label: 'shannon per second',
    Description:
      'Time related logarithmic unit for information equal to the content of decision of a sentence of two mutually exclusive events, expressed as a logarithm to base 2.',
  },
  {
    key: 'Q18',
    label: 'hartley per second',
    Description:
      'Time related logarithmic unit for information equal to the content of decision of a sentence of ten mutually exclusive events, expressed as a logarithm to base 10.',
  },
  {
    key: 'Q19',
    label: 'natural unit of information per second',
    Description:
      'Time related logarithmic unit for information equal to the content of decision of a sentence of 2,718 281 828 459 mutually exclusive events, expressed as a logarithm to base of the Euler value e.',
  },
  {
    key: 'Q20',
    label: 'second per kilogramm',
    Description:
      'Unit of the Einstein transition probability for spontaneous or inducing emissions and absorption according to ISO 80000-7:2008, expressed as SI base unit second divided by the SI base unit kilogram.',
  },
  {
    key: 'Q21',
    label: 'watt square metre',
    Description:
      'Unit of the first radiation constants c1 = 2·p·h·c0², the value of which is 3,741 771 18·10?¹6-fold   that of the comparative value of the product of the derived SI unit watt multiplied with the power of the SI base unit metre with the exponent 2.',
  },
  {
    key: 'Q22',
    label: 'second per radian cubic metre',
    Description:
      'Unit of the density of states as an expression of angular frequency as complement of the product of hertz and radiant and the power of SI base unit metre by exponent 3 .',
  },
  {
    key: 'Q23',
    label: 'weber to the power minus one',
    Description:
      'Complement of the derived SI unit weber as unit of the Josephson constant, which value is equal to the 384 597,891-fold of the reference value gigahertz divided by volt.',
  },
  {
    key: 'Q24',
    label: 'reciprocal inch',
    Description:
      'Complement of the unit inch according to the Anglo-American and Imperial system of units.',
  },
  {
    key: 'Q25',
    label: 'dioptre',
    Description:
      'Unit used at the statement of relative refractive indexes of optical systems as complement of the focal length with correspondence to: 1 dpt = 1/m.',
  },
  {
    key: 'Q26',
    label: 'one per one',
    Description:
      'Value of the quotient from two physical units of the same kind as a numerator and denominator whereas the units are shortened mutually.',
  },
  {
    key: 'Q27',
    label: 'newton metre per metre',
    Description:
      'Unit for length-related rotational moment as product of the derived SI unit newton and the SI base unit metre divided by the SI base unit metre.',
  },
  {
    key: 'Q28',
    label: 'kilogram per square metre pascal second',
    Description:
      'Unit for the ability of a material to allow the transition of steam.',
  },
  {
    key: 'Q36',
    label: 'square metre per cubic metre',
    Description:
      'A unit of the amount of surface area per unit volume of an object or collection of objects.',
  },
  {
    key: 'Q3',
    label: 'meal',
    Description:
      'A unit of count defining the number of meals (meal: an amount of food to be eaten on a single occasion).',
  },
  {
    key: 'QA',
    label: 'page - facsimile',
    Description: 'A unit of count defining the number of facsimile pages.',
  },
  {
    key: 'QAN',
    label: 'quarter (of a year)',
    Description: 'A unit of time defining the number of quarters (3 months).',
  },
  {
    key: 'QB',
    label: 'page - hardcopy',
    Description:
      'A unit of count defining the number of hardcopy pages (hardcopy page: a page rendered as printed or written output on paper, film, or other permanent medium).',
  },
  {
    key: 'QR',
    label: 'quire',
    Description:
      'A unit of count for paper, expressed as the number of quires (quire: a number of paper sheets, typically 25).',
  },
  {
    key: 'QTR',
    label: 'quarter (UK)',
    Description:
      'A traditional unit of weight equal to 1/4 hundredweight. In the United Kingdom, one quarter equals 28 pounds.',
  },
  {
    key: 'R1',
    label: 'pica',
    Description:
      'A unit of count defining the number of picas. (pica: typographical length equal to 12 points or 4.22 mm (approx.)).',
  },
  {
    key: 'R9',
    label: 'thousand cubic metre',
    Description: 'A unit of volume equal to one thousand cubic metres.',
  },
  {
    key: 'RH',
    label: 'running or operating hour',
    Description: 'A unit of time defining the number of hours of operation.',
  },
  {
    key: 'RM',
    label: 'ream',
    Description:
      'A unit of count for paper, expressed as the number of reams (ream: a large quantity of paper sheets, typically 500).',
  },
  {
    key: 'ROM',
    label: 'room',
    Description: 'A unit of count defining the number of rooms.',
  },
  {
    key: 'RP',
    label: 'pound per ream',
    Description:
      'A unit of mass for paper, expressed as pounds per ream. (ream: a large quantity of paper, typically 500 sheets).',
  },
  {
    key: 'RT',
    label: 'revenue ton mile',
    Description:
      'A unit of information typically used for billing purposes, expressed as the number of revenue tons (revenue ton: either a metric ton or a cubic metres, whichever is the larger), moved over a distance of one mile.',
  },
  {
    key: 'SAN',
    label: 'half year (6 months)',
    Description: 'A unit of time defining the number of half years (6 months).',
  },
  {
    key: 'SCO',
    label: 'score',
    Description:
      'A unit of count defining the number of units in multiples of 20.',
  },
  {
    key: 'SCR',
    label: 'scruple',
    Description: '',
  },
  {
    key: 'SET',
    label: 'set',
    Description:
      'A unit of count defining the number of sets (set: a number of objects grouped together).',
  },
  {
    key: 'SG',
    label: 'segment',
    Description: 'A unit of information equal to 64000 bytes.',
  },
  {
    key: 'SHT',
    label: 'shipping ton',
    Description: 'A unit of mass defining the number of tons for shipping.',
  },
  {
    key: 'SQ',
    label: 'square',
    Description:
      'A unit of count defining the number of squares (square: rectangular shape).',
  },
  {
    key: 'SQR',
    label: 'square, roofing',
    Description:
      'A unit of count defining the number of squares of roofing materials, measured in multiples of 100 square feet.',
  },
  {
    key: 'SR',
    label: 'strip',
    Description:
      'A unit of count defining the number of strips (strip: long narrow piece of an object).',
  },
  {
    key: 'STC',
    label: 'stick',
    Description:
      'A unit of count defining the number of sticks (stick: slender and often cylindrical piece of a substance).',
  },
  {
    key: 'STK',
    label: 'stick, cigarette',
    Description:
      'A unit of count defining the number of cigarettes in the smallest unit for stock-taking and/or duty computation.',
  },
  {
    key: 'STL',
    label: 'standard litre',
    Description:
      'A unit of volume defining the number of litres of a product at a temperature of 15 degrees Celsius, especially in relation to hydrocarbon oils.',
  },
  {
    key: 'STW',
    label: 'straw',
    Description:
      'A unit of count defining the number of straws (straw: a slender tube used for sucking up liquids).',
  },
  {
    key: 'SW',
    label: 'skein',
    Description:
      'A unit of count defining the number of skeins (skein: a loosely-coiled bundle of yarn or thread).',
  },
  {
    key: 'SX',
    label: 'shipment',
    Description:
      'A unit of count defining the number of shipments (shipment: an amount of goods shipped or transported).',
  },
  {
    key: 'SYR',
    label: 'syringe',
    Description:
      'A unit of count defining the number of syringes (syringe: a small device for pumping, spraying and/or injecting liquids through a small aperture).',
  },
  {
    key: 'T0',
    label: 'telecommunication line in service',
    Description: 'A unit of count defining the number of lines in service.',
  },
  {
    key: 'T3',
    label: 'thousand piece',
    Description:
      'A unit of count defining the number of pieces in multiples of 1000 (piece: a single item, article or exemplar).',
  },
  {
    key: 'TAN',
    label: 'total acid number',
    Description:
      'A unit of chemistry defining the amount of potassium hydroxide (KOH) in milligrams that is needed to neutralize the acids in one gram of oil. It is an important quality measurement of crude oil.',
  },
  {
    key: 'TI',
    label: 'thousand square inch',
    Description: '',
  },
  {
    key: 'TIC',
    label: 'metric ton, including container',
    Description:
      'A unit of mass defining the number of metric tons of a product, including its container.',
  },
  {
    key: 'TIP',
    label: 'metric ton, including inner packaging',
    Description:
      'A unit of mass defining the number of metric tons of a product, including its inner packaging materials.',
  },
  {
    key: 'TKM',
    label: 'tonne kilometre',
    Description:
      'A unit of information typically used for billing purposes, expressed as the number of tonnes (metric tons) moved over a distance of one kilometre. ',
  },
  {
    key: 'TMS',
    label: 'kilogram of imported meat, less offal',
    Description:
      'A unit of mass equal to one thousand grams of imported meat, disregarding less valuable by-products such as the entrails.',
  },
  {
    key: 'TP',
    label: 'ten pack',
    Description:
      'A unit of count defining the number of items in multiples of 10.',
  },
  {
    key: 'TPI',
    label: 'teeth per inch',
    Description: 'The number of teeth per inch.',
  },
  {
    key: 'TPR',
    label: 'ten pair',
    Description:
      "A unit of count defining the number of pairs in multiples of 10 (pair: item described by two's).",
  },
  {
    key: 'TQD',
    label: 'thousand cubic metre per day',
    Description: 'A unit of volume equal to one thousand cubic metres per day.',
  },
  {
    key: 'TRL',
    label: 'trillion (EUR)',
    Description: '',
  },
  {
    key: 'TST',
    label: 'ten set',
    Description:
      'A unit of count defining the number of sets in multiples of 10 (set: a number of objects grouped together).',
  },
  {
    key: 'TTS',
    label: 'ten thousand sticks',
    Description:
      'A unit of count defining the number of sticks in multiples of 10000 (stick: slender and often cylindrical piece of a substance).',
  },
  {
    key: 'U1',
    label: 'treatment',
    Description:
      'A unit of count defining the number of treatments (treatment: subjection to the action of a chemical, physical or biological agent).',
  },
  {
    key: 'U2',
    label: 'tablet',
    Description:
      'A unit of count defining the number of tablets (tablet: a small flat or compressed solid object).',
  },
  {
    key: 'UB',
    label: 'telecommunication line in service average',
    Description:
      'A unit of count defining the average number of lines in service.',
  },
  {
    key: 'UC',
    label: 'telecommunication port',
    Description: 'A unit of count defining the number of network access ports.',
  },
  {
    key: 'VA',
    label: 'volt - ampere per kilogram',
    Description: '',
  },
  {
    key: 'VP',
    label: 'percent volume',
    Description:
      'A measure of concentration, typically expressed as the percentage volume of a solute in a solution.',
  },
  {
    key: 'W2',
    label: 'wet kilo',
    Description:
      'A unit of mass defining the number of kilograms of a product, including the water content of the product.',
  },
  {
    key: 'WA',
    label: 'watt per kilogram',
    Description: '',
  },
  {
    key: 'WB',
    label: 'wet pound',
    Description:
      'A unit of mass defining the number of pounds of a material, including the water content of the material.',
  },
  {
    key: 'WCD',
    label: 'cord',
    Description:
      'A unit of volume used for measuring lumber. One board foot equals 1/12 of a cubic foot.',
  },
  {
    key: 'WE',
    label: 'wet ton',
    Description:
      'A unit of mass defining the number of tons of a material, including the water content of the material.',
  },
  {
    key: 'WG',
    label: 'wine gallon',
    Description: 'A unit of volume equal to 231 cubic inches.',
  },
  {
    key: 'WM',
    label: 'working month',
    Description: 'A unit of time defining the number of working months.',
  },
  {
    key: 'WSD',
    label: 'standard',
    Description: 'A unit of volume of finished lumber equal to 165 cubic feet.',
  },
  {
    key: 'WW',
    label: 'millilitre of water',
    Description:
      'A unit of volume equal to the number of millilitres of water.',
  },
  {
    key: 'Z11',
    label: 'hanging container',
    Description: 'A unit of count defining the number of hanging containers.',
  },
  {
    key: 'ZP',
    label: 'page',
    Description: 'A unit of count defining the number of pages.',
  },
  {
    key: 'ZZ',
    label: 'mutually defined',
    Description:
      'A unit of measure as agreed in common between two or more parties.',
  },
  {
    key: 'MRW',
    label: 'Metre Week',
    Description:
      'Unit for measuring physical dimensions and time, as required by DIN 18451',
  },
  {
    key: 'MKW',
    label: 'Square Metre Week',
    Description:
      'Unit for measuring physical dimensions and time as required by DIN 18451',
  },
  {
    key: 'MQW',
    label: 'Cubic Metre Week',
    Description:
      'Unit for measuring physical dimensions and time as required by DIN 18451',
  },
  {
    key: 'HWE',
    label: 'Piece Week',
    Description:
      'Unit for measuring the item amount and time as required by DIN 18451',
  },
  {
    key: 'MRD',
    label: 'Metre Day',
    Description:
      'Unit for measuring physical dimensions and time as required by DIN 18451',
  },
  {
    key: 'MKD',
    label: 'Square Metre Day',
    Description:
      'Unit for measuring physical dimensions and time as required by DIN 18451',
  },
  {
    key: 'MQD',
    label: 'Cubic Metre Day',
    Description:
      'Unit for measuring physical dimensions and time as required by DIN 18451',
  },
  {
    key: 'HAD',
    label: 'Piece Day',
    Description:
      'Unit for measuring the item amount and time as required by DIN 18451',
  },
  {
    key: 'MRM',
    label: 'Metre Month',
    Description:
      'Unit for measuring physical dimensions and time as required by DIN 18451',
  },
  {
    key: 'MKM',
    label: 'Square Metre Month',
    Description:
      'Unit for measuring physical dimensions and time as required by DIN 18451',
  },
  {
    key: 'MQM',
    label: 'Cubic Metre Month',
    Description:
      'Unit for measuring physical dimensions and time as required by DIN 18451',
  },
  {
    key: 'HMO',
    label: 'Piece Month',
    Description:
      'Unit for measuring the item amount and time as required by DIN 18451',
  },
  {
    key: 'DBW',
    label: 'Decibel watt',
    Description:
      'The decibel watt or dBW is a unit for the measurement of the strength of a signal expressed in decibels relative to one watt.',
  },
  {
    key: 'DBM',
    label: 'Decibel-milliwatts',
    Description:
      'dBm (sometimes dBmW or decibel-milliwatts) is unit of level used to indicate that a power ratio is expressed in decibels (dB) with reference to one milliwatt (mW).',
  },
  {
    key: 'FNU',
    label: 'Formazin nephelometric unit',
    Description:
      'Formazin nephelometric unit (FNU) is used for water turbidity level evaluation',
  },
  {
    key: 'NTU',
    label: 'Nephelometric turbidity unit',
    Description:
      'Nephelometric turbidity unit (NTU) is used for water turbidity level evaluation',
  },
]
